// （ 全国 ）省 市 县三級区域列表
export const region_list = [
  {
    label: "北京市",
    code: "110000",
    children: [
      {
        label: "北京市",
        code: "110100",
        children: [
          { label: "东城区", code: "110101", level: "district" },
          { label: "西城区", code: "110102", level: "district" },
          { label: "朝阳区", code: "110105", level: "district" },
          { label: "丰台区", code: "110106", level: "district" },
          { label: "石景山区", code: "110107", level: "district" },
          { label: "海淀区", code: "110108", level: "district" },
          { label: "门头沟区", code: "110109", level: "district" },
          { label: "房山区", code: "110111", level: "district" },
          { label: "通州区", code: "110112", level: "district" },
          { label: "顺义区", code: "110113", level: "district" },
          { label: "昌平区", code: "110114", level: "district" },
          { label: "大兴区", code: "110115", level: "district" },
          { label: "怀柔区", code: "110116", level: "district" },
          { label: "平谷区", code: "110117", level: "district" },
          { label: "密云区", code: "110118", level: "district" },
          { label: "延庆区", code: "110119", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "天津市",
    code: "120000",
    children: [
      {
        label: "天津市",
        code: "120100",
        children: [
          { label: "和平区", code: "120101", level: "district" },
          { label: "河东区", code: "120102", level: "district" },
          { label: "河西区", code: "120103", level: "district" },
          { label: "南开区", code: "120104", level: "district" },
          { label: "河北区", code: "120105", level: "district" },
          { label: "红桥区", code: "120106", level: "district" },
          { label: "东丽区", code: "120110", level: "district" },
          { label: "西青区", code: "120111", level: "district" },
          { label: "津南区", code: "120112", level: "district" },
          { label: "北辰区", code: "120113", level: "district" },
          { label: "武清区", code: "120114", level: "district" },
          { label: "宝坻区", code: "120115", level: "district" },
          { label: "滨海新区", code: "120116", level: "district" },
          { label: "宁河区", code: "120117", level: "district" },
          { label: "静海区", code: "120118", level: "district" },
          { label: "蓟州区", code: "120119", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "河北省",
    code: "130000",
    children: [
      {
        label: "石家庄市",
        code: "130100",
        children: [
          { label: "长安区", code: "130102", level: "district" },
          { label: "桥西区", code: "130104", level: "district" },
          { label: "新华区", code: "130105", level: "district" },
          { label: "井陉矿区", code: "130107", level: "district" },
          { label: "裕华区", code: "130108", level: "district" },
          { label: "藁城区", code: "130109", level: "district" },
          { label: "鹿泉区", code: "130110", level: "district" },
          { label: "栾城区", code: "130111", level: "district" },
          { label: "井陉县", code: "130121", level: "district" },
          { label: "正定县", code: "130123", level: "district" },
          { label: "行唐县", code: "130125", level: "district" },
          { label: "灵寿县", code: "130126", level: "district" },
          { label: "高邑县", code: "130127", level: "district" },
          { label: "深泽县", code: "130128", level: "district" },
          { label: "赞皇县", code: "130129", level: "district" },
          { label: "无极县", code: "130130", level: "district" },
          { label: "平山县", code: "130131", level: "district" },
          { label: "元氏县", code: "130132", level: "district" },
          { label: "赵县", code: "130133", level: "district" },
          { label: "辛集市", code: "130181", level: "district" },
          { label: "晋州市", code: "130183", level: "district" },
          { label: "新乐市", code: "130184", level: "district" }
        ],
        level: "city"
      },
      {
        label: "唐山市",
        code: "130200",
        children: [
          { label: "路南区", code: "130202", level: "district" },
          { label: "路北区", code: "130203", level: "district" },
          { label: "古冶区", code: "130204", level: "district" },
          { label: "开平区", code: "130205", level: "district" },
          { label: "丰南区", code: "130207", level: "district" },
          { label: "丰润区", code: "130208", level: "district" },
          { label: "曹妃甸区", code: "130209", level: "district" },
          { label: "滦南县", code: "130224", level: "district" },
          { label: "乐亭县", code: "130225", level: "district" },
          { label: "迁西县", code: "130227", level: "district" },
          { label: "玉田县", code: "130229", level: "district" },
          { label: "遵化市", code: "130281", level: "district" },
          { label: "迁安市", code: "130283", level: "district" },
          { label: "滦州市", code: "130284", level: "district" }
        ],
        level: "city"
      },
      {
        label: "秦皇岛市",
        code: "130300",
        children: [
          { label: "海港区", code: "130302", level: "district" },
          { label: "山海关区", code: "130303", level: "district" },
          { label: "北戴河区", code: "130304", level: "district" },
          { label: "抚宁区", code: "130306", level: "district" },
          { label: "青龙满族自治县", code: "130321", level: "district" },
          { label: "昌黎县", code: "130322", level: "district" },
          { label: "卢龙县", code: "130324", level: "district" }
        ],
        level: "city"
      },
      {
        label: "邯郸市",
        code: "130400",
        children: [
          { label: "邯山区", code: "130402", level: "district" },
          { label: "丛台区", code: "130403", level: "district" },
          { label: "复兴区", code: "130404", level: "district" },
          { label: "峰峰矿区", code: "130406", level: "district" },
          { label: "肥乡区", code: "130407", level: "district" },
          { label: "永年区", code: "130408", level: "district" },
          { label: "临漳县", code: "130423", level: "district" },
          { label: "成安县", code: "130424", level: "district" },
          { label: "大名县", code: "130425", level: "district" },
          { label: "涉县", code: "130426", level: "district" },
          { label: "磁县", code: "130427", level: "district" },
          { label: "邱县", code: "130430", level: "district" },
          { label: "鸡泽县", code: "130431", level: "district" },
          { label: "广平县", code: "130432", level: "district" },
          { label: "馆陶县", code: "130433", level: "district" },
          { label: "魏县", code: "130434", level: "district" },
          { label: "曲周县", code: "130435", level: "district" },
          { label: "武安市", code: "130481", level: "district" }
        ],
        level: "city"
      },
      {
        label: "邢台市",
        code: "130500",
        children: [
          { label: "襄都区", code: "130502", level: "district" },
          { label: "信都区", code: "130503", level: "district" },
          { label: "任泽区", code: "130505", level: "district" },
          { label: "南和区", code: "130506", level: "district" },
          { label: "临城县", code: "130522", level: "district" },
          { label: "内丘县", code: "130523", level: "district" },
          { label: "柏乡县", code: "130524", level: "district" },
          { label: "隆尧县", code: "130525", level: "district" },
          { label: "宁晋县", code: "130528", level: "district" },
          { label: "巨鹿县", code: "130529", level: "district" },
          { label: "新河县", code: "130530", level: "district" },
          { label: "广宗县", code: "130531", level: "district" },
          { label: "平乡县", code: "130532", level: "district" },
          { label: "威县", code: "130533", level: "district" },
          { label: "清河县", code: "130534", level: "district" },
          { label: "临西县", code: "130535", level: "district" },
          { label: "南宫市", code: "130581", level: "district" },
          { label: "沙河市", code: "130582", level: "district" }
        ],
        level: "city"
      },
      {
        label: "保定市",
        code: "130600",
        children: [
          { label: "竞秀区", code: "130602", level: "district" },
          { label: "莲池区", code: "130606", level: "district" },
          { label: "满城区", code: "130607", level: "district" },
          { label: "清苑区", code: "130608", level: "district" },
          { label: "徐水区", code: "130609", level: "district" },
          { label: "涞水县", code: "130623", level: "district" },
          { label: "阜平县", code: "130624", level: "district" },
          { label: "定兴县", code: "130626", level: "district" },
          { label: "唐县", code: "130627", level: "district" },
          { label: "高阳县", code: "130628", level: "district" },
          { label: "容城县", code: "130629", level: "district" },
          { label: "涞源县", code: "130630", level: "district" },
          { label: "望都县", code: "130631", level: "district" },
          { label: "安新县", code: "130632", level: "district" },
          { label: "易县", code: "130633", level: "district" },
          { label: "曲阳县", code: "130634", level: "district" },
          { label: "蠡县", code: "130635", level: "district" },
          { label: "顺平县", code: "130636", level: "district" },
          { label: "博野县", code: "130637", level: "district" },
          { label: "雄县", code: "130638", level: "district" },
          { label: "涿州市", code: "130681", level: "district" },
          { label: "定州市", code: "130682", level: "district" },
          { label: "安国市", code: "130683", level: "district" },
          { label: "高碑店市", code: "130684", level: "district" }
        ],
        level: "city"
      },
      {
        label: "张家口市",
        code: "130700",
        children: [
          { label: "桥东区", code: "130702", level: "district" },
          { label: "桥西区", code: "130703", level: "district" },
          { label: "宣化区", code: "130705", level: "district" },
          { label: "下花园区", code: "130706", level: "district" },
          { label: "万全区", code: "130708", level: "district" },
          { label: "崇礼区", code: "130709", level: "district" },
          { label: "张北县", code: "130722", level: "district" },
          { label: "康保县", code: "130723", level: "district" },
          { label: "沽源县", code: "130724", level: "district" },
          { label: "尚义县", code: "130725", level: "district" },
          { label: "蔚县", code: "130726", level: "district" },
          { label: "阳原县", code: "130727", level: "district" },
          { label: "怀安县", code: "130728", level: "district" },
          { label: "怀来县", code: "130730", level: "district" },
          { label: "涿鹿县", code: "130731", level: "district" },
          { label: "赤城县", code: "130732", level: "district" }
        ],
        level: "city"
      },
      {
        label: "承德市",
        code: "130800",
        children: [
          { label: "双桥区", code: "130802", level: "district" },
          { label: "双滦区", code: "130803", level: "district" },
          { label: "鹰手营子矿区", code: "130804", level: "district" },
          { label: "承德县", code: "130821", level: "district" },
          { label: "兴隆县", code: "130822", level: "district" },
          { label: "滦平县", code: "130824", level: "district" },
          { label: "隆化县", code: "130825", level: "district" },
          { label: "丰宁满族自治县", code: "130826", level: "district" },
          { label: "宽城满族自治县", code: "130827", level: "district" },
          { label: "围场满族蒙古族自治县", code: "130828", level: "district" },
          { label: "平泉市", code: "130881", level: "district" }
        ],
        level: "city"
      },
      {
        label: "沧州市",
        code: "130900",
        children: [
          { label: "新华区", code: "130902", level: "district" },
          { label: "运河区", code: "130903", level: "district" },
          { label: "沧县", code: "130921", level: "district" },
          { label: "青县", code: "130922", level: "district" },
          { label: "东光县", code: "130923", level: "district" },
          { label: "海兴县", code: "130924", level: "district" },
          { label: "盐山县", code: "130925", level: "district" },
          { label: "肃宁县", code: "130926", level: "district" },
          { label: "南皮县", code: "130927", level: "district" },
          { label: "吴桥县", code: "130928", level: "district" },
          { label: "献县", code: "130929", level: "district" },
          { label: "孟村回族自治县", code: "130930", level: "district" },
          { label: "泊头市", code: "130981", level: "district" },
          { label: "任丘市", code: "130982", level: "district" },
          { label: "黄骅市", code: "130983", level: "district" },
          { label: "河间市", code: "130984", level: "district" }
        ],
        level: "city"
      },
      {
        label: "廊坊市",
        code: "131000",
        children: [
          { label: "安次区", code: "131002", level: "district" },
          { label: "广阳区", code: "131003", level: "district" },
          { label: "固安县", code: "131022", level: "district" },
          { label: "永清县", code: "131023", level: "district" },
          { label: "香河县", code: "131024", level: "district" },
          { label: "大城县", code: "131025", level: "district" },
          { label: "文安县", code: "131026", level: "district" },
          { label: "大厂回族自治县", code: "131028", level: "district" },
          { label: "霸州市", code: "131081", level: "district" },
          { label: "三河市", code: "131082", level: "district" }
        ],
        level: "city"
      },
      {
        label: "衡水市",
        code: "131100",
        children: [
          { label: "桃城区", code: "131102", level: "district" },
          { label: "冀州区", code: "131103", level: "district" },
          { label: "枣强县", code: "131121", level: "district" },
          { label: "武邑县", code: "131122", level: "district" },
          { label: "武强县", code: "131123", level: "district" },
          { label: "饶阳县", code: "131124", level: "district" },
          { label: "安平县", code: "131125", level: "district" },
          { label: "故城县", code: "131126", level: "district" },
          { label: "景县", code: "131127", level: "district" },
          { label: "阜城县", code: "131128", level: "district" },
          { label: "深州市", code: "131182", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "山西省",
    code: "140000",
    children: [
      {
        label: "太原市",
        code: "140100",
        children: [
          { label: "小店区", code: "140105", level: "district" },
          { label: "迎泽区", code: "140106", level: "district" },
          { label: "杏花岭区", code: "140107", level: "district" },
          { label: "尖草坪区", code: "140108", level: "district" },
          { label: "万柏林区", code: "140109", level: "district" },
          { label: "晋源区", code: "140110", level: "district" },
          { label: "清徐县", code: "140121", level: "district" },
          { label: "阳曲县", code: "140122", level: "district" },
          { label: "娄烦县", code: "140123", level: "district" },
          { label: "古交市", code: "140181", level: "district" }
        ],
        level: "city"
      },
      {
        label: "大同市",
        code: "140200",
        children: [
          { label: "新荣区", code: "140212", level: "district" },
          { label: "平城区", code: "140213", level: "district" },
          { label: "云冈区", code: "140214", level: "district" },
          { label: "云州区", code: "140215", level: "district" },
          { label: "阳高县", code: "140221", level: "district" },
          { label: "天镇县", code: "140222", level: "district" },
          { label: "广灵县", code: "140223", level: "district" },
          { label: "灵丘县", code: "140224", level: "district" },
          { label: "浑源县", code: "140225", level: "district" },
          { label: "左云县", code: "140226", level: "district" }
        ],
        level: "city"
      },
      {
        label: "阳泉市",
        code: "140300",
        children: [
          { label: "城区", code: "140302", level: "district" },
          { label: "矿区", code: "140303", level: "district" },
          { label: "郊区", code: "140311", level: "district" },
          { label: "平定县", code: "140321", level: "district" },
          { label: "盂县", code: "140322", level: "district" }
        ],
        level: "city"
      },
      {
        label: "长治市",
        code: "140400",
        children: [
          { label: "潞州区", code: "140403", level: "district" },
          { label: "上党区", code: "140404", level: "district" },
          { label: "屯留区", code: "140405", level: "district" },
          { label: "潞城区", code: "140406", level: "district" },
          { label: "襄垣县", code: "140423", level: "district" },
          { label: "平顺县", code: "140425", level: "district" },
          { label: "黎城县", code: "140426", level: "district" },
          { label: "壶关县", code: "140427", level: "district" },
          { label: "长子县", code: "140428", level: "district" },
          { label: "武乡县", code: "140429", level: "district" },
          { label: "沁县", code: "140430", level: "district" },
          { label: "沁源县", code: "140431", level: "district" }
        ],
        level: "city"
      },
      {
        label: "晋城市",
        code: "140500",
        children: [
          { label: "城区", code: "140502", level: "district" },
          { label: "沁水县", code: "140521", level: "district" },
          { label: "阳城县", code: "140522", level: "district" },
          { label: "陵川县", code: "140524", level: "district" },
          { label: "泽州县", code: "140525", level: "district" },
          { label: "高平市", code: "140581", level: "district" }
        ],
        level: "city"
      },
      {
        label: "朔州市",
        code: "140600",
        children: [
          { label: "朔城区", code: "140602", level: "district" },
          { label: "平鲁区", code: "140603", level: "district" },
          { label: "山阴县", code: "140621", level: "district" },
          { label: "应县", code: "140622", level: "district" },
          { label: "右玉县", code: "140623", level: "district" },
          { label: "怀仁市", code: "140681", level: "district" }
        ],
        level: "city"
      },
      {
        label: "晋中市",
        code: "140700",
        children: [
          { label: "榆次区", code: "140702", level: "district" },
          { label: "太谷区", code: "140703", level: "district" },
          { label: "榆社县", code: "140721", level: "district" },
          { label: "左权县", code: "140722", level: "district" },
          { label: "和顺县", code: "140723", level: "district" },
          { label: "昔阳县", code: "140724", level: "district" },
          { label: "寿阳县", code: "140725", level: "district" },
          { label: "祁县", code: "140727", level: "district" },
          { label: "平遥县", code: "140728", level: "district" },
          { label: "灵石县", code: "140729", level: "district" },
          { label: "介休市", code: "140781", level: "district" }
        ],
        level: "city"
      },
      {
        label: "运城市",
        code: "140800",
        children: [
          { label: "盐湖区", code: "140802", level: "district" },
          { label: "临猗县", code: "140821", level: "district" },
          { label: "万荣县", code: "140822", level: "district" },
          { label: "闻喜县", code: "140823", level: "district" },
          { label: "稷山县", code: "140824", level: "district" },
          { label: "新绛县", code: "140825", level: "district" },
          { label: "绛县", code: "140826", level: "district" },
          { label: "垣曲县", code: "140827", level: "district" },
          { label: "夏县", code: "140828", level: "district" },
          { label: "平陆县", code: "140829", level: "district" },
          { label: "芮城县", code: "140830", level: "district" },
          { label: "永济市", code: "140881", level: "district" },
          { label: "河津市", code: "140882", level: "district" }
        ],
        level: "city"
      },
      {
        label: "忻州市",
        code: "140900",
        children: [
          { label: "忻府区", code: "140902", level: "district" },
          { label: "定襄县", code: "140921", level: "district" },
          { label: "五台县", code: "140922", level: "district" },
          { label: "代县", code: "140923", level: "district" },
          { label: "繁峙县", code: "140924", level: "district" },
          { label: "宁武县", code: "140925", level: "district" },
          { label: "静乐县", code: "140926", level: "district" },
          { label: "神池县", code: "140927", level: "district" },
          { label: "五寨县", code: "140928", level: "district" },
          { label: "岢岚县", code: "140929", level: "district" },
          { label: "河曲县", code: "140930", level: "district" },
          { label: "保德县", code: "140931", level: "district" },
          { label: "偏关县", code: "140932", level: "district" },
          { label: "原平市", code: "140981", level: "district" }
        ],
        level: "city"
      },
      {
        label: "临汾市",
        code: "141000",
        children: [
          { label: "尧都区", code: "141002", level: "district" },
          { label: "曲沃县", code: "141021", level: "district" },
          { label: "翼城县", code: "141022", level: "district" },
          { label: "襄汾县", code: "141023", level: "district" },
          { label: "洪洞县", code: "141024", level: "district" },
          { label: "古县", code: "141025", level: "district" },
          { label: "安泽县", code: "141026", level: "district" },
          { label: "浮山县", code: "141027", level: "district" },
          { label: "吉县", code: "141028", level: "district" },
          { label: "乡宁县", code: "141029", level: "district" },
          { label: "大宁县", code: "141030", level: "district" },
          { label: "隰县", code: "141031", level: "district" },
          { label: "永和县", code: "141032", level: "district" },
          { label: "蒲县", code: "141033", level: "district" },
          { label: "汾西县", code: "141034", level: "district" },
          { label: "侯马市", code: "141081", level: "district" },
          { label: "霍州市", code: "141082", level: "district" }
        ],
        level: "city"
      },
      {
        label: "吕梁市",
        code: "141100",
        children: [
          { label: "离石区", code: "141102", level: "district" },
          { label: "文水县", code: "141121", level: "district" },
          { label: "交城县", code: "141122", level: "district" },
          { label: "兴县", code: "141123", level: "district" },
          { label: "临县", code: "141124", level: "district" },
          { label: "柳林县", code: "141125", level: "district" },
          { label: "石楼县", code: "141126", level: "district" },
          { label: "岚县", code: "141127", level: "district" },
          { label: "方山县", code: "141128", level: "district" },
          { label: "中阳县", code: "141129", level: "district" },
          { label: "交口县", code: "141130", level: "district" },
          { label: "孝义市", code: "141181", level: "district" },
          { label: "汾阳市", code: "141182", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "内蒙古自治区",
    code: "150000",
    children: [
      {
        label: "呼和浩特市",
        code: "150100",
        children: [
          { label: "新城区", code: "150102", level: "district" },
          { label: "回民区", code: "150103", level: "district" },
          { label: "玉泉区", code: "150104", level: "district" },
          { label: "赛罕区", code: "150105", level: "district" },
          { label: "土默特左旗", code: "150121", level: "district" },
          { label: "托克托县", code: "150122", level: "district" },
          { label: "和林格尔县", code: "150123", level: "district" },
          { label: "清水河县", code: "150124", level: "district" },
          { label: "武川县", code: "150125", level: "district" }
        ],
        level: "city"
      },
      {
        label: "包头市",
        code: "150200",
        children: [
          { label: "东河区", code: "150202", level: "district" },
          { label: "昆都仑区", code: "150203", level: "district" },
          { label: "青山区", code: "150204", level: "district" },
          { label: "石拐区", code: "150205", level: "district" },
          { label: "白云鄂博矿区", code: "150206", level: "district" },
          { label: "九原区", code: "150207", level: "district" },
          { label: "土默特右旗", code: "150221", level: "district" },
          { label: "固阳县", code: "150222", level: "district" },
          { label: "达尔罕茂明安联合旗", code: "150223", level: "district" }
        ],
        level: "city"
      },
      {
        label: "乌海市",
        code: "150300",
        children: [
          { label: "海勃湾区", code: "150302", level: "district" },
          { label: "海南区", code: "150303", level: "district" },
          { label: "乌达区", code: "150304", level: "district" }
        ],
        level: "city"
      },
      {
        label: "赤峰市",
        code: "150400",
        children: [
          { label: "红山区", code: "150402", level: "district" },
          { label: "元宝山区", code: "150403", level: "district" },
          { label: "松山区", code: "150404", level: "district" },
          { label: "阿鲁科尔沁旗", code: "150421", level: "district" },
          { label: "巴林左旗", code: "150422", level: "district" },
          { label: "巴林右旗", code: "150423", level: "district" },
          { label: "林西县", code: "150424", level: "district" },
          { label: "克什克腾旗", code: "150425", level: "district" },
          { label: "翁牛特旗", code: "150426", level: "district" },
          { label: "喀喇沁旗", code: "150428", level: "district" },
          { label: "宁城县", code: "150429", level: "district" },
          { label: "敖汉旗", code: "150430", level: "district" }
        ],
        level: "city"
      },
      {
        label: "通辽市",
        code: "150500",
        children: [
          { label: "科尔沁区", code: "150502", level: "district" },
          { label: "科尔沁左翼中旗", code: "150521", level: "district" },
          { label: "科尔沁左翼后旗", code: "150522", level: "district" },
          { label: "开鲁县", code: "150523", level: "district" },
          { label: "库伦旗", code: "150524", level: "district" },
          { label: "奈曼旗", code: "150525", level: "district" },
          { label: "扎鲁特旗", code: "150526", level: "district" },
          { label: "霍林郭勒市", code: "150581", level: "district" }
        ],
        level: "city"
      },
      {
        label: "鄂尔多斯市",
        code: "150600",
        children: [
          { label: "东胜区", code: "150602", level: "district" },
          { label: "康巴什区", code: "150603", level: "district" },
          { label: "达拉特旗", code: "150621", level: "district" },
          { label: "准格尔旗", code: "150622", level: "district" },
          { label: "鄂托克前旗", code: "150623", level: "district" },
          { label: "鄂托克旗", code: "150624", level: "district" },
          { label: "杭锦旗", code: "150625", level: "district" },
          { label: "乌审旗", code: "150626", level: "district" },
          { label: "伊金霍洛旗", code: "150627", level: "district" }
        ],
        level: "city"
      },
      {
        label: "呼伦贝尔市",
        code: "150700",
        children: [
          { label: "海拉尔区", code: "150702", level: "district" },
          { label: "扎赉诺尔区", code: "150703", level: "district" },
          { label: "阿荣旗", code: "150721", level: "district" },
          {
            label: "莫力达瓦达斡尔族自治旗",
            code: "150722",
            level: "district"
          },
          { label: "鄂伦春自治旗", code: "150723", level: "district" },
          { label: "鄂温克族自治旗", code: "150724", level: "district" },
          { label: "陈巴尔虎旗", code: "150725", level: "district" },
          { label: "新巴尔虎左旗", code: "150726", level: "district" },
          { label: "新巴尔虎右旗", code: "150727", level: "district" },
          { label: "满洲里市", code: "150781", level: "district" },
          { label: "牙克石市", code: "150782", level: "district" },
          { label: "扎兰屯市", code: "150783", level: "district" },
          { label: "额尔古纳市", code: "150784", level: "district" },
          { label: "根河市", code: "150785", level: "district" }
        ],
        level: "city"
      },
      {
        label: "巴彦淖尔市",
        code: "150800",
        children: [
          { label: "临河区", code: "150802", level: "district" },
          { label: "五原县", code: "150821", level: "district" },
          { label: "磴口县", code: "150822", level: "district" },
          { label: "乌拉特前旗", code: "150823", level: "district" },
          { label: "乌拉特中旗", code: "150824", level: "district" },
          { label: "乌拉特后旗", code: "150825", level: "district" },
          { label: "杭锦后旗", code: "150826", level: "district" }
        ],
        level: "city"
      },
      {
        label: "乌兰察布市",
        code: "150900",
        children: [
          { label: "集宁区", code: "150902", level: "district" },
          { label: "卓资县", code: "150921", level: "district" },
          { label: "化德县", code: "150922", level: "district" },
          { label: "商都县", code: "150923", level: "district" },
          { label: "兴和县", code: "150924", level: "district" },
          { label: "凉城县", code: "150925", level: "district" },
          { label: "察哈尔右翼前旗", code: "150926", level: "district" },
          { label: "察哈尔右翼中旗", code: "150927", level: "district" },
          { label: "察哈尔右翼后旗", code: "150928", level: "district" },
          { label: "四子王旗", code: "150929", level: "district" },
          { label: "丰镇市", code: "150981", level: "district" }
        ],
        level: "city"
      },
      {
        label: "兴安盟",
        code: "152200",
        children: [
          { label: "乌兰浩特市", code: "152201", level: "district" },
          { label: "阿尔山市", code: "152202", level: "district" },
          { label: "科尔沁右翼前旗", code: "152221", level: "district" },
          { label: "科尔沁右翼中旗", code: "152222", level: "district" },
          { label: "扎赉特旗", code: "152223", level: "district" },
          { label: "突泉县", code: "152224", level: "district" }
        ],
        level: "city"
      },
      {
        label: "锡林郭勒盟",
        code: "152500",
        children: [
          { label: "二连浩特市", code: "152501", level: "district" },
          { label: "锡林浩特市", code: "152502", level: "district" },
          { label: "阿巴嘎旗", code: "152522", level: "district" },
          { label: "苏尼特左旗", code: "152523", level: "district" },
          { label: "苏尼特右旗", code: "152524", level: "district" },
          { label: "东乌珠穆沁旗", code: "152525", level: "district" },
          { label: "西乌珠穆沁旗", code: "152526", level: "district" },
          { label: "太仆寺旗", code: "152527", level: "district" },
          { label: "镶黄旗", code: "152528", level: "district" },
          { label: "正镶白旗", code: "152529", level: "district" },
          { label: "正蓝旗", code: "152530", level: "district" },
          { label: "多伦县", code: "152531", level: "district" },
          { label: "乌拉盖管委会", code: "152571", level: "district" }
        ],
        level: "city"
      },
      {
        label: "阿拉善盟",
        code: "152900",
        children: [
          { label: "阿拉善左旗", code: "152921", level: "district" },
          { label: "阿拉善右旗", code: "152922", level: "district" },
          { label: "额济纳旗", code: "152923", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "辽宁省",
    code: "210000",
    children: [
      {
        label: "沈阳市",
        code: "210100",
        children: [
          { label: "和平区", code: "210102", level: "district" },
          { label: "沈河区", code: "210103", level: "district" },
          { label: "大东区", code: "210104", level: "district" },
          { label: "皇姑区", code: "210105", level: "district" },
          { label: "铁西区", code: "210106", level: "district" },
          { label: "苏家屯区", code: "210111", level: "district" },
          { label: "浑南区", code: "210112", level: "district" },
          { label: "沈北新区", code: "210113", level: "district" },
          { label: "于洪区", code: "210114", level: "district" },
          { label: "辽中区", code: "210115", level: "district" },
          { label: "康平县", code: "210123", level: "district" },
          { label: "法库县", code: "210124", level: "district" },
          { label: "新民市", code: "210181", level: "district" }
        ],
        level: "city"
      },
      {
        label: "大连市",
        code: "210200",
        children: [
          { label: "中山区", code: "210202", level: "district" },
          { label: "西岗区", code: "210203", level: "district" },
          { label: "沙河口区", code: "210204", level: "district" },
          { label: "甘井子区", code: "210211", level: "district" },
          { label: "旅顺口区", code: "210212", level: "district" },
          { label: "金州区", code: "210213", level: "district" },
          { label: "普兰店区", code: "210214", level: "district" },
          { label: "长海县", code: "210224", level: "district" },
          { label: "瓦房店市", code: "210281", level: "district" },
          { label: "庄河市", code: "210283", level: "district" }
        ],
        level: "city"
      },
      {
        label: "鞍山市",
        code: "210300",
        children: [
          { label: "铁东区", code: "210302", level: "district" },
          { label: "铁西区", code: "210303", level: "district" },
          { label: "立山区", code: "210304", level: "district" },
          { label: "千山区", code: "210311", level: "district" },
          { label: "台安县", code: "210321", level: "district" },
          { label: "岫岩满族自治县", code: "210323", level: "district" },
          { label: "海城市", code: "210381", level: "district" }
        ],
        level: "city"
      },
      {
        label: "抚顺市",
        code: "210400",
        children: [
          { label: "新抚区", code: "210402", level: "district" },
          { label: "东洲区", code: "210403", level: "district" },
          { label: "望花区", code: "210404", level: "district" },
          { label: "顺城区", code: "210411", level: "district" },
          { label: "抚顺县", code: "210421", level: "district" },
          { label: "新宾满族自治县", code: "210422", level: "district" },
          { label: "清原满族自治县", code: "210423", level: "district" }
        ],
        level: "city"
      },
      {
        label: "本溪市",
        code: "210500",
        children: [
          { label: "平山区", code: "210502", level: "district" },
          { label: "溪湖区", code: "210503", level: "district" },
          { label: "明山区", code: "210504", level: "district" },
          { label: "南芬区", code: "210505", level: "district" },
          { label: "本溪满族自治县", code: "210521", level: "district" },
          { label: "桓仁满族自治县", code: "210522", level: "district" }
        ],
        level: "city"
      },
      {
        label: "丹东市",
        code: "210600",
        children: [
          { label: "元宝区", code: "210602", level: "district" },
          { label: "振兴区", code: "210603", level: "district" },
          { label: "振安区", code: "210604", level: "district" },
          { label: "宽甸满族自治县", code: "210624", level: "district" },
          { label: "东港市", code: "210681", level: "district" },
          { label: "凤城市", code: "210682", level: "district" }
        ],
        level: "city"
      },
      {
        label: "锦州市",
        code: "210700",
        children: [
          { label: "古塔区", code: "210702", level: "district" },
          { label: "凌河区", code: "210703", level: "district" },
          { label: "太和区", code: "210711", level: "district" },
          { label: "黑山县", code: "210726", level: "district" },
          { label: "义县", code: "210727", level: "district" },
          { label: "凌海市", code: "210781", level: "district" },
          { label: "北镇市", code: "210782", level: "district" }
        ],
        level: "city"
      },
      {
        label: "营口市",
        code: "210800",
        children: [
          { label: "站前区", code: "210802", level: "district" },
          { label: "西市区", code: "210803", level: "district" },
          { label: "鲅鱼圈区", code: "210804", level: "district" },
          { label: "老边区", code: "210811", level: "district" },
          { label: "盖州市", code: "210881", level: "district" },
          { label: "大石桥市", code: "210882", level: "district" }
        ],
        level: "city"
      },
      {
        label: "阜新市",
        code: "210900",
        children: [
          { label: "海州区", code: "210902", level: "district" },
          { label: "新邱区", code: "210903", level: "district" },
          { label: "太平区", code: "210904", level: "district" },
          { label: "清河门区", code: "210905", level: "district" },
          { label: "细河区", code: "210911", level: "district" },
          { label: "阜新蒙古族自治县", code: "210921", level: "district" },
          { label: "彰武县", code: "210922", level: "district" }
        ],
        level: "city"
      },
      {
        label: "辽阳市",
        code: "211000",
        children: [
          { label: "白塔区", code: "211002", level: "district" },
          { label: "文圣区", code: "211003", level: "district" },
          { label: "宏伟区", code: "211004", level: "district" },
          { label: "弓长岭区", code: "211005", level: "district" },
          { label: "太子河区", code: "211011", level: "district" },
          { label: "辽阳县", code: "211021", level: "district" },
          { label: "灯塔市", code: "211081", level: "district" }
        ],
        level: "city"
      },
      {
        label: "盘锦市",
        code: "211100",
        children: [
          { label: "双台子区", code: "211102", level: "district" },
          { label: "兴隆台区", code: "211103", level: "district" },
          { label: "大洼区", code: "211104", level: "district" },
          { label: "盘山县", code: "211122", level: "district" }
        ],
        level: "city"
      },
      {
        label: "铁岭市",
        code: "211200",
        children: [
          { label: "银州区", code: "211202", level: "district" },
          { label: "清河区", code: "211204", level: "district" },
          { label: "铁岭县", code: "211221", level: "district" },
          { label: "西丰县", code: "211223", level: "district" },
          { label: "昌图县", code: "211224", level: "district" },
          { label: "调兵山市", code: "211281", level: "district" },
          { label: "开原市", code: "211282", level: "district" }
        ],
        level: "city"
      },
      {
        label: "朝阳市",
        code: "211300",
        children: [
          { label: "双塔区", code: "211302", level: "district" },
          { label: "龙城区", code: "211303", level: "district" },
          { label: "朝阳县", code: "211321", level: "district" },
          { label: "建平县", code: "211322", level: "district" },
          {
            label: "喀喇沁左翼蒙古族自治县",
            code: "211324",
            level: "district"
          },
          { label: "北票市", code: "211381", level: "district" },
          { label: "凌源市", code: "211382", level: "district" }
        ],
        level: "city"
      },
      {
        label: "葫芦岛市",
        code: "211400",
        children: [
          { label: "连山区", code: "211402", level: "district" },
          { label: "龙港区", code: "211403", level: "district" },
          { label: "南票区", code: "211404", level: "district" },
          { label: "绥中县", code: "211421", level: "district" },
          { label: "建昌县", code: "211422", level: "district" },
          { label: "兴城市", code: "211481", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "吉林省",
    code: "220000",
    children: [
      {
        label: "长春市",
        code: "220100",
        children: [
          { label: "南关区", code: "220102", level: "district" },
          { label: "宽城区", code: "220103", level: "district" },
          { label: "朝阳区", code: "220104", level: "district" },
          { label: "二道区", code: "220105", level: "district" },
          { label: "绿园区", code: "220106", level: "district" },
          { label: "双阳区", code: "220112", level: "district" },
          { label: "九台区", code: "220113", level: "district" },
          { label: "农安县", code: "220122", level: "district" },
          { label: "榆树市", code: "220182", level: "district" },
          { label: "德惠市", code: "220183", level: "district" }
        ],
        level: "city"
      },
      {
        label: "吉林市",
        code: "220200",
        children: [
          { label: "昌邑区", code: "220202", level: "district" },
          { label: "龙潭区", code: "220203", level: "district" },
          { label: "船营区", code: "220204", level: "district" },
          { label: "丰满区", code: "220211", level: "district" },
          { label: "永吉县", code: "220221", level: "district" },
          { label: "蛟河市", code: "220281", level: "district" },
          { label: "桦甸市", code: "220282", level: "district" },
          { label: "舒兰市", code: "220283", level: "district" },
          { label: "磐石市", code: "220284", level: "district" }
        ],
        level: "city"
      },
      {
        label: "四平市",
        code: "220300",
        children: [
          { label: "铁西区", code: "220302", level: "district" },
          { label: "铁东区", code: "220303", level: "district" },
          { label: "梨树县", code: "220322", level: "district" },
          { label: "伊通满族自治县", code: "220323", level: "district" },
          { label: "公主岭市", code: "220381", level: "district" },
          { label: "双辽市", code: "220382", level: "district" }
        ],
        level: "city"
      },
      {
        label: "辽源市",
        code: "220400",
        children: [
          { label: "龙山区", code: "220402", level: "district" },
          { label: "西安区", code: "220403", level: "district" },
          { label: "东丰县", code: "220421", level: "district" },
          { label: "东辽县", code: "220422", level: "district" }
        ],
        level: "city"
      },
      {
        label: "通化市",
        code: "220500",
        children: [
          { label: "东昌区", code: "220502", level: "district" },
          { label: "二道江区", code: "220503", level: "district" },
          { label: "通化县", code: "220521", level: "district" },
          { label: "辉南县", code: "220523", level: "district" },
          { label: "柳河县", code: "220524", level: "district" },
          { label: "梅河口市", code: "220581", level: "district" },
          { label: "集安市", code: "220582", level: "district" }
        ],
        level: "city"
      },
      {
        label: "白山市",
        code: "220600",
        children: [
          { label: "浑江区", code: "220602", level: "district" },
          { label: "江源区", code: "220605", level: "district" },
          { label: "抚松县", code: "220621", level: "district" },
          { label: "靖宇县", code: "220622", level: "district" },
          { label: "长白朝鲜族自治县", code: "220623", level: "district" },
          { label: "临江市", code: "220681", level: "district" }
        ],
        level: "city"
      },
      {
        label: "松原市",
        code: "220700",
        children: [
          { label: "宁江区", code: "220702", level: "district" },
          {
            label: "前郭尔罗斯蒙古族自治县",
            code: "220721",
            level: "district"
          },
          { label: "长岭县", code: "220722", level: "district" },
          { label: "乾安县", code: "220723", level: "district" },
          { label: "扶余市", code: "220781", level: "district" }
        ],
        level: "city"
      },
      {
        label: "白城市",
        code: "220800",
        children: [
          { label: "洮北区", code: "220802", level: "district" },
          { label: "镇赉县", code: "220821", level: "district" },
          { label: "通榆县", code: "220822", level: "district" },
          { label: "洮南市", code: "220881", level: "district" },
          { label: "大安市", code: "220882", level: "district" }
        ],
        level: "city"
      },
      {
        label: "延边朝鲜族自治州",
        code: "222400",
        children: [
          { label: "延吉市", code: "222401", level: "district" },
          { label: "图们市", code: "222402", level: "district" },
          { label: "敦化市", code: "222403", level: "district" },
          { label: "珲春市", code: "222404", level: "district" },
          { label: "龙井市", code: "222405", level: "district" },
          { label: "和龙市", code: "222406", level: "district" },
          { label: "汪清县", code: "222424", level: "district" },
          { label: "安图县", code: "222426", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "黑龙江省",
    code: "230000",
    children: [
      {
        label: "哈尔滨市",
        code: "230100",
        children: [
          { label: "道里区", code: "230102", level: "district" },
          { label: "南岗区", code: "230103", level: "district" },
          { label: "道外区", code: "230104", level: "district" },
          { label: "平房区", code: "230108", level: "district" },
          { label: "松北区", code: "230109", level: "district" },
          { label: "香坊区", code: "230110", level: "district" },
          { label: "呼兰区", code: "230111", level: "district" },
          { label: "阿城区", code: "230112", level: "district" },
          { label: "双城区", code: "230113", level: "district" },
          { label: "依兰县", code: "230123", level: "district" },
          { label: "方正县", code: "230124", level: "district" },
          { label: "宾县", code: "230125", level: "district" },
          { label: "巴彦县", code: "230126", level: "district" },
          { label: "木兰县", code: "230127", level: "district" },
          { label: "通河县", code: "230128", level: "district" },
          { label: "延寿县", code: "230129", level: "district" },
          { label: "尚志市", code: "230183", level: "district" },
          { label: "五常市", code: "230184", level: "district" }
        ],
        level: "city"
      },
      {
        label: "齐齐哈尔市",
        code: "230200",
        children: [
          { label: "龙沙区", code: "230202", level: "district" },
          { label: "建华区", code: "230203", level: "district" },
          { label: "铁锋区", code: "230204", level: "district" },
          { label: "昂昂溪区", code: "230205", level: "district" },
          { label: "富拉尔基区", code: "230206", level: "district" },
          { label: "碾子山区", code: "230207", level: "district" },
          { label: "梅里斯达斡尔族区", code: "230208", level: "district" },
          { label: "龙江县", code: "230221", level: "district" },
          { label: "依安县", code: "230223", level: "district" },
          { label: "泰来县", code: "230224", level: "district" },
          { label: "甘南县", code: "230225", level: "district" },
          { label: "富裕县", code: "230227", level: "district" },
          { label: "克山县", code: "230229", level: "district" },
          { label: "克东县", code: "230230", level: "district" },
          { label: "拜泉县", code: "230231", level: "district" },
          { label: "讷河市", code: "230281", level: "district" }
        ],
        level: "city"
      },
      {
        label: "鸡西市",
        code: "230300",
        children: [
          { label: "鸡冠区", code: "230302", level: "district" },
          { label: "恒山区", code: "230303", level: "district" },
          { label: "滴道区", code: "230304", level: "district" },
          { label: "梨树区", code: "230305", level: "district" },
          { label: "城子河区", code: "230306", level: "district" },
          { label: "麻山区", code: "230307", level: "district" },
          { label: "鸡东县", code: "230321", level: "district" },
          { label: "虎林市", code: "230381", level: "district" },
          { label: "密山市", code: "230382", level: "district" }
        ],
        level: "city"
      },
      {
        label: "鹤岗市",
        code: "230400",
        children: [
          { label: "向阳区", code: "230402", level: "district" },
          { label: "工农区", code: "230403", level: "district" },
          { label: "南山区", code: "230404", level: "district" },
          { label: "兴安区", code: "230405", level: "district" },
          { label: "东山区", code: "230406", level: "district" },
          { label: "兴山区", code: "230407", level: "district" },
          { label: "萝北县", code: "230421", level: "district" },
          { label: "绥滨县", code: "230422", level: "district" }
        ],
        level: "city"
      },
      {
        label: "双鸭山市",
        code: "230500",
        children: [
          { label: "尖山区", code: "230502", level: "district" },
          { label: "岭东区", code: "230503", level: "district" },
          { label: "四方台区", code: "230505", level: "district" },
          { label: "宝山区", code: "230506", level: "district" },
          { label: "集贤县", code: "230521", level: "district" },
          { label: "友谊县", code: "230522", level: "district" },
          { label: "宝清县", code: "230523", level: "district" },
          { label: "饶河县", code: "230524", level: "district" }
        ],
        level: "city"
      },
      {
        label: "大庆市",
        code: "230600",
        children: [
          { label: "萨尔图区", code: "230602", level: "district" },
          { label: "龙凤区", code: "230603", level: "district" },
          { label: "让胡路区", code: "230604", level: "district" },
          { label: "红岗区", code: "230605", level: "district" },
          { label: "大同区", code: "230606", level: "district" },
          { label: "肇州县", code: "230621", level: "district" },
          { label: "肇源县", code: "230622", level: "district" },
          { label: "林甸县", code: "230623", level: "district" },
          { label: "杜尔伯特蒙古族自治县", code: "230624", level: "district" }
        ],
        level: "city"
      },
      {
        label: "伊春市",
        code: "230700",
        children: [
          { label: "伊美区", code: "230717", level: "district" },
          { label: "乌翠区", code: "230718", level: "district" },
          { label: "友好区", code: "230719", level: "district" },
          { label: "嘉荫县", code: "230722", level: "district" },
          { label: "汤旺县", code: "230723", level: "district" },
          { label: "丰林县", code: "230724", level: "district" },
          { label: "大箐山县", code: "230725", level: "district" },
          { label: "南岔县", code: "230726", level: "district" },
          { label: "金林区", code: "230751", level: "district" },
          { label: "铁力市", code: "230781", level: "district" }
        ],
        level: "city"
      },
      {
        label: "佳木斯市",
        code: "230800",
        children: [
          { label: "向阳区", code: "230803", level: "district" },
          { label: "前进区", code: "230804", level: "district" },
          { label: "东风区", code: "230805", level: "district" },
          { label: "郊区", code: "230811", level: "district" },
          { label: "桦南县", code: "230822", level: "district" },
          { label: "桦川县", code: "230826", level: "district" },
          { label: "汤原县", code: "230828", level: "district" },
          { label: "同江市", code: "230881", level: "district" },
          { label: "富锦市", code: "230882", level: "district" },
          { label: "抚远市", code: "230883", level: "district" }
        ],
        level: "city"
      },
      {
        label: "七台河市",
        code: "230900",
        children: [
          { label: "新兴区", code: "230902", level: "district" },
          { label: "桃山区", code: "230903", level: "district" },
          { label: "茄子河区", code: "230904", level: "district" },
          { label: "勃利县", code: "230921", level: "district" }
        ],
        level: "city"
      },
      {
        label: "牡丹江市",
        code: "231000",
        children: [
          { label: "东安区", code: "231002", level: "district" },
          { label: "阳明区", code: "231003", level: "district" },
          { label: "爱民区", code: "231004", level: "district" },
          { label: "西安区", code: "231005", level: "district" },
          { label: "林口县", code: "231025", level: "district" },
          { label: "绥芬河市", code: "231081", level: "district" },
          { label: "海林市", code: "231083", level: "district" },
          { label: "宁安市", code: "231084", level: "district" },
          { label: "穆棱市", code: "231085", level: "district" },
          { label: "东宁市", code: "231086", level: "district" }
        ],
        level: "city"
      },
      {
        label: "黑河市",
        code: "231100",
        children: [
          { label: "爱辉区", code: "231102", level: "district" },
          { label: "逊克县", code: "231123", level: "district" },
          { label: "孙吴县", code: "231124", level: "district" },
          { label: "北安市", code: "231181", level: "district" },
          { label: "五大连池市", code: "231182", level: "district" },
          { label: "嫩江市", code: "231183", level: "district" }
        ],
        level: "city"
      },
      {
        label: "绥化市",
        code: "231200",
        children: [
          { label: "北林区", code: "231202", level: "district" },
          { label: "望奎县", code: "231221", level: "district" },
          { label: "兰西县", code: "231222", level: "district" },
          { label: "青冈县", code: "231223", level: "district" },
          { label: "庆安县", code: "231224", level: "district" },
          { label: "明水县", code: "231225", level: "district" },
          { label: "绥棱县", code: "231226", level: "district" },
          { label: "安达市", code: "231281", level: "district" },
          { label: "肇东市", code: "231282", level: "district" },
          { label: "海伦市", code: "231283", level: "district" }
        ],
        level: "city"
      },
      {
        label: "大兴安岭地区",
        code: "232700",
        children: [
          { label: "漠河市", code: "232701", level: "district" },
          { label: "呼玛县", code: "232721", level: "district" },
          { label: "塔河县", code: "232722", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "上海市",
    code: "310000",
    children: [
      {
        label: "上海市",
        code: "310100",
        children: [
          { label: "黄浦区", code: "310101", level: "district" },
          { label: "徐汇区", code: "310104", level: "district" },
          { label: "长宁区", code: "310105", level: "district" },
          { label: "静安区", code: "310106", level: "district" },
          { label: "普陀区", code: "310107", level: "district" },
          { label: "虹口区", code: "310109", level: "district" },
          { label: "杨浦区", code: "310110", level: "district" },
          { label: "闵行区", code: "310112", level: "district" },
          { label: "宝山区", code: "310113", level: "district" },
          { label: "嘉定区", code: "310114", level: "district" },
          { label: "浦东新区", code: "310115", level: "district" },
          { label: "金山区", code: "310116", level: "district" },
          { label: "松江区", code: "310117", level: "district" },
          { label: "青浦区", code: "310118", level: "district" },
          { label: "奉贤区", code: "310120", level: "district" },
          { label: "崇明区", code: "310151", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "江苏省",
    code: "320000",
    children: [
      {
        label: "南京市",
        code: "320100",
        children: [
          { label: "玄武区", code: "320102", level: "district" },
          { label: "秦淮区", code: "320104", level: "district" },
          { label: "建邺区", code: "320105", level: "district" },
          { label: "鼓楼区", code: "320106", level: "district" },
          { label: "浦口区", code: "320111", level: "district" },
          { label: "栖霞区", code: "320113", level: "district" },
          { label: "雨花台区", code: "320114", level: "district" },
          { label: "江宁区", code: "320115", level: "district" },
          { label: "六合区", code: "320116", level: "district" },
          { label: "溧水区", code: "320117", level: "district" },
          { label: "高淳区", code: "320118", level: "district" }
        ],
        level: "city"
      },
      {
        label: "无锡市",
        code: "320200",
        children: [
          { label: "锡山区", code: "320205", level: "district" },
          { label: "惠山区", code: "320206", level: "district" },
          { label: "滨湖区", code: "320211", level: "district" },
          { label: "梁溪区", code: "320213", level: "district" },
          { label: "新吴区", code: "320214", level: "district" },
          { label: "江阴市", code: "320281", level: "district" },
          { label: "宜兴市", code: "320282", level: "district" }
        ],
        level: "city"
      },
      {
        label: "徐州市",
        code: "320300",
        children: [
          { label: "鼓楼区", code: "320302", level: "district" },
          { label: "云龙区", code: "320303", level: "district" },
          { label: "贾汪区", code: "320305", level: "district" },
          { label: "泉山区", code: "320311", level: "district" },
          { label: "铜山区", code: "320312", level: "district" },
          { label: "丰县", code: "320321", level: "district" },
          { label: "沛县", code: "320322", level: "district" },
          { label: "睢宁县", code: "320324", level: "district" },
          { label: "新沂市", code: "320381", level: "district" },
          { label: "邳州市", code: "320382", level: "district" }
        ],
        level: "city"
      },
      {
        label: "常州市",
        code: "320400",
        children: [
          { label: "天宁区", code: "320402", level: "district" },
          { label: "钟楼区", code: "320404", level: "district" },
          { label: "新北区", code: "320411", level: "district" },
          { label: "武进区", code: "320412", level: "district" },
          { label: "金坛区", code: "320413", level: "district" },
          { label: "溧阳市", code: "320481", level: "district" }
        ],
        level: "city"
      },
      {
        label: "苏州市",
        code: "320500",
        children: [
          { label: "虎丘区", code: "320505", level: "district" },
          { label: "吴中区", code: "320506", level: "district" },
          { label: "相城区", code: "320507", level: "district" },
          { label: "姑苏区", code: "320508", level: "district" },
          { label: "吴江区", code: "320509", level: "district" },
          { label: "常熟市", code: "320581", level: "district" },
          { label: "张家港市", code: "320582", level: "district" },
          { label: "昆山市", code: "320583", level: "district" },
          { label: "太仓市", code: "320585", level: "district" }
        ],
        level: "city"
      },
      {
        label: "南通市",
        code: "320600",
        children: [
          { label: "通州区", code: "320612", level: "district" },
          { label: "如东县", code: "320623", level: "district" },
          { label: "启东市", code: "320681", level: "district" },
          { label: "如皋市", code: "320682", level: "district" },
          { label: "海安市", code: "320685", level: "district" }
        ],
        level: "city"
      },
      {
        label: "连云港市",
        code: "320700",
        children: [
          { label: "连云区", code: "320703", level: "district" },
          { label: "海州区", code: "320706", level: "district" },
          { label: "赣榆区", code: "320707", level: "district" },
          { label: "东海县", code: "320722", level: "district" },
          { label: "灌云县", code: "320723", level: "district" },
          { label: "灌南县", code: "320724", level: "district" }
        ],
        level: "city"
      },
      {
        label: "淮安市",
        code: "320800",
        children: [
          { label: "淮安区", code: "320803", level: "district" },
          { label: "淮阴区", code: "320804", level: "district" },
          { label: "清江浦区", code: "320812", level: "district" },
          { label: "洪泽区", code: "320813", level: "district" },
          { label: "涟水县", code: "320826", level: "district" },
          { label: "盱眙县", code: "320830", level: "district" },
          { label: "金湖县", code: "320831", level: "district" }
        ],
        level: "city"
      },
      {
        label: "盐城市",
        code: "320900",
        children: [
          { label: "亭湖区", code: "320902", level: "district" },
          { label: "盐都区", code: "320903", level: "district" },
          { label: "大丰区", code: "320904", level: "district" },
          { label: "响水县", code: "320921", level: "district" },
          { label: "滨海县", code: "320922", level: "district" },
          { label: "阜宁县", code: "320923", level: "district" },
          { label: "射阳县", code: "320924", level: "district" },
          { label: "建湖县", code: "320925", level: "district" },
          { label: "东台市", code: "320981", level: "district" }
        ],
        level: "city"
      },
      {
        label: "扬州市",
        code: "321000",
        children: [
          { label: "广陵区", code: "321002", level: "district" },
          { label: "邗江区", code: "321003", level: "district" },
          { label: "江都区", code: "321012", level: "district" },
          { label: "宝应县", code: "321023", level: "district" },
          { label: "仪征市", code: "321081", level: "district" },
          { label: "高邮市", code: "321084", level: "district" }
        ],
        level: "city"
      },
      {
        label: "镇江市",
        code: "321100",
        children: [
          { label: "京口区", code: "321102", level: "district" },
          { label: "润州区", code: "321111", level: "district" },
          { label: "丹徒区", code: "321112", level: "district" },
          { label: "丹阳市", code: "321181", level: "district" },
          { label: "扬中市", code: "321182", level: "district" },
          { label: "句容市", code: "321183", level: "district" }
        ],
        level: "city"
      },
      {
        label: "泰州市",
        code: "321200",
        children: [
          { label: "海陵区", code: "321202", level: "district" },
          { label: "高港区", code: "321203", level: "district" },
          { label: "姜堰区", code: "321204", level: "district" },
          { label: "兴化市", code: "321281", level: "district" },
          { label: "靖江市", code: "321282", level: "district" },
          { label: "泰兴市", code: "321283", level: "district" }
        ],
        level: "city"
      },
      {
        label: "宿迁市",
        code: "321300",
        children: [
          { label: "宿城区", code: "321302", level: "district" },
          { label: "宿豫区", code: "321311", level: "district" },
          { label: "沭阳县", code: "321322", level: "district" },
          { label: "泗阳县", code: "321323", level: "district" },
          { label: "泗洪县", code: "321324", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "浙江省",
    code: "330000",
    children: [
      {
        label: "杭州市",
        code: "330100",
        children: [
          { label: "上城区", code: "330102", level: "district" },
          { label: "拱墅区", code: "330105", level: "district" },
          { label: "西湖区", code: "330106", level: "district" },
          { label: "滨江区", code: "330108", level: "district" },
          { label: "萧山区", code: "330109", level: "district" },
          { label: "余杭区", code: "330110", level: "district" },
          { label: "富阳区", code: "330111", level: "district" },
          { label: "临安区", code: "330112", level: "district" },
          { label: "临平区", code: "330113", level: "district" },
          { label: "钱塘区", code: "330114", level: "district" },
          { label: "桐庐县", code: "330122", level: "district" },
          { label: "淳安县", code: "330127", level: "district" },
          { label: "建德市", code: "330182", level: "district" }
        ],
        level: "city"
      },
      {
        label: "宁波市",
        code: "330200",
        children: [
          { label: "海曙区", code: "330203", level: "district" },
          { label: "江北区", code: "330205", level: "district" },
          { label: "北仑区", code: "330206", level: "district" },
          { label: "镇海区", code: "330211", level: "district" },
          { label: "鄞州区", code: "330212", level: "district" },
          { label: "奉化区", code: "330213", level: "district" },
          { label: "象山县", code: "330225", level: "district" },
          { label: "宁海县", code: "330226", level: "district" },
          { label: "余姚市", code: "330281", level: "district" },
          { label: "慈溪市", code: "330282", level: "district" }
        ],
        level: "city"
      },
      {
        label: "温州市",
        code: "330300",
        children: [
          { label: "鹿城区", code: "330302", level: "district" },
          { label: "龙湾区", code: "330303", level: "district" },
          { label: "瓯海区", code: "330304", level: "district" },
          { label: "洞头区", code: "330305", level: "district" },
          { label: "永嘉县", code: "330324", level: "district" },
          { label: "平阳县", code: "330326", level: "district" },
          { label: "苍南县", code: "330327", level: "district" },
          { label: "文成县", code: "330328", level: "district" },
          { label: "泰顺县", code: "330329", level: "district" },
          { label: "瑞安市", code: "330381", level: "district" },
          { label: "乐清市", code: "330382", level: "district" },
          { label: "龙港市", code: "330383", level: "district" }
        ],
        level: "city"
      },
      {
        label: "嘉兴市",
        code: "330400",
        children: [
          { label: "南湖区", code: "330402", level: "district" },
          { label: "秀洲区", code: "330411", level: "district" },
          { label: "嘉善县", code: "330421", level: "district" },
          { label: "海盐县", code: "330424", level: "district" },
          { label: "海宁市", code: "330481", level: "district" },
          { label: "平湖市", code: "330482", level: "district" },
          { label: "桐乡市", code: "330483", level: "district" }
        ],
        level: "city"
      },
      {
        label: "湖州市",
        code: "330500",
        children: [
          { label: "吴兴区", code: "330502", level: "district" },
          { label: "南浔区", code: "330503", level: "district" },
          { label: "德清县", code: "330521", level: "district" },
          { label: "长兴县", code: "330522", level: "district" },
          { label: "安吉县", code: "330523", level: "district" }
        ],
        level: "city"
      },
      {
        label: "绍兴市",
        code: "330600",
        children: [
          { label: "越城区", code: "330602", level: "district" },
          { label: "柯桥区", code: "330603", level: "district" },
          { label: "上虞区", code: "330604", level: "district" },
          { label: "新昌县", code: "330624", level: "district" },
          { label: "诸暨市", code: "330681", level: "district" },
          { label: "嵊州市", code: "330683", level: "district" }
        ],
        level: "city"
      },
      {
        label: "金华市",
        code: "330700",
        children: [
          { label: "婺城区", code: "330702", level: "district" },
          { label: "金东区", code: "330703", level: "district" },
          { label: "武义县", code: "330723", level: "district" },
          { label: "浦江县", code: "330726", level: "district" },
          { label: "磐安县", code: "330727", level: "district" },
          { label: "兰溪市", code: "330781", level: "district" },
          { label: "义乌市", code: "330782", level: "district" },
          { label: "东阳市", code: "330783", level: "district" },
          { label: "永康市", code: "330784", level: "district" }
        ],
        level: "city"
      },
      {
        label: "衢州市",
        code: "330800",
        children: [
          { label: "柯城区", code: "330802", level: "district" },
          { label: "衢江区", code: "330803", level: "district" },
          { label: "常山县", code: "330822", level: "district" },
          { label: "开化县", code: "330824", level: "district" },
          { label: "龙游县", code: "330825", level: "district" },
          { label: "江山市", code: "330881", level: "district" }
        ],
        level: "city"
      },
      {
        label: "舟山市",
        code: "330900",
        children: [
          { label: "定海区", code: "330902", level: "district" },
          { label: "普陀区", code: "330903", level: "district" },
          { label: "岱山县", code: "330921", level: "district" },
          { label: "嵊泗县", code: "330922", level: "district" }
        ],
        level: "city"
      },
      {
        label: "台州市",
        code: "331000",
        children: [
          { label: "椒江区", code: "331002", level: "district" },
          { label: "黄岩区", code: "331003", level: "district" },
          { label: "路桥区", code: "331004", level: "district" },
          { label: "三门县", code: "331022", level: "district" },
          { label: "天台县", code: "331023", level: "district" },
          { label: "仙居县", code: "331024", level: "district" },
          { label: "温岭市", code: "331081", level: "district" },
          { label: "临海市", code: "331082", level: "district" },
          { label: "玉环市", code: "331083", level: "district" }
        ],
        level: "city"
      },
      {
        label: "丽水市",
        code: "331100",
        children: [
          { label: "莲都区", code: "331102", level: "district" },
          { label: "青田县", code: "331121", level: "district" },
          { label: "缙云县", code: "331122", level: "district" },
          { label: "遂昌县", code: "331123", level: "district" },
          { label: "松阳县", code: "331124", level: "district" },
          { label: "云和县", code: "331125", level: "district" },
          { label: "庆元县", code: "331126", level: "district" },
          { label: "景宁畲族自治县", code: "331127", level: "district" },
          { label: "龙泉市", code: "331181", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "安徽省",
    code: "340000",
    children: [
      {
        label: "合肥市",
        code: "340100",
        children: [
          { label: "瑶海区", code: "340102", level: "district" },
          { label: "庐阳区", code: "340103", level: "district" },
          { label: "蜀山区", code: "340104", level: "district" },
          { label: "包河区", code: "340111", level: "district" },
          { label: "长丰县", code: "340121", level: "district" },
          { label: "肥东县", code: "340122", level: "district" },
          { label: "肥西县", code: "340123", level: "district" },
          { label: "庐江县", code: "340124", level: "district" },
          { label: "巢湖市", code: "340181", level: "district" }
        ],
        level: "city"
      },
      {
        label: "芜湖市",
        code: "340200",
        children: [
          { label: "镜湖区", code: "340202", level: "district" },
          { label: "鸠江区", code: "340207", level: "district" },
          { label: "弋江区", code: "340209", level: "district" },
          { label: "湾沚区", code: "340210", level: "district" },
          { label: "繁昌区", code: "340212", level: "district" },
          { label: "南陵县", code: "340223", level: "district" },
          { label: "无为市", code: "340281", level: "district" }
        ],
        level: "city"
      },
      {
        label: "蚌埠市",
        code: "340300",
        children: [
          { label: "龙子湖区", code: "340302", level: "district" },
          { label: "蚌山区", code: "340303", level: "district" },
          { label: "禹会区", code: "340304", level: "district" },
          { label: "淮上区", code: "340311", level: "district" },
          { label: "怀远县", code: "340321", level: "district" },
          { label: "五河县", code: "340322", level: "district" },
          { label: "固镇县", code: "340323", level: "district" }
        ],
        level: "city"
      },
      {
        label: "淮南市",
        code: "340400",
        children: [
          { label: "大通区", code: "340402", level: "district" },
          { label: "田家庵区", code: "340403", level: "district" },
          { label: "谢家集区", code: "340404", level: "district" },
          { label: "八公山区", code: "340405", level: "district" },
          { label: "潘集区", code: "340406", level: "district" },
          { label: "凤台县", code: "340421", level: "district" },
          { label: "寿县", code: "340422", level: "district" }
        ],
        level: "city"
      },
      {
        label: "马鞍山市",
        code: "340500",
        children: [
          { label: "花山区", code: "340503", level: "district" },
          { label: "雨山区", code: "340504", level: "district" },
          { label: "博望区", code: "340506", level: "district" },
          { label: "当涂县", code: "340521", level: "district" },
          { label: "含山县", code: "340522", level: "district" },
          { label: "和县", code: "340523", level: "district" }
        ],
        level: "city"
      },
      {
        label: "淮北市",
        code: "340600",
        children: [
          { label: "杜集区", code: "340602", level: "district" },
          { label: "相山区", code: "340603", level: "district" },
          { label: "烈山区", code: "340604", level: "district" },
          { label: "濉溪县", code: "340621", level: "district" }
        ],
        level: "city"
      },
      {
        label: "铜陵市",
        code: "340700",
        children: [
          { label: "铜官区", code: "340705", level: "district" },
          { label: "义安区", code: "340706", level: "district" },
          { label: "郊区", code: "340711", level: "district" },
          { label: "枞阳县", code: "340722", level: "district" }
        ],
        level: "city"
      },
      {
        label: "安庆市",
        code: "340800",
        children: [
          { label: "迎江区", code: "340802", level: "district" },
          { label: "大观区", code: "340803", level: "district" },
          { label: "宜秀区", code: "340811", level: "district" },
          { label: "怀宁县", code: "340822", level: "district" },
          { label: "太湖县", code: "340825", level: "district" },
          { label: "宿松县", code: "340826", level: "district" },
          { label: "望江县", code: "340827", level: "district" },
          { label: "岳西县", code: "340828", level: "district" },
          { label: "桐城市", code: "340881", level: "district" },
          { label: "潜山市", code: "340882", level: "district" }
        ],
        level: "city"
      },
      {
        label: "黄山市",
        code: "341000",
        children: [
          { label: "屯溪区", code: "341002", level: "district" },
          { label: "黄山区", code: "341003", level: "district" },
          { label: "徽州区", code: "341004", level: "district" },
          { label: "歙县", code: "341021", level: "district" },
          { label: "休宁县", code: "341022", level: "district" },
          { label: "黟县", code: "341023", level: "district" },
          { label: "祁门县", code: "341024", level: "district" }
        ],
        level: "city"
      },
      {
        label: "滁州市",
        code: "341100",
        children: [
          { label: "琅琊区", code: "341102", level: "district" },
          { label: "南谯区", code: "341103", level: "district" },
          { label: "来安县", code: "341122", level: "district" },
          { label: "全椒县", code: "341124", level: "district" },
          { label: "定远县", code: "341125", level: "district" },
          { label: "凤阳县", code: "341126", level: "district" },
          { label: "天长市", code: "341181", level: "district" },
          { label: "明光市", code: "341182", level: "district" }
        ],
        level: "city"
      },
      {
        label: "阜阳市",
        code: "341200",
        children: [
          { label: "颍州区", code: "341202", level: "district" },
          { label: "颍东区", code: "341203", level: "district" },
          { label: "颍泉区", code: "341204", level: "district" },
          { label: "临泉县", code: "341221", level: "district" },
          { label: "太和县", code: "341222", level: "district" },
          { label: "阜南县", code: "341225", level: "district" },
          { label: "颍上县", code: "341226", level: "district" },
          { label: "界首市", code: "341282", level: "district" }
        ],
        level: "city"
      },
      {
        label: "宿州市",
        code: "341300",
        children: [
          { label: "埇桥区", code: "341302", level: "district" },
          { label: "砀山县", code: "341321", level: "district" },
          { label: "萧县", code: "341322", level: "district" },
          { label: "灵璧县", code: "341323", level: "district" },
          { label: "泗县", code: "341324", level: "district" }
        ],
        level: "city"
      },
      {
        label: "六安市",
        code: "341500",
        children: [
          { label: "金安区", code: "341502", level: "district" },
          { label: "裕安区", code: "341503", level: "district" },
          { label: "叶集区", code: "341504", level: "district" },
          { label: "霍邱县", code: "341522", level: "district" },
          { label: "舒城县", code: "341523", level: "district" },
          { label: "金寨县", code: "341524", level: "district" },
          { label: "霍山县", code: "341525", level: "district" }
        ],
        level: "city"
      },
      {
        label: "亳州市",
        code: "341600",
        children: [
          { label: "谯城区", code: "341602", level: "district" },
          { label: "涡阳县", code: "341621", level: "district" },
          { label: "蒙城县", code: "341622", level: "district" },
          { label: "利辛县", code: "341623", level: "district" }
        ],
        level: "city"
      },
      {
        label: "池州市",
        code: "341700",
        children: [
          { label: "贵池区", code: "341702", level: "district" },
          { label: "东至县", code: "341721", level: "district" },
          { label: "石台县", code: "341722", level: "district" },
          { label: "青阳县", code: "341723", level: "district" }
        ],
        level: "city"
      },
      {
        label: "宣城市",
        code: "341800",
        children: [
          { label: "宣州区", code: "341802", level: "district" },
          { label: "郎溪县", code: "341821", level: "district" },
          { label: "泾县", code: "341823", level: "district" },
          { label: "绩溪县", code: "341824", level: "district" },
          { label: "旌德县", code: "341825", level: "district" },
          { label: "宁国市", code: "341881", level: "district" },
          { label: "广德市", code: "341882", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "福建省",
    code: "350000",
    children: [
      {
        label: "福州市",
        code: "350100",
        children: [
          { label: "鼓楼区", code: "350102", level: "district" },
          { label: "台江区", code: "350103", level: "district" },
          { label: "仓山区", code: "350104", level: "district" },
          { label: "马尾区", code: "350105", level: "district" },
          { label: "晋安区", code: "350111", level: "district" },
          { label: "长乐区", code: "350112", level: "district" },
          { label: "闽侯县", code: "350121", level: "district" },
          { label: "连江县", code: "350122", level: "district" },
          { label: "罗源县", code: "350123", level: "district" },
          { label: "闽清县", code: "350124", level: "district" },
          { label: "永泰县", code: "350125", level: "district" },
          { label: "平潭县", code: "350128", level: "district" },
          { label: "福清市", code: "350181", level: "district" }
        ],
        level: "city"
      },
      {
        label: "厦门市",
        code: "350200",
        children: [
          { label: "思明区", code: "350203", level: "district" },
          { label: "海沧区", code: "350205", level: "district" },
          { label: "湖里区", code: "350206", level: "district" },
          { label: "集美区", code: "350211", level: "district" },
          { label: "同安区", code: "350212", level: "district" },
          { label: "翔安区", code: "350213", level: "district" }
        ],
        level: "city"
      },
      {
        label: "莆田市",
        code: "350300",
        children: [
          { label: "城厢区", code: "350302", level: "district" },
          { label: "涵江区", code: "350303", level: "district" },
          { label: "荔城区", code: "350304", level: "district" },
          { label: "秀屿区", code: "350305", level: "district" },
          { label: "仙游县", code: "350322", level: "district" }
        ],
        level: "city"
      },
      {
        label: "三明市",
        code: "350400",
        children: [
          { label: "明溪县", code: "350421", level: "district" },
          { label: "清流县", code: "350423", level: "district" },
          { label: "宁化县", code: "350424", level: "district" },
          { label: "大田县", code: "350425", level: "district" },
          { label: "尤溪县", code: "350426", level: "district" },
          { label: "将乐县", code: "350428", level: "district" },
          { label: "泰宁县", code: "350429", level: "district" },
          { label: "建宁县", code: "350430", level: "district" },
          { label: "永安市", code: "350481", level: "district" }
        ],
        level: "city"
      },
      {
        label: "泉州市",
        code: "350500",
        children: [
          { label: "鲤城区", code: "350502", level: "district" },
          { label: "丰泽区", code: "350503", level: "district" },
          { label: "洛江区", code: "350504", level: "district" },
          { label: "泉港区", code: "350505", level: "district" },
          { label: "惠安县", code: "350521", level: "district" },
          { label: "安溪县", code: "350524", level: "district" },
          { label: "永春县", code: "350525", level: "district" },
          { label: "德化县", code: "350526", level: "district" },
          { label: "金门县", code: "350527", level: "district" },
          { label: "石狮市", code: "350581", level: "district" },
          { label: "晋江市", code: "350582", level: "district" },
          { label: "南安市", code: "350583", level: "district" }
        ],
        level: "city"
      },
      {
        label: "漳州市",
        code: "350600",
        children: [
          { label: "芗城区", code: "350602", level: "district" },
          { label: "龙文区", code: "350603", level: "district" },
          { label: "云霄县", code: "350622", level: "district" },
          { label: "漳浦县", code: "350623", level: "district" },
          { label: "诏安县", code: "350624", level: "district" },
          { label: "东山县", code: "350626", level: "district" },
          { label: "南靖县", code: "350627", level: "district" },
          { label: "平和县", code: "350628", level: "district" },
          { label: "华安县", code: "350629", level: "district" }
        ],
        level: "city"
      },
      {
        label: "南平市",
        code: "350700",
        children: [
          { label: "延平区", code: "350702", level: "district" },
          { label: "建阳区", code: "350703", level: "district" },
          { label: "顺昌县", code: "350721", level: "district" },
          { label: "浦城县", code: "350722", level: "district" },
          { label: "光泽县", code: "350723", level: "district" },
          { label: "松溪县", code: "350724", level: "district" },
          { label: "政和县", code: "350725", level: "district" },
          { label: "邵武市", code: "350781", level: "district" },
          { label: "武夷山市", code: "350782", level: "district" },
          { label: "建瓯市", code: "350783", level: "district" }
        ],
        level: "city"
      },
      {
        label: "龙岩市",
        code: "350800",
        children: [
          { label: "新罗区", code: "350802", level: "district" },
          { label: "永定区", code: "350803", level: "district" },
          { label: "长汀县", code: "350821", level: "district" },
          { label: "上杭县", code: "350823", level: "district" },
          { label: "武平县", code: "350824", level: "district" },
          { label: "连城县", code: "350825", level: "district" },
          { label: "漳平市", code: "350881", level: "district" }
        ],
        level: "city"
      },
      {
        label: "宁德市",
        code: "350900",
        children: [
          { label: "蕉城区", code: "350902", level: "district" },
          { label: "霞浦县", code: "350921", level: "district" },
          { label: "古田县", code: "350922", level: "district" },
          { label: "屏南县", code: "350923", level: "district" },
          { label: "寿宁县", code: "350924", level: "district" },
          { label: "周宁县", code: "350925", level: "district" },
          { label: "柘荣县", code: "350926", level: "district" },
          { label: "福安市", code: "350981", level: "district" },
          { label: "福鼎市", code: "350982", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "江西省",
    code: "360000",
    children: [
      {
        label: "南昌市",
        code: "360100",
        children: [
          { label: "东湖区", code: "360102", level: "district" },
          { label: "西湖区", code: "360103", level: "district" },
          { label: "青云谱区", code: "360104", level: "district" },
          { label: "青山湖区", code: "360111", level: "district" },
          { label: "新建区", code: "360112", level: "district" },
          { label: "红谷滩区", code: "360113", level: "district" },
          { label: "南昌县", code: "360121", level: "district" },
          { label: "安义县", code: "360123", level: "district" },
          { label: "进贤县", code: "360124", level: "district" }
        ],
        level: "city"
      },
      {
        label: "景德镇市",
        code: "360200",
        children: [
          { label: "昌江区", code: "360202", level: "district" },
          { label: "珠山区", code: "360203", level: "district" },
          { label: "浮梁县", code: "360222", level: "district" },
          { label: "乐平市", code: "360281", level: "district" }
        ],
        level: "city"
      },
      {
        label: "萍乡市",
        code: "360300",
        children: [
          { label: "安源区", code: "360302", level: "district" },
          { label: "湘东区", code: "360313", level: "district" },
          { label: "莲花县", code: "360321", level: "district" },
          { label: "上栗县", code: "360322", level: "district" },
          { label: "芦溪县", code: "360323", level: "district" }
        ],
        level: "city"
      },
      {
        label: "九江市",
        code: "360400",
        children: [
          { label: "濂溪区", code: "360402", level: "district" },
          { label: "浔阳区", code: "360403", level: "district" },
          { label: "柴桑区", code: "360404", level: "district" },
          { label: "武宁县", code: "360423", level: "district" },
          { label: "修水县", code: "360424", level: "district" },
          { label: "永修县", code: "360425", level: "district" },
          { label: "德安县", code: "360426", level: "district" },
          { label: "都昌县", code: "360428", level: "district" },
          { label: "湖口县", code: "360429", level: "district" },
          { label: "彭泽县", code: "360430", level: "district" },
          { label: "瑞昌市", code: "360481", level: "district" },
          { label: "共青城市", code: "360482", level: "district" },
          { label: "庐山市", code: "360483", level: "district" }
        ],
        level: "city"
      },
      {
        label: "新余市",
        code: "360500",
        children: [
          { label: "渝水区", code: "360502", level: "district" },
          { label: "分宜县", code: "360521", level: "district" }
        ],
        level: "city"
      },
      {
        label: "鹰潭市",
        code: "360600",
        children: [
          { label: "月湖区", code: "360602", level: "district" },
          { label: "余江区", code: "360603", level: "district" },
          { label: "贵溪市", code: "360681", level: "district" }
        ],
        level: "city"
      },
      {
        label: "赣州市",
        code: "360700",
        children: [
          { label: "章贡区", code: "360702", level: "district" },
          { label: "南康区", code: "360703", level: "district" },
          { label: "赣县区", code: "360704", level: "district" },
          { label: "信丰县", code: "360722", level: "district" },
          { label: "大余县", code: "360723", level: "district" },
          { label: "上犹县", code: "360724", level: "district" },
          { label: "崇义县", code: "360725", level: "district" },
          { label: "安远县", code: "360726", level: "district" },
          { label: "定南县", code: "360728", level: "district" },
          { label: "全南县", code: "360729", level: "district" },
          { label: "宁都县", code: "360730", level: "district" },
          { label: "于都县", code: "360731", level: "district" },
          { label: "兴国县", code: "360732", level: "district" },
          { label: "会昌县", code: "360733", level: "district" },
          { label: "寻乌县", code: "360734", level: "district" },
          { label: "石城县", code: "360735", level: "district" },
          { label: "瑞金市", code: "360781", level: "district" },
          { label: "龙南市", code: "360783", level: "district" }
        ],
        level: "city"
      },
      {
        label: "吉安市",
        code: "360800",
        children: [
          { label: "吉州区", code: "360802", level: "district" },
          { label: "青原区", code: "360803", level: "district" },
          { label: "吉安县", code: "360821", level: "district" },
          { label: "吉水县", code: "360822", level: "district" },
          { label: "峡江县", code: "360823", level: "district" },
          { label: "新干县", code: "360824", level: "district" },
          { label: "永丰县", code: "360825", level: "district" },
          { label: "泰和县", code: "360826", level: "district" },
          { label: "遂川县", code: "360827", level: "district" },
          { label: "万安县", code: "360828", level: "district" },
          { label: "安福县", code: "360829", level: "district" },
          { label: "永新县", code: "360830", level: "district" },
          { label: "井冈山市", code: "360881", level: "district" }
        ],
        level: "city"
      },
      {
        label: "宜春市",
        code: "360900",
        children: [
          { label: "袁州区", code: "360902", level: "district" },
          { label: "奉新县", code: "360921", level: "district" },
          { label: "万载县", code: "360922", level: "district" },
          { label: "上高县", code: "360923", level: "district" },
          { label: "宜丰县", code: "360924", level: "district" },
          { label: "靖安县", code: "360925", level: "district" },
          { label: "铜鼓县", code: "360926", level: "district" },
          { label: "丰城市", code: "360981", level: "district" },
          { label: "樟树市", code: "360982", level: "district" },
          { label: "高安市", code: "360983", level: "district" }
        ],
        level: "city"
      },
      {
        label: "抚州市",
        code: "361000",
        children: [
          { label: "临川区", code: "361002", level: "district" },
          { label: "东乡区", code: "361003", level: "district" },
          { label: "南城县", code: "361021", level: "district" },
          { label: "黎川县", code: "361022", level: "district" },
          { label: "南丰县", code: "361023", level: "district" },
          { label: "崇仁县", code: "361024", level: "district" },
          { label: "乐安县", code: "361025", level: "district" },
          { label: "宜黄县", code: "361026", level: "district" },
          { label: "金溪县", code: "361027", level: "district" },
          { label: "资溪县", code: "361028", level: "district" },
          { label: "广昌县", code: "361030", level: "district" }
        ],
        level: "city"
      },
      {
        label: "上饶市",
        code: "361100",
        children: [
          { label: "信州区", code: "361102", level: "district" },
          { label: "广丰区", code: "361103", level: "district" },
          { label: "广信区", code: "361104", level: "district" },
          { label: "玉山县", code: "361123", level: "district" },
          { label: "铅山县", code: "361124", level: "district" },
          { label: "横峰县", code: "361125", level: "district" },
          { label: "弋阳县", code: "361126", level: "district" },
          { label: "余干县", code: "361127", level: "district" },
          { label: "鄱阳县", code: "361128", level: "district" },
          { label: "万年县", code: "361129", level: "district" },
          { label: "婺源县", code: "361130", level: "district" },
          { label: "德兴市", code: "361181", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "山东省",
    code: "370000",
    children: [
      {
        label: "济南市",
        code: "370100",
        children: [
          { label: "历下区", code: "370102", level: "district" },
          { label: "市中区", code: "370103", level: "district" },
          { label: "槐荫区", code: "370104", level: "district" },
          { label: "天桥区", code: "370105", level: "district" },
          { label: "历城区", code: "370112", level: "district" },
          { label: "长清区", code: "370113", level: "district" },
          { label: "章丘区", code: "370114", level: "district" },
          { label: "济阳区", code: "370115", level: "district" },
          { label: "莱芜区", code: "370116", level: "district" },
          { label: "钢城区", code: "370117", level: "district" },
          { label: "平阴县", code: "370124", level: "district" },
          { label: "商河县", code: "370126", level: "district" }
        ],
        level: "city"
      },
      {
        label: "青岛市",
        code: "370200",
        children: [
          { label: "市南区", code: "370202", level: "district" },
          { label: "市北区", code: "370203", level: "district" },
          { label: "黄岛区", code: "370211", level: "district" },
          { label: "崂山区", code: "370212", level: "district" },
          { label: "李沧区", code: "370213", level: "district" },
          { label: "城阳区", code: "370214", level: "district" },
          { label: "即墨区", code: "370215", level: "district" },
          { label: "胶州市", code: "370281", level: "district" },
          { label: "平度市", code: "370283", level: "district" },
          { label: "莱西市", code: "370285", level: "district" }
        ],
        level: "city"
      },
      {
        label: "淄博市",
        code: "370300",
        children: [
          { label: "淄川区", code: "370302", level: "district" },
          { label: "张店区", code: "370303", level: "district" },
          { label: "博山区", code: "370304", level: "district" },
          { label: "临淄区", code: "370305", level: "district" },
          { label: "周村区", code: "370306", level: "district" },
          { label: "桓台县", code: "370321", level: "district" },
          { label: "高青县", code: "370322", level: "district" },
          { label: "沂源县", code: "370323", level: "district" }
        ],
        level: "city"
      },
      {
        label: "枣庄市",
        code: "370400",
        children: [
          { label: "市中区", code: "370402", level: "district" },
          { label: "薛城区", code: "370403", level: "district" },
          { label: "峄城区", code: "370404", level: "district" },
          { label: "台儿庄区", code: "370405", level: "district" },
          { label: "山亭区", code: "370406", level: "district" },
          { label: "滕州市", code: "370481", level: "district" }
        ],
        level: "city"
      },
      {
        label: "东营市",
        code: "370500",
        children: [
          { label: "东营区", code: "370502", level: "district" },
          { label: "河口区", code: "370503", level: "district" },
          { label: "垦利区", code: "370505", level: "district" },
          { label: "利津县", code: "370522", level: "district" },
          { label: "广饶县", code: "370523", level: "district" }
        ],
        level: "city"
      },
      {
        label: "烟台市",
        code: "370600",
        children: [
          { label: "芝罘区", code: "370602", level: "district" },
          { label: "福山区", code: "370611", level: "district" },
          { label: "牟平区", code: "370612", level: "district" },
          { label: "莱山区", code: "370613", level: "district" },
          { label: "龙口市", code: "370681", level: "district" },
          { label: "莱阳市", code: "370682", level: "district" },
          { label: "莱州市", code: "370683", level: "district" },
          { label: "招远市", code: "370685", level: "district" },
          { label: "栖霞市", code: "370686", level: "district" },
          { label: "海阳市", code: "370687", level: "district" }
        ],
        level: "city"
      },
      {
        label: "潍坊市",
        code: "370700",
        children: [
          { label: "潍城区", code: "370702", level: "district" },
          { label: "寒亭区", code: "370703", level: "district" },
          { label: "坊子区", code: "370704", level: "district" },
          { label: "奎文区", code: "370705", level: "district" },
          { label: "临朐县", code: "370724", level: "district" },
          { label: "昌乐县", code: "370725", level: "district" },
          { label: "青州市", code: "370781", level: "district" },
          { label: "诸城市", code: "370782", level: "district" },
          { label: "寿光市", code: "370783", level: "district" },
          { label: "安丘市", code: "370784", level: "district" },
          { label: "高密市", code: "370785", level: "district" },
          { label: "昌邑市", code: "370786", level: "district" }
        ],
        level: "city"
      },
      {
        label: "济宁市",
        code: "370800",
        children: [
          { label: "任城区", code: "370811", level: "district" },
          { label: "兖州区", code: "370812", level: "district" },
          { label: "微山县", code: "370826", level: "district" },
          { label: "鱼台县", code: "370827", level: "district" },
          { label: "金乡县", code: "370828", level: "district" },
          { label: "嘉祥县", code: "370829", level: "district" },
          { label: "汶上县", code: "370830", level: "district" },
          { label: "泗水县", code: "370831", level: "district" },
          { label: "梁山县", code: "370832", level: "district" },
          { label: "曲阜市", code: "370881", level: "district" },
          { label: "邹城市", code: "370883", level: "district" }
        ],
        level: "city"
      },
      {
        label: "泰安市",
        code: "370900",
        children: [
          { label: "泰山区", code: "370902", level: "district" },
          { label: "岱岳区", code: "370911", level: "district" },
          { label: "宁阳县", code: "370921", level: "district" },
          { label: "东平县", code: "370923", level: "district" },
          { label: "新泰市", code: "370982", level: "district" },
          { label: "肥城市", code: "370983", level: "district" }
        ],
        level: "city"
      },
      {
        label: "威海市",
        code: "371000",
        children: [
          { label: "环翠区", code: "371002", level: "district" },
          { label: "文登区", code: "371003", level: "district" },
          { label: "荣成市", code: "371082", level: "district" },
          { label: "乳山市", code: "371083", level: "district" }
        ],
        level: "city"
      },
      {
        label: "日照市",
        code: "371100",
        children: [
          { label: "东港区", code: "371102", level: "district" },
          { label: "岚山区", code: "371103", level: "district" },
          { label: "五莲县", code: "371121", level: "district" },
          { label: "莒县", code: "371122", level: "district" }
        ],
        level: "city"
      },
      {
        label: "临沂市",
        code: "371300",
        children: [
          { label: "兰山区", code: "371302", level: "district" },
          { label: "罗庄区", code: "371311", level: "district" },
          { label: "河东区", code: "371312", level: "district" },
          { label: "沂南县", code: "371321", level: "district" },
          { label: "郯城县", code: "371322", level: "district" },
          { label: "沂水县", code: "371323", level: "district" },
          { label: "兰陵县", code: "371324", level: "district" },
          { label: "费县", code: "371325", level: "district" },
          { label: "平邑县", code: "371326", level: "district" },
          { label: "莒南县", code: "371327", level: "district" },
          { label: "蒙阴县", code: "371328", level: "district" },
          { label: "临沭县", code: "371329", level: "district" }
        ],
        level: "city"
      },
      {
        label: "德州市",
        code: "371400",
        children: [
          { label: "德城区", code: "371402", level: "district" },
          { label: "陵城区", code: "371403", level: "district" },
          { label: "宁津县", code: "371422", level: "district" },
          { label: "庆云县", code: "371423", level: "district" },
          { label: "临邑县", code: "371424", level: "district" },
          { label: "齐河县", code: "371425", level: "district" },
          { label: "平原县", code: "371426", level: "district" },
          { label: "夏津县", code: "371427", level: "district" },
          { label: "武城县", code: "371428", level: "district" },
          { label: "乐陵市", code: "371481", level: "district" },
          { label: "禹城市", code: "371482", level: "district" }
        ],
        level: "city"
      },
      {
        label: "聊城市",
        code: "371500",
        children: [
          { label: "东昌府区", code: "371502", level: "district" },
          { label: "茌平区", code: "371503", level: "district" },
          { label: "阳谷县", code: "371521", level: "district" },
          { label: "莘县", code: "371522", level: "district" },
          { label: "东阿县", code: "371524", level: "district" },
          { label: "冠县", code: "371525", level: "district" },
          { label: "高唐县", code: "371526", level: "district" },
          { label: "临清市", code: "371581", level: "district" }
        ],
        level: "city"
      },
      {
        label: "滨州市",
        code: "371600",
        children: [
          { label: "滨城区", code: "371602", level: "district" },
          { label: "沾化区", code: "371603", level: "district" },
          { label: "惠民县", code: "371621", level: "district" },
          { label: "阳信县", code: "371622", level: "district" },
          { label: "无棣县", code: "371623", level: "district" },
          { label: "博兴县", code: "371625", level: "district" }
        ],
        level: "city"
      },
      {
        label: "菏泽市",
        code: "371700",
        children: [
          { label: "牡丹区", code: "371702", level: "district" },
          { label: "定陶区", code: "371703", level: "district" },
          { label: "曹县", code: "371721", level: "district" },
          { label: "单县", code: "371722", level: "district" },
          { label: "成武县", code: "371723", level: "district" },
          { label: "巨野县", code: "371724", level: "district" },
          { label: "郓城县", code: "371725", level: "district" },
          { label: "鄄城县", code: "371726", level: "district" },
          { label: "东明县", code: "371728", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "河南省",
    code: "410000",
    children: [
      {
        label: "郑州市",
        code: "410100",
        children: [
          { label: "中原区", code: "410102", level: "district" },
          { label: "二七区", code: "410103", level: "district" },
          { label: "管城回族区", code: "410104", level: "district" },
          { label: "金水区", code: "410105", level: "district" },
          { label: "上街区", code: "410106", level: "district" },
          { label: "惠济区", code: "410108", level: "district" },
          { label: "中牟县", code: "410122", level: "district" },
          { label: "巩义市", code: "410181", level: "district" },
          { label: "荥阳市", code: "410182", level: "district" },
          { label: "新密市", code: "410183", level: "district" },
          { label: "新郑市", code: "410184", level: "district" },
          { label: "登封市", code: "410185", level: "district" }
        ],
        level: "city"
      },
      {
        label: "开封市",
        code: "410200",
        children: [
          { label: "龙亭区", code: "410202", level: "district" },
          { label: "顺河回族区", code: "410203", level: "district" },
          { label: "鼓楼区", code: "410204", level: "district" },
          { label: "禹王台区", code: "410205", level: "district" },
          { label: "祥符区", code: "410212", level: "district" },
          { label: "杞县", code: "410221", level: "district" },
          { label: "通许县", code: "410222", level: "district" },
          { label: "尉氏县", code: "410223", level: "district" },
          { label: "兰考县", code: "410225", level: "district" }
        ],
        level: "city"
      },
      {
        label: "洛阳市",
        code: "410300",
        children: [
          { label: "老城区", code: "410302", level: "district" },
          { label: "西工区", code: "410303", level: "district" },
          { label: "瀍河回族区", code: "410304", level: "district" },
          { label: "涧西区", code: "410305", level: "district" },
          { label: "洛龙区", code: "410311", level: "district" },
          { label: "新安县", code: "410323", level: "district" },
          { label: "栾川县", code: "410324", level: "district" },
          { label: "嵩县", code: "410325", level: "district" },
          { label: "汝阳县", code: "410326", level: "district" },
          { label: "宜阳县", code: "410327", level: "district" },
          { label: "洛宁县", code: "410328", level: "district" },
          { label: "伊川县", code: "410329", level: "district" }
        ],
        level: "city"
      },
      {
        label: "平顶山市",
        code: "410400",
        children: [
          { label: "新华区", code: "410402", level: "district" },
          { label: "卫东区", code: "410403", level: "district" },
          { label: "石龙区", code: "410404", level: "district" },
          { label: "湛河区", code: "410411", level: "district" },
          { label: "宝丰县", code: "410421", level: "district" },
          { label: "叶县", code: "410422", level: "district" },
          { label: "鲁山县", code: "410423", level: "district" },
          { label: "郏县", code: "410425", level: "district" },
          { label: "舞钢市", code: "410481", level: "district" },
          { label: "汝州市", code: "410482", level: "district" }
        ],
        level: "city"
      },
      {
        label: "安阳市",
        code: "410500",
        children: [
          { label: "文峰区", code: "410502", level: "district" },
          { label: "北关区", code: "410503", level: "district" },
          { label: "殷都区", code: "410505", level: "district" },
          { label: "龙安区", code: "410506", level: "district" },
          { label: "安阳县", code: "410522", level: "district" },
          { label: "汤阴县", code: "410523", level: "district" },
          { label: "滑县", code: "410526", level: "district" },
          { label: "内黄县", code: "410527", level: "district" },
          { label: "林州市", code: "410581", level: "district" }
        ],
        level: "city"
      },
      {
        label: "鹤壁市",
        code: "410600",
        children: [
          { label: "鹤山区", code: "410602", level: "district" },
          { label: "山城区", code: "410603", level: "district" },
          { label: "淇滨区", code: "410611", level: "district" },
          { label: "浚县", code: "410621", level: "district" },
          { label: "淇县", code: "410622", level: "district" }
        ],
        level: "city"
      },
      {
        label: "新乡市",
        code: "410700",
        children: [
          { label: "红旗区", code: "410702", level: "district" },
          { label: "卫滨区", code: "410703", level: "district" },
          { label: "凤泉区", code: "410704", level: "district" },
          { label: "牧野区", code: "410711", level: "district" },
          { label: "新乡县", code: "410721", level: "district" },
          { label: "获嘉县", code: "410724", level: "district" },
          { label: "原阳县", code: "410725", level: "district" },
          { label: "延津县", code: "410726", level: "district" },
          { label: "封丘县", code: "410727", level: "district" },
          { label: "卫辉市", code: "410781", level: "district" },
          { label: "辉县市", code: "410782", level: "district" },
          { label: "长垣市", code: "410783", level: "district" }
        ],
        level: "city"
      },
      {
        label: "焦作市",
        code: "410800",
        children: [
          { label: "解放区", code: "410802", level: "district" },
          { label: "中站区", code: "410803", level: "district" },
          { label: "马村区", code: "410804", level: "district" },
          { label: "山阳区", code: "410811", level: "district" },
          { label: "修武县", code: "410821", level: "district" },
          { label: "博爱县", code: "410822", level: "district" },
          { label: "武陟县", code: "410823", level: "district" },
          { label: "温县", code: "410825", level: "district" },
          { label: "沁阳市", code: "410882", level: "district" },
          { label: "孟州市", code: "410883", level: "district" }
        ],
        level: "city"
      },
      {
        label: "濮阳市",
        code: "410900",
        children: [
          { label: "华龙区", code: "410902", level: "district" },
          { label: "清丰县", code: "410922", level: "district" },
          { label: "南乐县", code: "410923", level: "district" },
          { label: "范县", code: "410926", level: "district" },
          { label: "台前县", code: "410927", level: "district" },
          { label: "濮阳县", code: "410928", level: "district" }
        ],
        level: "city"
      },
      {
        label: "许昌市",
        code: "411000",
        children: [
          { label: "魏都区", code: "411002", level: "district" },
          { label: "建安区", code: "411003", level: "district" },
          { label: "鄢陵县", code: "411024", level: "district" },
          { label: "襄城县", code: "411025", level: "district" },
          { label: "禹州市", code: "411081", level: "district" },
          { label: "长葛市", code: "411082", level: "district" }
        ],
        level: "city"
      },
      {
        label: "漯河市",
        code: "411100",
        children: [
          { label: "源汇区", code: "411102", level: "district" },
          { label: "郾城区", code: "411103", level: "district" },
          { label: "召陵区", code: "411104", level: "district" },
          { label: "舞阳县", code: "411121", level: "district" },
          { label: "临颍县", code: "411122", level: "district" }
        ],
        level: "city"
      },
      {
        label: "三门峡市",
        code: "411200",
        children: [
          { label: "湖滨区", code: "411202", level: "district" },
          { label: "陕州区", code: "411203", level: "district" },
          { label: "渑池县", code: "411221", level: "district" },
          { label: "卢氏县", code: "411224", level: "district" },
          { label: "义马市", code: "411281", level: "district" },
          { label: "灵宝市", code: "411282", level: "district" }
        ],
        level: "city"
      },
      {
        label: "南阳市",
        code: "411300",
        children: [
          { label: "宛城区", code: "411302", level: "district" },
          { label: "卧龙区", code: "411303", level: "district" },
          { label: "南召县", code: "411321", level: "district" },
          { label: "方城县", code: "411322", level: "district" },
          { label: "西峡县", code: "411323", level: "district" },
          { label: "镇平县", code: "411324", level: "district" },
          { label: "内乡县", code: "411325", level: "district" },
          { label: "淅川县", code: "411326", level: "district" },
          { label: "社旗县", code: "411327", level: "district" },
          { label: "唐河县", code: "411328", level: "district" },
          { label: "新野县", code: "411329", level: "district" },
          { label: "桐柏县", code: "411330", level: "district" },
          { label: "邓州市", code: "411381", level: "district" }
        ],
        level: "city"
      },
      {
        label: "商丘市",
        code: "411400",
        children: [
          { label: "梁园区", code: "411402", level: "district" },
          { label: "睢阳区", code: "411403", level: "district" },
          { label: "民权县", code: "411421", level: "district" },
          { label: "睢县", code: "411422", level: "district" },
          { label: "宁陵县", code: "411423", level: "district" },
          { label: "柘城县", code: "411424", level: "district" },
          { label: "虞城县", code: "411425", level: "district" },
          { label: "夏邑县", code: "411426", level: "district" },
          { label: "永城市", code: "411481", level: "district" }
        ],
        level: "city"
      },
      {
        label: "信阳市",
        code: "411500",
        children: [
          { label: "浉河区", code: "411502", level: "district" },
          { label: "平桥区", code: "411503", level: "district" },
          { label: "罗山县", code: "411521", level: "district" },
          { label: "光山县", code: "411522", level: "district" },
          { label: "新县", code: "411523", level: "district" },
          { label: "商城县", code: "411524", level: "district" },
          { label: "固始县", code: "411525", level: "district" },
          { label: "潢川县", code: "411526", level: "district" },
          { label: "淮滨县", code: "411527", level: "district" },
          { label: "息县", code: "411528", level: "district" }
        ],
        level: "city"
      },
      {
        label: "周口市",
        code: "411600",
        children: [
          { label: "川汇区", code: "411602", level: "district" },
          { label: "淮阳区", code: "411603", level: "district" },
          { label: "扶沟县", code: "411621", level: "district" },
          { label: "西华县", code: "411622", level: "district" },
          { label: "商水县", code: "411623", level: "district" },
          { label: "沈丘县", code: "411624", level: "district" },
          { label: "郸城县", code: "411625", level: "district" },
          { label: "太康县", code: "411627", level: "district" },
          { label: "鹿邑县", code: "411628", level: "district" },
          { label: "项城市", code: "411681", level: "district" }
        ],
        level: "city"
      },
      {
        label: "驻马店市",
        code: "411700",
        children: [
          { label: "驿城区", code: "411702", level: "district" },
          { label: "西平县", code: "411721", level: "district" },
          { label: "上蔡县", code: "411722", level: "district" },
          { label: "平舆县", code: "411723", level: "district" },
          { label: "正阳县", code: "411724", level: "district" },
          { label: "确山县", code: "411725", level: "district" },
          { label: "泌阳县", code: "411726", level: "district" },
          { label: "汝南县", code: "411727", level: "district" },
          { label: "遂平县", code: "411728", level: "district" },
          { label: "新蔡县", code: "411729", level: "district" }
        ],
        level: "city"
      },
      {
        label: "省直辖县",
        code: "419000",
        children: [{ label: "济源市", code: "419001", level: "district" }],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "湖北省",
    code: "420000",
    children: [
      {
        label: "武汉市",
        code: "420100",
        children: [
          { label: "江岸区", code: "420102", level: "district" },
          { label: "江汉区", code: "420103", level: "district" },
          { label: "硚口区", code: "420104", level: "district" },
          { label: "汉阳区", code: "420105", level: "district" },
          { label: "武昌区", code: "420106", level: "district" },
          { label: "青山区", code: "420107", level: "district" },
          { label: "洪山区", code: "420111", level: "district" },
          { label: "东西湖区", code: "420112", level: "district" },
          { label: "汉南区", code: "420113", level: "district" },
          { label: "蔡甸区", code: "420114", level: "district" },
          { label: "江夏区", code: "420115", level: "district" },
          { label: "黄陂区", code: "420116", level: "district" },
          { label: "新洲区", code: "420117", level: "district" }
        ],
        level: "city"
      },
      {
        label: "黄石市",
        code: "420200",
        children: [
          { label: "黄石港区", code: "420202", level: "district" },
          { label: "西塞山区", code: "420203", level: "district" },
          { label: "下陆区", code: "420204", level: "district" },
          { label: "铁山区", code: "420205", level: "district" },
          { label: "阳新县", code: "420222", level: "district" },
          { label: "大冶市", code: "420281", level: "district" }
        ],
        level: "city"
      },
      {
        label: "十堰市",
        code: "420300",
        children: [
          { label: "茅箭区", code: "420302", level: "district" },
          { label: "张湾区", code: "420303", level: "district" },
          { label: "郧阳区", code: "420304", level: "district" },
          { label: "郧西县", code: "420322", level: "district" },
          { label: "竹山县", code: "420323", level: "district" },
          { label: "竹溪县", code: "420324", level: "district" },
          { label: "房县", code: "420325", level: "district" },
          { label: "丹江口市", code: "420381", level: "district" }
        ],
        level: "city"
      },
      {
        label: "宜昌市",
        code: "420500",
        children: [
          { label: "西陵区", code: "420502", level: "district" },
          { label: "伍家岗区", code: "420503", level: "district" },
          { label: "点军区", code: "420504", level: "district" },
          { label: "猇亭区", code: "420505", level: "district" },
          { label: "夷陵区", code: "420506", level: "district" },
          { label: "远安县", code: "420525", level: "district" },
          { label: "兴山县", code: "420526", level: "district" },
          { label: "秭归县", code: "420527", level: "district" },
          { label: "长阳土家族自治县", code: "420528", level: "district" },
          { label: "五峰土家族自治县", code: "420529", level: "district" },
          { label: "宜都市", code: "420581", level: "district" },
          { label: "当阳市", code: "420582", level: "district" },
          { label: "枝江市", code: "420583", level: "district" }
        ],
        level: "city"
      },
      {
        label: "襄阳市",
        code: "420600",
        children: [
          { label: "襄城区", code: "420602", level: "district" },
          { label: "樊城区", code: "420606", level: "district" },
          { label: "襄州区", code: "420607", level: "district" },
          { label: "南漳县", code: "420624", level: "district" },
          { label: "谷城县", code: "420625", level: "district" },
          { label: "保康县", code: "420626", level: "district" },
          { label: "老河口市", code: "420682", level: "district" },
          { label: "枣阳市", code: "420683", level: "district" },
          { label: "宜城市", code: "420684", level: "district" }
        ],
        level: "city"
      },
      {
        label: "鄂州市",
        code: "420700",
        children: [
          { label: "梁子湖区", code: "420702", level: "district" },
          { label: "华容区", code: "420703", level: "district" },
          { label: "鄂城区", code: "420704", level: "district" }
        ],
        level: "city"
      },
      {
        label: "荆门市",
        code: "420800",
        children: [
          { label: "东宝区", code: "420802", level: "district" },
          { label: "掇刀区", code: "420804", level: "district" },
          { label: "沙洋县", code: "420822", level: "district" },
          { label: "钟祥市", code: "420881", level: "district" },
          { label: "京山市", code: "420882", level: "district" }
        ],
        level: "city"
      },
      {
        label: "孝感市",
        code: "420900",
        children: [
          { label: "孝南区", code: "420902", level: "district" },
          { label: "孝昌县", code: "420921", level: "district" },
          { label: "大悟县", code: "420922", level: "district" },
          { label: "云梦县", code: "420923", level: "district" },
          { label: "应城市", code: "420981", level: "district" },
          { label: "安陆市", code: "420982", level: "district" },
          { label: "汉川市", code: "420984", level: "district" }
        ],
        level: "city"
      },
      {
        label: "荆州市",
        code: "421000",
        children: [
          { label: "沙市区", code: "421002", level: "district" },
          { label: "荆州区", code: "421003", level: "district" },
          { label: "公安县", code: "421022", level: "district" },
          { label: "江陵县", code: "421024", level: "district" },
          { label: "石首市", code: "421081", level: "district" },
          { label: "洪湖市", code: "421083", level: "district" },
          { label: "松滋市", code: "421087", level: "district" }
        ],
        level: "city"
      },
      {
        label: "黄冈市",
        code: "421100",
        children: [
          { label: "黄州区", code: "421102", level: "district" },
          { label: "团风县", code: "421121", level: "district" },
          { label: "红安县", code: "421122", level: "district" },
          { label: "罗田县", code: "421123", level: "district" },
          { label: "英山县", code: "421124", level: "district" },
          { label: "浠水县", code: "421125", level: "district" },
          { label: "蕲春县", code: "421126", level: "district" },
          { label: "黄梅县", code: "421127", level: "district" },
          { label: "麻城市", code: "421181", level: "district" },
          { label: "武穴市", code: "421182", level: "district" }
        ],
        level: "city"
      },
      {
        label: "咸宁市",
        code: "421200",
        children: [
          { label: "咸安区", code: "421202", level: "district" },
          { label: "嘉鱼县", code: "421221", level: "district" },
          { label: "通城县", code: "421222", level: "district" },
          { label: "崇阳县", code: "421223", level: "district" },
          { label: "通山县", code: "421224", level: "district" },
          { label: "赤壁市", code: "421281", level: "district" }
        ],
        level: "city"
      },
      {
        label: "随州市",
        code: "421300",
        children: [
          { label: "曾都区", code: "421303", level: "district" },
          { label: "随县", code: "421321", level: "district" },
          { label: "广水市", code: "421381", level: "district" }
        ],
        level: "city"
      },
      {
        label: "恩施土家族苗族自治州",
        code: "422800",
        children: [
          { label: "恩施市", code: "422801", level: "district" },
          { label: "利川市", code: "422802", level: "district" },
          { label: "建始县", code: "422822", level: "district" },
          { label: "巴东县", code: "422823", level: "district" },
          { label: "宣恩县", code: "422825", level: "district" },
          { label: "咸丰县", code: "422826", level: "district" },
          { label: "来凤县", code: "422827", level: "district" },
          { label: "鹤峰县", code: "422828", level: "district" }
        ],
        level: "city"
      },
      {
        label: "省直辖县",
        code: "429000",
        children: [
          { label: "仙桃市", code: "429004", level: "district" },
          { label: "潜江市", code: "429005", level: "district" },
          { label: "天门市", code: "429006", level: "district" },
          { label: "神农架林区", code: "429021", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "湖南省",
    code: "430000",
    children: [
      {
        label: "长沙市",
        code: "430100",
        children: [
          { label: "芙蓉区", code: "430102", level: "district" },
          { label: "天心区", code: "430103", level: "district" },
          { label: "岳麓区", code: "430104", level: "district" },
          { label: "开福区", code: "430105", level: "district" },
          { label: "雨花区", code: "430111", level: "district" },
          { label: "望城区", code: "430112", level: "district" },
          { label: "长沙县", code: "430121", level: "district" },
          { label: "浏阳市", code: "430181", level: "district" },
          { label: "宁乡市", code: "430182", level: "district" }
        ],
        level: "city"
      },
      {
        label: "株洲市",
        code: "430200",
        children: [
          { label: "荷塘区", code: "430202", level: "district" },
          { label: "芦淞区", code: "430203", level: "district" },
          { label: "石峰区", code: "430204", level: "district" },
          { label: "天元区", code: "430211", level: "district" },
          { label: "渌口区", code: "430212", level: "district" },
          { label: "攸县", code: "430223", level: "district" },
          { label: "茶陵县", code: "430224", level: "district" },
          { label: "炎陵县", code: "430225", level: "district" },
          { label: "醴陵市", code: "430281", level: "district" }
        ],
        level: "city"
      },
      {
        label: "湘潭市",
        code: "430300",
        children: [
          { label: "雨湖区", code: "430302", level: "district" },
          { label: "岳塘区", code: "430304", level: "district" },
          { label: "湘潭县", code: "430321", level: "district" },
          { label: "湘乡市", code: "430381", level: "district" },
          { label: "韶山市", code: "430382", level: "district" }
        ],
        level: "city"
      },
      {
        label: "衡阳市",
        code: "430400",
        children: [
          { label: "珠晖区", code: "430405", level: "district" },
          { label: "雁峰区", code: "430406", level: "district" },
          { label: "石鼓区", code: "430407", level: "district" },
          { label: "蒸湘区", code: "430408", level: "district" },
          { label: "南岳区", code: "430412", level: "district" },
          { label: "衡阳县", code: "430421", level: "district" },
          { label: "衡南县", code: "430422", level: "district" },
          { label: "衡山县", code: "430423", level: "district" },
          { label: "衡东县", code: "430424", level: "district" },
          { label: "祁东县", code: "430426", level: "district" },
          { label: "耒阳市", code: "430481", level: "district" },
          { label: "常宁市", code: "430482", level: "district" }
        ],
        level: "city"
      },
      {
        label: "邵阳市",
        code: "430500",
        children: [
          { label: "双清区", code: "430502", level: "district" },
          { label: "大祥区", code: "430503", level: "district" },
          { label: "北塔区", code: "430511", level: "district" },
          { label: "新邵县", code: "430522", level: "district" },
          { label: "邵阳县", code: "430523", level: "district" },
          { label: "隆回县", code: "430524", level: "district" },
          { label: "洞口县", code: "430525", level: "district" },
          { label: "绥宁县", code: "430527", level: "district" },
          { label: "新宁县", code: "430528", level: "district" },
          { label: "城步苗族自治县", code: "430529", level: "district" },
          { label: "武冈市", code: "430581", level: "district" },
          { label: "邵东市", code: "430582", level: "district" }
        ],
        level: "city"
      },
      {
        label: "岳阳市",
        code: "430600",
        children: [
          { label: "岳阳楼区", code: "430602", level: "district" },
          { label: "云溪区", code: "430603", level: "district" },
          { label: "君山区", code: "430611", level: "district" },
          { label: "岳阳县", code: "430621", level: "district" },
          { label: "华容县", code: "430623", level: "district" },
          { label: "湘阴县", code: "430624", level: "district" },
          { label: "平江县", code: "430626", level: "district" },
          { label: "汨罗市", code: "430681", level: "district" },
          { label: "临湘市", code: "430682", level: "district" }
        ],
        level: "city"
      },
      {
        label: "常德市",
        code: "430700",
        children: [
          { label: "武陵区", code: "430702", level: "district" },
          { label: "鼎城区", code: "430703", level: "district" },
          { label: "安乡县", code: "430721", level: "district" },
          { label: "汉寿县", code: "430722", level: "district" },
          { label: "澧县", code: "430723", level: "district" },
          { label: "临澧县", code: "430724", level: "district" },
          { label: "桃源县", code: "430725", level: "district" },
          { label: "石门县", code: "430726", level: "district" },
          { label: "津市市", code: "430781", level: "district" }
        ],
        level: "city"
      },
      {
        label: "张家界市",
        code: "430800",
        children: [
          { label: "永定区", code: "430802", level: "district" },
          { label: "武陵源区", code: "430811", level: "district" },
          { label: "慈利县", code: "430821", level: "district" },
          { label: "桑植县", code: "430822", level: "district" }
        ],
        level: "city"
      },
      {
        label: "益阳市",
        code: "430900",
        children: [
          { label: "资阳区", code: "430902", level: "district" },
          { label: "赫山区", code: "430903", level: "district" },
          { label: "南县", code: "430921", level: "district" },
          { label: "桃江县", code: "430922", level: "district" },
          { label: "安化县", code: "430923", level: "district" },
          { label: "沅江市", code: "430981", level: "district" }
        ],
        level: "city"
      },
      {
        label: "郴州市",
        code: "431000",
        children: [
          { label: "北湖区", code: "431002", level: "district" },
          { label: "苏仙区", code: "431003", level: "district" },
          { label: "桂阳县", code: "431021", level: "district" },
          { label: "宜章县", code: "431022", level: "district" },
          { label: "永兴县", code: "431023", level: "district" },
          { label: "嘉禾县", code: "431024", level: "district" },
          { label: "临武县", code: "431025", level: "district" },
          { label: "汝城县", code: "431026", level: "district" },
          { label: "桂东县", code: "431027", level: "district" },
          { label: "安仁县", code: "431028", level: "district" },
          { label: "资兴市", code: "431081", level: "district" }
        ],
        level: "city"
      },
      {
        label: "永州市",
        code: "431100",
        children: [
          { label: "零陵区", code: "431102", level: "district" },
          { label: "冷水滩区", code: "431103", level: "district" },
          { label: "东安县", code: "431122", level: "district" },
          { label: "双牌县", code: "431123", level: "district" },
          { label: "道县", code: "431124", level: "district" },
          { label: "江永县", code: "431125", level: "district" },
          { label: "宁远县", code: "431126", level: "district" },
          { label: "蓝山县", code: "431127", level: "district" },
          { label: "新田县", code: "431128", level: "district" },
          { label: "江华瑶族自治县", code: "431129", level: "district" }
        ],
        level: "city"
      },
      {
        label: "怀化市",
        code: "431200",
        children: [
          { label: "鹤城区", code: "431202", level: "district" },
          { label: "中方县", code: "431221", level: "district" },
          { label: "沅陵县", code: "431222", level: "district" },
          { label: "辰溪县", code: "431223", level: "district" },
          { label: "溆浦县", code: "431224", level: "district" },
          { label: "会同县", code: "431225", level: "district" },
          { label: "麻阳苗族自治县", code: "431226", level: "district" },
          { label: "新晃侗族自治县", code: "431227", level: "district" },
          { label: "芷江侗族自治县", code: "431228", level: "district" },
          { label: "靖州苗族侗族自治县", code: "431229", level: "district" },
          { label: "通道侗族自治县", code: "431230", level: "district" },
          { label: "洪江市", code: "431281", level: "district" }
        ],
        level: "city"
      },
      {
        label: "娄底市",
        code: "431300",
        children: [
          { label: "娄星区", code: "431302", level: "district" },
          { label: "双峰县", code: "431321", level: "district" },
          { label: "新化县", code: "431322", level: "district" },
          { label: "冷水江市", code: "431381", level: "district" },
          { label: "涟源市", code: "431382", level: "district" }
        ],
        level: "city"
      },
      {
        label: "湘西土家族苗族自治州",
        code: "433100",
        children: [
          { label: "吉首市", code: "433101", level: "district" },
          { label: "泸溪县", code: "433122", level: "district" },
          { label: "凤凰县", code: "433123", level: "district" },
          { label: "花垣县", code: "433124", level: "district" },
          { label: "保靖县", code: "433125", level: "district" },
          { label: "古丈县", code: "433126", level: "district" },
          { label: "永顺县", code: "433127", level: "district" },
          { label: "龙山县", code: "433130", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "广东省",
    code: "440000",
    children: [
      {
        label: "广州市",
        code: "440100",
        children: [
          { label: "荔湾区", code: "440103", level: "district" },
          { label: "越秀区", code: "440104", level: "district" },
          { label: "海珠区", code: "440105", level: "district" },
          { label: "天河区", code: "440106", level: "district" },
          { label: "白云区", code: "440111", level: "district" },
          { label: "黄埔区", code: "440112", level: "district" },
          { label: "番禺区", code: "440113", level: "district" },
          { label: "花都区", code: "440114", level: "district" },
          { label: "南沙区", code: "440115", level: "district" },
          { label: "从化区", code: "440117", level: "district" },
          { label: "增城区", code: "440118", level: "district" }
        ],
        level: "city"
      },
      {
        label: "韶关市",
        code: "440200",
        children: [
          { label: "武江区", code: "440203", level: "district" },
          { label: "浈江区", code: "440204", level: "district" },
          { label: "曲江区", code: "440205", level: "district" },
          { label: "始兴县", code: "440222", level: "district" },
          { label: "仁化县", code: "440224", level: "district" },
          { label: "翁源县", code: "440229", level: "district" },
          { label: "乳源瑶族自治县", code: "440232", level: "district" },
          { label: "新丰县", code: "440233", level: "district" },
          { label: "乐昌市", code: "440281", level: "district" },
          { label: "南雄市", code: "440282", level: "district" }
        ],
        level: "city"
      },
      {
        label: "深圳市",
        code: "440300",
        children: [
          { label: "罗湖区", code: "440303", level: "district" },
          { label: "福田区", code: "440304", level: "district" },
          { label: "南山区", code: "440305", level: "district" },
          { label: "宝安区", code: "440306", level: "district" },
          { label: "龙岗区", code: "440307", level: "district" },
          { label: "盐田区", code: "440308", level: "district" },
          { label: "龙华区", code: "440309", level: "district" },
          { label: "坪山区", code: "440310", level: "district" },
          { label: "光明区", code: "440311", level: "district" }
        ],
        level: "city"
      },
      {
        label: "珠海市",
        code: "440400",
        children: [
          { label: "香洲区", code: "440402", level: "district" },
          { label: "斗门区", code: "440403", level: "district" },
          { label: "金湾区", code: "440404", level: "district" }
        ],
        level: "city"
      },
      {
        label: "汕头市",
        code: "440500",
        children: [
          { label: "龙湖区", code: "440507", level: "district" },
          { label: "金平区", code: "440511", level: "district" },
          { label: "濠江区", code: "440512", level: "district" },
          { label: "潮阳区", code: "440513", level: "district" },
          { label: "潮南区", code: "440514", level: "district" },
          { label: "澄海区", code: "440515", level: "district" },
          { label: "南澳县", code: "440523", level: "district" }
        ],
        level: "city"
      },
      {
        label: "佛山市",
        code: "440600",
        children: [
          { label: "禅城区", code: "440604", level: "district" },
          { label: "南海区", code: "440605", level: "district" },
          { label: "顺德区", code: "440606", level: "district" },
          { label: "三水区", code: "440607", level: "district" },
          { label: "高明区", code: "440608", level: "district" }
        ],
        level: "city"
      },
      {
        label: "江门市",
        code: "440700",
        children: [
          { label: "蓬江区", code: "440703", level: "district" },
          { label: "江海区", code: "440704", level: "district" },
          { label: "新会区", code: "440705", level: "district" },
          { label: "台山市", code: "440781", level: "district" },
          { label: "开平市", code: "440783", level: "district" },
          { label: "鹤山市", code: "440784", level: "district" },
          { label: "恩平市", code: "440785", level: "district" }
        ],
        level: "city"
      },
      {
        label: "湛江市",
        code: "440800",
        children: [
          { label: "赤坎区", code: "440802", level: "district" },
          { label: "霞山区", code: "440803", level: "district" },
          { label: "坡头区", code: "440804", level: "district" },
          { label: "麻章区", code: "440811", level: "district" },
          { label: "遂溪县", code: "440823", level: "district" },
          { label: "徐闻县", code: "440825", level: "district" },
          { label: "廉江市", code: "440881", level: "district" },
          { label: "雷州市", code: "440882", level: "district" },
          { label: "吴川市", code: "440883", level: "district" }
        ],
        level: "city"
      },
      {
        label: "茂名市",
        code: "440900",
        children: [
          { label: "茂南区", code: "440902", level: "district" },
          { label: "电白区", code: "440904", level: "district" },
          { label: "高州市", code: "440981", level: "district" },
          { label: "化州市", code: "440982", level: "district" },
          { label: "信宜市", code: "440983", level: "district" }
        ],
        level: "city"
      },
      {
        label: "肇庆市",
        code: "441200",
        children: [
          { label: "端州区", code: "441202", level: "district" },
          { label: "鼎湖区", code: "441203", level: "district" },
          { label: "高要区", code: "441204", level: "district" },
          { label: "广宁县", code: "441223", level: "district" },
          { label: "怀集县", code: "441224", level: "district" },
          { label: "封开县", code: "441225", level: "district" },
          { label: "德庆县", code: "441226", level: "district" },
          { label: "四会市", code: "441284", level: "district" }
        ],
        level: "city"
      },
      {
        label: "惠州市",
        code: "441300",
        children: [
          { label: "惠城区", code: "441302", level: "district" },
          { label: "惠阳区", code: "441303", level: "district" },
          { label: "博罗县", code: "441322", level: "district" },
          { label: "惠东县", code: "441323", level: "district" },
          { label: "龙门县", code: "441324", level: "district" }
        ],
        level: "city"
      },
      {
        label: "梅州市",
        code: "441400",
        children: [
          { label: "梅江区", code: "441402", level: "district" },
          { label: "梅县区", code: "441403", level: "district" },
          { label: "大埔县", code: "441422", level: "district" },
          { label: "丰顺县", code: "441423", level: "district" },
          { label: "五华县", code: "441424", level: "district" },
          { label: "平远县", code: "441426", level: "district" },
          { label: "蕉岭县", code: "441427", level: "district" },
          { label: "兴宁市", code: "441481", level: "district" }
        ],
        level: "city"
      },
      {
        label: "汕尾市",
        code: "441500",
        children: [
          { label: "城区", code: "441502", level: "district" },
          { label: "海丰县", code: "441521", level: "district" },
          { label: "陆河县", code: "441523", level: "district" },
          { label: "陆丰市", code: "441581", level: "district" }
        ],
        level: "city"
      },
      {
        label: "河源市",
        code: "441600",
        children: [
          { label: "源城区", code: "441602", level: "district" },
          { label: "紫金县", code: "441621", level: "district" },
          { label: "龙川县", code: "441622", level: "district" },
          { label: "连平县", code: "441623", level: "district" },
          { label: "和平县", code: "441624", level: "district" },
          { label: "东源县", code: "441625", level: "district" }
        ],
        level: "city"
      },
      {
        label: "阳江市",
        code: "441700",
        children: [
          { label: "江城区", code: "441702", level: "district" },
          { label: "阳东区", code: "441704", level: "district" },
          { label: "阳西县", code: "441721", level: "district" },
          { label: "阳春市", code: "441781", level: "district" }
        ],
        level: "city"
      },
      {
        label: "清远市",
        code: "441800",
        children: [
          { label: "清城区", code: "441802", level: "district" },
          { label: "清新区", code: "441803", level: "district" },
          { label: "佛冈县", code: "441821", level: "district" },
          { label: "阳山县", code: "441823", level: "district" },
          { label: "连山壮族瑶族自治县", code: "441825", level: "district" },
          { label: "连南瑶族自治县", code: "441826", level: "district" },
          { label: "英德市", code: "441881", level: "district" },
          { label: "连州市", code: "441882", level: "district" }
        ],
        level: "city"
      },
      { label: "东莞市", code: "441900", children: [], level: "city" },
      { label: "中山市", code: "442000", children: [], level: "city" },
      {
        label: "潮州市",
        code: "445100",
        children: [
          { label: "湘桥区", code: "445102", level: "district" },
          { label: "潮安区", code: "445103", level: "district" },
          { label: "饶平县", code: "445122", level: "district" }
        ],
        level: "city"
      },
      {
        label: "揭阳市",
        code: "445200",
        children: [
          { label: "榕城区", code: "445202", level: "district" },
          { label: "揭东区", code: "445203", level: "district" },
          { label: "揭西县", code: "445222", level: "district" },
          { label: "惠来县", code: "445224", level: "district" },
          { label: "普宁市", code: "445281", level: "district" }
        ],
        level: "city"
      },
      {
        label: "云浮市",
        code: "445300",
        children: [
          { label: "云城区", code: "445302", level: "district" },
          { label: "云安区", code: "445303", level: "district" },
          { label: "新兴县", code: "445321", level: "district" },
          { label: "郁南县", code: "445322", level: "district" },
          { label: "罗定市", code: "445381", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "广西壮族自治区",
    code: "450000",
    children: [
      {
        label: "南宁市",
        code: "450100",
        children: [
          { label: "兴宁区", code: "450102", level: "district" },
          { label: "青秀区", code: "450103", level: "district" },
          { label: "江南区", code: "450105", level: "district" },
          { label: "西乡塘区", code: "450107", level: "district" },
          { label: "良庆区", code: "450108", level: "district" },
          { label: "邕宁区", code: "450109", level: "district" },
          { label: "武鸣区", code: "450110", level: "district" },
          { label: "隆安县", code: "450123", level: "district" },
          { label: "马山县", code: "450124", level: "district" },
          { label: "上林县", code: "450125", level: "district" },
          { label: "宾阳县", code: "450126", level: "district" }
        ],
        level: "city"
      },
      {
        label: "柳州市",
        code: "450200",
        children: [
          { label: "城中区", code: "450202", level: "district" },
          { label: "鱼峰区", code: "450203", level: "district" },
          { label: "柳南区", code: "450204", level: "district" },
          { label: "柳北区", code: "450205", level: "district" },
          { label: "柳江区", code: "450206", level: "district" },
          { label: "柳城县", code: "450222", level: "district" },
          { label: "鹿寨县", code: "450223", level: "district" },
          { label: "融安县", code: "450224", level: "district" },
          { label: "融水苗族自治县", code: "450225", level: "district" },
          { label: "三江侗族自治县", code: "450226", level: "district" }
        ],
        level: "city"
      },
      {
        label: "桂林市",
        code: "450300",
        children: [
          { label: "秀峰区", code: "450302", level: "district" },
          { label: "叠彩区", code: "450303", level: "district" },
          { label: "象山区", code: "450304", level: "district" },
          { label: "七星区", code: "450305", level: "district" },
          { label: "雁山区", code: "450311", level: "district" },
          { label: "临桂区", code: "450312", level: "district" },
          { label: "阳朔县", code: "450321", level: "district" },
          { label: "灵川县", code: "450323", level: "district" },
          { label: "全州县", code: "450324", level: "district" },
          { label: "兴安县", code: "450325", level: "district" },
          { label: "永福县", code: "450326", level: "district" },
          { label: "灌阳县", code: "450327", level: "district" },
          { label: "龙胜各族自治县", code: "450328", level: "district" },
          { label: "资源县", code: "450329", level: "district" },
          { label: "平乐县", code: "450330", level: "district" },
          { label: "恭城瑶族自治县", code: "450332", level: "district" },
          { label: "荔浦市", code: "450381", level: "district" }
        ],
        level: "city"
      },
      {
        label: "梧州市",
        code: "450400",
        children: [
          { label: "万秀区", code: "450403", level: "district" },
          { label: "长洲区", code: "450405", level: "district" },
          { label: "龙圩区", code: "450406", level: "district" },
          { label: "苍梧县", code: "450421", level: "district" },
          { label: "藤县", code: "450422", level: "district" },
          { label: "蒙山县", code: "450423", level: "district" },
          { label: "岑溪市", code: "450481", level: "district" }
        ],
        level: "city"
      },
      {
        label: "北海市",
        code: "450500",
        children: [
          { label: "海城区", code: "450502", level: "district" },
          { label: "银海区", code: "450503", level: "district" },
          { label: "铁山港区", code: "450512", level: "district" },
          { label: "合浦县", code: "450521", level: "district" }
        ],
        level: "city"
      },
      {
        label: "防城港市",
        code: "450600",
        children: [
          { label: "港口区", code: "450602", level: "district" },
          { label: "防城区", code: "450603", level: "district" },
          { label: "上思县", code: "450621", level: "district" },
          { label: "东兴市", code: "450681", level: "district" }
        ],
        level: "city"
      },
      {
        label: "钦州市",
        code: "450700",
        children: [
          { label: "钦南区", code: "450702", level: "district" },
          { label: "钦北区", code: "450703", level: "district" },
          { label: "灵山县", code: "450721", level: "district" },
          { label: "浦北县", code: "450722", level: "district" }
        ],
        level: "city"
      },
      {
        label: "贵港市",
        code: "450800",
        children: [
          { label: "港北区", code: "450802", level: "district" },
          { label: "港南区", code: "450803", level: "district" },
          { label: "覃塘区", code: "450804", level: "district" },
          { label: "平南县", code: "450821", level: "district" },
          { label: "桂平市", code: "450881", level: "district" }
        ],
        level: "city"
      },
      {
        label: "玉林市",
        code: "450900",
        children: [
          { label: "玉州区", code: "450902", level: "district" },
          { label: "福绵区", code: "450903", level: "district" },
          { label: "容县", code: "450921", level: "district" },
          { label: "陆川县", code: "450922", level: "district" },
          { label: "博白县", code: "450923", level: "district" },
          { label: "兴业县", code: "450924", level: "district" },
          { label: "北流市", code: "450981", level: "district" }
        ],
        level: "city"
      },
      {
        label: "百色市",
        code: "451000",
        children: [
          { label: "右江区", code: "451002", level: "district" },
          { label: "田阳区", code: "451003", level: "district" },
          { label: "田东县", code: "451022", level: "district" },
          { label: "德保县", code: "451024", level: "district" },
          { label: "那坡县", code: "451026", level: "district" },
          { label: "凌云县", code: "451027", level: "district" },
          { label: "乐业县", code: "451028", level: "district" },
          { label: "田林县", code: "451029", level: "district" },
          { label: "西林县", code: "451030", level: "district" },
          { label: "隆林各族自治县", code: "451031", level: "district" },
          { label: "靖西市", code: "451081", level: "district" },
          { label: "平果市", code: "451082", level: "district" }
        ],
        level: "city"
      },
      {
        label: "贺州市",
        code: "451100",
        children: [
          { label: "八步区", code: "451102", level: "district" },
          { label: "平桂区", code: "451103", level: "district" },
          { label: "昭平县", code: "451121", level: "district" },
          { label: "钟山县", code: "451122", level: "district" },
          { label: "富川瑶族自治县", code: "451123", level: "district" }
        ],
        level: "city"
      },
      {
        label: "河池市",
        code: "451200",
        children: [
          { label: "金城江区", code: "451202", level: "district" },
          { label: "宜州区", code: "451203", level: "district" },
          { label: "南丹县", code: "451221", level: "district" },
          { label: "天峨县", code: "451222", level: "district" },
          { label: "凤山县", code: "451223", level: "district" },
          { label: "东兰县", code: "451224", level: "district" },
          { label: "罗城仫佬族自治县", code: "451225", level: "district" },
          { label: "环江毛南族自治县", code: "451226", level: "district" },
          { label: "巴马瑶族自治县", code: "451227", level: "district" },
          { label: "都安瑶族自治县", code: "451228", level: "district" },
          { label: "大化瑶族自治县", code: "451229", level: "district" }
        ],
        level: "city"
      },
      {
        label: "来宾市",
        code: "451300",
        children: [
          { label: "兴宾区", code: "451302", level: "district" },
          { label: "忻城县", code: "451321", level: "district" },
          { label: "象州县", code: "451322", level: "district" },
          { label: "武宣县", code: "451323", level: "district" },
          { label: "金秀瑶族自治县", code: "451324", level: "district" },
          { label: "合山市", code: "451381", level: "district" }
        ],
        level: "city"
      },
      {
        label: "崇左市",
        code: "451400",
        children: [
          { label: "江州区", code: "451402", level: "district" },
          { label: "扶绥县", code: "451421", level: "district" },
          { label: "宁明县", code: "451422", level: "district" },
          { label: "龙州县", code: "451423", level: "district" },
          { label: "大新县", code: "451424", level: "district" },
          { label: "天等县", code: "451425", level: "district" },
          { label: "凭祥市", code: "451481", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "海南省",
    code: "460000",
    children: [
      {
        label: "海口市",
        code: "460100",
        children: [
          { label: "秀英区", code: "460105", level: "district" },
          { label: "龙华区", code: "460106", level: "district" },
          { label: "琼山区", code: "460107", level: "district" },
          { label: "美兰区", code: "460108", level: "district" }
        ],
        level: "city"
      },
      {
        label: "三亚市",
        code: "460200",
        children: [
          { label: "海棠区", code: "460202", level: "district" },
          { label: "吉阳区", code: "460203", level: "district" },
          { label: "天涯区", code: "460204", level: "district" },
          { label: "崖州区", code: "460205", level: "district" }
        ],
        level: "city"
      },
      { label: "三沙市", code: "460300", children: [], level: "city" },
      { label: "儋州市", code: "460400", children: [], level: "city" },
      {
        label: "省直辖县",
        code: "469000",
        children: [
          { label: "五指山市", code: "469001", level: "district" },
          { label: "琼海市", code: "469002", level: "district" },
          { label: "文昌市", code: "469005", level: "district" },
          { label: "万宁市", code: "469006", level: "district" },
          { label: "东方市", code: "469007", level: "district" },
          { label: "定安县", code: "469021", level: "district" },
          { label: "屯昌县", code: "469022", level: "district" },
          { label: "澄迈县", code: "469023", level: "district" },
          { label: "临高县", code: "469024", level: "district" },
          { label: "白沙黎族自治县", code: "469025", level: "district" },
          { label: "昌江黎族自治县", code: "469026", level: "district" },
          { label: "乐东黎族自治县", code: "469027", level: "district" },
          { label: "陵水黎族自治县", code: "469028", level: "district" },
          { label: "保亭黎族苗族自治县", code: "469029", level: "district" },
          { label: "琼中黎族苗族自治县", code: "469030", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "重庆市",
    code: "500000",
    children: [
      {
        label: "重庆市",
        code: "500100",
        children: [
          { label: "万州区", code: "500101", level: "district" },
          { label: "涪陵区", code: "500102", level: "district" },
          { label: "渝中区", code: "500103", level: "district" },
          { label: "大渡口区", code: "500104", level: "district" },
          { label: "江北区", code: "500105", level: "district" },
          { label: "沙坪坝区", code: "500106", level: "district" },
          { label: "九龙坡区", code: "500107", level: "district" },
          { label: "南岸区", code: "500108", level: "district" },
          { label: "北碚区", code: "500109", level: "district" },
          { label: "綦江区", code: "500110", level: "district" },
          { label: "大足区", code: "500111", level: "district" },
          { label: "渝北区", code: "500112", level: "district" },
          { label: "巴南区", code: "500113", level: "district" },
          { label: "黔江区", code: "500114", level: "district" },
          { label: "长寿区", code: "500115", level: "district" },
          { label: "江津区", code: "500116", level: "district" },
          { label: "合川区", code: "500117", level: "district" },
          { label: "永川区", code: "500118", level: "district" },
          { label: "南川区", code: "500119", level: "district" },
          { label: "璧山区", code: "500120", level: "district" },
          { label: "铜梁区", code: "500151", level: "district" },
          { label: "潼南区", code: "500152", level: "district" },
          { label: "荣昌区", code: "500153", level: "district" },
          { label: "开州区", code: "500154", level: "district" },
          { label: "梁平区", code: "500155", level: "district" },
          { label: "武隆区", code: "500156", level: "district" }
        ],
        level: "city"
      },
      {
        label: "县",
        code: "500200",
        children: [
          { label: "城口县", code: "500229", level: "district" },
          { label: "丰都县", code: "500230", level: "district" },
          { label: "垫江县", code: "500231", level: "district" },
          { label: "忠县", code: "500233", level: "district" },
          { label: "云阳县", code: "500235", level: "district" },
          { label: "奉节县", code: "500236", level: "district" },
          { label: "巫山县", code: "500237", level: "district" },
          { label: "巫溪县", code: "500238", level: "district" },
          { label: "石柱土家族自治县", code: "500240", level: "district" },
          { label: "秀山土家族苗族自治县", code: "500241", level: "district" },
          { label: "酉阳土家族苗族自治县", code: "500242", level: "district" },
          { label: "彭水苗族土家族自治县", code: "500243", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "四川省",
    code: "510000",
    children: [
      {
        label: "成都市",
        code: "510100",
        children: [
          { label: "锦江区", code: "510104", level: "district" },
          { label: "青羊区", code: "510105", level: "district" },
          { label: "金牛区", code: "510106", level: "district" },
          { label: "武侯区", code: "510107", level: "district" },
          { label: "成华区", code: "510108", level: "district" },
          { label: "龙泉驿区", code: "510112", level: "district" },
          { label: "青白江区", code: "510113", level: "district" },
          { label: "新都区", code: "510114", level: "district" },
          { label: "温江区", code: "510115", level: "district" },
          { label: "双流区", code: "510116", level: "district" },
          { label: "郫都区", code: "510117", level: "district" },
          { label: "金堂县", code: "510121", level: "district" },
          { label: "大邑县", code: "510129", level: "district" },
          { label: "蒲江县", code: "510131", level: "district" },
          { label: "都江堰市", code: "510181", level: "district" },
          { label: "彭州市", code: "510182", level: "district" },
          { label: "邛崃市", code: "510183", level: "district" },
          { label: "崇州市", code: "510184", level: "district" },
          { label: "简阳市", code: "510185", level: "district" }
        ],
        level: "city"
      },
      {
        label: "自贡市",
        code: "510300",
        children: [
          { label: "自流井区", code: "510302", level: "district" },
          { label: "贡井区", code: "510303", level: "district" },
          { label: "大安区", code: "510304", level: "district" },
          { label: "沿滩区", code: "510311", level: "district" },
          { label: "荣县", code: "510321", level: "district" },
          { label: "富顺县", code: "510322", level: "district" }
        ],
        level: "city"
      },
      {
        label: "攀枝花市",
        code: "510400",
        children: [
          { label: "东区", code: "510402", level: "district" },
          { label: "西区", code: "510403", level: "district" },
          { label: "仁和区", code: "510411", level: "district" },
          { label: "米易县", code: "510421", level: "district" },
          { label: "盐边县", code: "510422", level: "district" }
        ],
        level: "city"
      },
      {
        label: "泸州市",
        code: "510500",
        children: [
          { label: "江阳区", code: "510502", level: "district" },
          { label: "纳溪区", code: "510503", level: "district" },
          { label: "龙马潭区", code: "510504", level: "district" },
          { label: "泸县", code: "510521", level: "district" },
          { label: "合江县", code: "510522", level: "district" },
          { label: "叙永县", code: "510524", level: "district" },
          { label: "古蔺县", code: "510525", level: "district" }
        ],
        level: "city"
      },
      {
        label: "德阳市",
        code: "510600",
        children: [
          { label: "旌阳区", code: "510603", level: "district" },
          { label: "罗江区", code: "510604", level: "district" },
          { label: "中江县", code: "510623", level: "district" },
          { label: "广汉市", code: "510681", level: "district" },
          { label: "什邡市", code: "510682", level: "district" },
          { label: "绵竹市", code: "510683", level: "district" }
        ],
        level: "city"
      },
      {
        label: "绵阳市",
        code: "510700",
        children: [
          { label: "涪城区", code: "510703", level: "district" },
          { label: "游仙区", code: "510704", level: "district" },
          { label: "安州区", code: "510705", level: "district" },
          { label: "三台县", code: "510722", level: "district" },
          { label: "盐亭县", code: "510723", level: "district" },
          { label: "梓潼县", code: "510725", level: "district" },
          { label: "北川羌族自治县", code: "510726", level: "district" },
          { label: "平武县", code: "510727", level: "district" },
          { label: "江油市", code: "510781", level: "district" }
        ],
        level: "city"
      },
      {
        label: "广元市",
        code: "510800",
        children: [
          { label: "利州区", code: "510802", level: "district" },
          { label: "昭化区", code: "510811", level: "district" },
          { label: "朝天区", code: "510812", level: "district" },
          { label: "旺苍县", code: "510821", level: "district" },
          { label: "青川县", code: "510822", level: "district" },
          { label: "剑阁县", code: "510823", level: "district" },
          { label: "苍溪县", code: "510824", level: "district" }
        ],
        level: "city"
      },
      {
        label: "遂宁市",
        code: "510900",
        children: [
          { label: "船山区", code: "510903", level: "district" },
          { label: "安居区", code: "510904", level: "district" },
          { label: "蓬溪县", code: "510921", level: "district" },
          { label: "大英县", code: "510923", level: "district" },
          { label: "射洪市", code: "510981", level: "district" }
        ],
        level: "city"
      },
      {
        label: "内江市",
        code: "511000",
        children: [
          { label: "市中区", code: "511002", level: "district" },
          { label: "东兴区", code: "511011", level: "district" },
          { label: "威远县", code: "511024", level: "district" },
          { label: "资中县", code: "511025", level: "district" },
          { label: "隆昌市", code: "511083", level: "district" }
        ],
        level: "city"
      },
      {
        label: "乐山市",
        code: "511100",
        children: [
          { label: "市中区", code: "511102", level: "district" },
          { label: "沙湾区", code: "511111", level: "district" },
          { label: "五通桥区", code: "511112", level: "district" },
          { label: "金口河区", code: "511113", level: "district" },
          { label: "犍为县", code: "511123", level: "district" },
          { label: "井研县", code: "511124", level: "district" },
          { label: "夹江县", code: "511126", level: "district" },
          { label: "沐川县", code: "511129", level: "district" },
          { label: "峨边彝族自治县", code: "511132", level: "district" },
          { label: "马边彝族自治县", code: "511133", level: "district" },
          { label: "峨眉山市", code: "511181", level: "district" }
        ],
        level: "city"
      },
      {
        label: "南充市",
        code: "511300",
        children: [
          { label: "顺庆区", code: "511302", level: "district" },
          { label: "高坪区", code: "511303", level: "district" },
          { label: "嘉陵区", code: "511304", level: "district" },
          { label: "南部县", code: "511321", level: "district" },
          { label: "营山县", code: "511322", level: "district" },
          { label: "蓬安县", code: "511323", level: "district" },
          { label: "仪陇县", code: "511324", level: "district" },
          { label: "西充县", code: "511325", level: "district" },
          { label: "阆中市", code: "511381", level: "district" }
        ],
        level: "city"
      },
      {
        label: "眉山市",
        code: "511400",
        children: [
          { label: "东坡区", code: "511402", level: "district" },
          { label: "彭山区", code: "511403", level: "district" },
          { label: "仁寿县", code: "511421", level: "district" },
          { label: "洪雅县", code: "511423", level: "district" },
          { label: "丹棱县", code: "511424", level: "district" },
          { label: "青神县", code: "511425", level: "district" }
        ],
        level: "city"
      },
      {
        label: "宜宾市",
        code: "511500",
        children: [
          { label: "翠屏区", code: "511502", level: "district" },
          { label: "南溪区", code: "511503", level: "district" },
          { label: "叙州区", code: "511504", level: "district" },
          { label: "江安县", code: "511523", level: "district" },
          { label: "长宁县", code: "511524", level: "district" },
          { label: "高县", code: "511525", level: "district" },
          { label: "珙县", code: "511526", level: "district" },
          { label: "筠连县", code: "511527", level: "district" },
          { label: "兴文县", code: "511528", level: "district" },
          { label: "屏山县", code: "511529", level: "district" }
        ],
        level: "city"
      },
      {
        label: "广安市",
        code: "511600",
        children: [
          { label: "广安区", code: "511602", level: "district" },
          { label: "前锋区", code: "511603", level: "district" },
          { label: "岳池县", code: "511621", level: "district" },
          { label: "武胜县", code: "511622", level: "district" },
          { label: "邻水县", code: "511623", level: "district" },
          { label: "华蓥市", code: "511681", level: "district" }
        ],
        level: "city"
      },
      {
        label: "达州市",
        code: "511700",
        children: [
          { label: "通川区", code: "511702", level: "district" },
          { label: "达川区", code: "511703", level: "district" },
          { label: "宣汉县", code: "511722", level: "district" },
          { label: "开江县", code: "511723", level: "district" },
          { label: "大竹县", code: "511724", level: "district" },
          { label: "渠县", code: "511725", level: "district" },
          { label: "万源市", code: "511781", level: "district" }
        ],
        level: "city"
      },
      {
        label: "雅安市",
        code: "511800",
        children: [
          { label: "雨城区", code: "511802", level: "district" },
          { label: "名山区", code: "511803", level: "district" },
          { label: "荥经县", code: "511822", level: "district" },
          { label: "汉源县", code: "511823", level: "district" },
          { label: "石棉县", code: "511824", level: "district" },
          { label: "天全县", code: "511825", level: "district" },
          { label: "芦山县", code: "511826", level: "district" },
          { label: "宝兴县", code: "511827", level: "district" }
        ],
        level: "city"
      },
      {
        label: "巴中市",
        code: "511900",
        children: [
          { label: "巴州区", code: "511902", level: "district" },
          { label: "恩阳区", code: "511903", level: "district" },
          { label: "通江县", code: "511921", level: "district" },
          { label: "南江县", code: "511922", level: "district" },
          { label: "平昌县", code: "511923", level: "district" }
        ],
        level: "city"
      },
      {
        label: "资阳市",
        code: "512000",
        children: [
          { label: "雁江区", code: "512002", level: "district" },
          { label: "安岳县", code: "512021", level: "district" },
          { label: "乐至县", code: "512022", level: "district" }
        ],
        level: "city"
      },
      {
        label: "阿坝藏族羌族自治州",
        code: "513200",
        children: [
          { label: "马尔康市", code: "513201", level: "district" },
          { label: "汶川县", code: "513221", level: "district" },
          { label: "理县", code: "513222", level: "district" },
          { label: "茂县", code: "513223", level: "district" },
          { label: "松潘县", code: "513224", level: "district" },
          { label: "九寨沟县", code: "513225", level: "district" },
          { label: "金川县", code: "513226", level: "district" },
          { label: "小金县", code: "513227", level: "district" },
          { label: "黑水县", code: "513228", level: "district" },
          { label: "壤塘县", code: "513230", level: "district" },
          { label: "阿坝县", code: "513231", level: "district" },
          { label: "若尔盖县", code: "513232", level: "district" },
          { label: "红原县", code: "513233", level: "district" }
        ],
        level: "city"
      },
      {
        label: "甘孜藏族自治州",
        code: "513300",
        children: [
          { label: "康定市", code: "513301", level: "district" },
          { label: "泸定县", code: "513322", level: "district" },
          { label: "丹巴县", code: "513323", level: "district" },
          { label: "九龙县", code: "513324", level: "district" },
          { label: "雅江县", code: "513325", level: "district" },
          { label: "道孚县", code: "513326", level: "district" },
          { label: "炉霍县", code: "513327", level: "district" },
          { label: "甘孜县", code: "513328", level: "district" },
          { label: "新龙县", code: "513329", level: "district" },
          { label: "德格县", code: "513330", level: "district" },
          { label: "白玉县", code: "513331", level: "district" },
          { label: "石渠县", code: "513332", level: "district" },
          { label: "色达县", code: "513333", level: "district" },
          { label: "理塘县", code: "513334", level: "district" },
          { label: "巴塘县", code: "513335", level: "district" },
          { label: "乡城县", code: "513336", level: "district" },
          { label: "稻城县", code: "513337", level: "district" },
          { label: "得荣县", code: "513338", level: "district" }
        ],
        level: "city"
      },
      {
        label: "凉山彝族自治州",
        code: "513400",
        children: [
          { label: "西昌市", code: "513401", level: "district" },
          { label: "木里藏族自治县", code: "513422", level: "district" },
          { label: "盐源县", code: "513423", level: "district" },
          { label: "德昌县", code: "513424", level: "district" },
          { label: "会东县", code: "513426", level: "district" },
          { label: "宁南县", code: "513427", level: "district" },
          { label: "普格县", code: "513428", level: "district" },
          { label: "布拖县", code: "513429", level: "district" },
          { label: "金阳县", code: "513430", level: "district" },
          { label: "昭觉县", code: "513431", level: "district" },
          { label: "喜德县", code: "513432", level: "district" },
          { label: "冕宁县", code: "513433", level: "district" },
          { label: "越西县", code: "513434", level: "district" },
          { label: "甘洛县", code: "513435", level: "district" },
          { label: "美姑县", code: "513436", level: "district" },
          { label: "雷波县", code: "513437", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "贵州省",
    code: "520000",
    children: [
      {
        label: "贵阳市",
        code: "520100",
        children: [
          { label: "南明区", code: "520102", level: "district" },
          { label: "云岩区", code: "520103", level: "district" },
          { label: "花溪区", code: "520111", level: "district" },
          { label: "乌当区", code: "520112", level: "district" },
          { label: "白云区", code: "520113", level: "district" },
          { label: "观山湖区", code: "520115", level: "district" },
          { label: "开阳县", code: "520121", level: "district" },
          { label: "息烽县", code: "520122", level: "district" },
          { label: "修文县", code: "520123", level: "district" },
          { label: "清镇市", code: "520181", level: "district" }
        ],
        level: "city"
      },
      {
        label: "六盘水市",
        code: "520200",
        children: [
          { label: "钟山区", code: "520201", level: "district" },
          { label: "六枝特区", code: "520203", level: "district" },
          { label: "盘州市", code: "520281", level: "district" }
        ],
        level: "city"
      },
      {
        label: "遵义市",
        code: "520300",
        children: [
          { label: "红花岗区", code: "520302", level: "district" },
          { label: "汇川区", code: "520303", level: "district" },
          { label: "播州区", code: "520304", level: "district" },
          { label: "桐梓县", code: "520322", level: "district" },
          { label: "绥阳县", code: "520323", level: "district" },
          { label: "正安县", code: "520324", level: "district" },
          { label: "道真仡佬族苗族自治县", code: "520325", level: "district" },
          { label: "务川仡佬族苗族自治县", code: "520326", level: "district" },
          { label: "凤冈县", code: "520327", level: "district" },
          { label: "湄潭县", code: "520328", level: "district" },
          { label: "余庆县", code: "520329", level: "district" },
          { label: "习水县", code: "520330", level: "district" },
          { label: "赤水市", code: "520381", level: "district" },
          { label: "仁怀市", code: "520382", level: "district" }
        ],
        level: "city"
      },
      {
        label: "安顺市",
        code: "520400",
        children: [
          { label: "西秀区", code: "520402", level: "district" },
          { label: "平坝区", code: "520403", level: "district" },
          { label: "普定县", code: "520422", level: "district" },
          { label: "镇宁布依族苗族自治县", code: "520423", level: "district" },
          { label: "关岭布依族苗族自治县", code: "520424", level: "district" },
          { label: "紫云苗族布依族自治县", code: "520425", level: "district" }
        ],
        level: "city"
      },
      {
        label: "毕节市",
        code: "520500",
        children: [
          { label: "七星关区", code: "520502", level: "district" },
          { label: "大方县", code: "520521", level: "district" },
          { label: "金沙县", code: "520523", level: "district" },
          { label: "织金县", code: "520524", level: "district" },
          { label: "纳雍县", code: "520525", level: "district" },
          {
            label: "威宁彝族回族苗族自治县",
            code: "520526",
            level: "district"
          },
          { label: "赫章县", code: "520527", level: "district" }
        ],
        level: "city"
      },
      {
        label: "铜仁市",
        code: "520600",
        children: [
          { label: "碧江区", code: "520602", level: "district" },
          { label: "万山区", code: "520603", level: "district" },
          { label: "江口县", code: "520621", level: "district" },
          { label: "玉屏侗族自治县", code: "520622", level: "district" },
          { label: "石阡县", code: "520623", level: "district" },
          { label: "思南县", code: "520624", level: "district" },
          { label: "印江土家族苗族自治县", code: "520625", level: "district" },
          { label: "德江县", code: "520626", level: "district" },
          { label: "沿河土家族自治县", code: "520627", level: "district" },
          { label: "松桃苗族自治县", code: "520628", level: "district" }
        ],
        level: "city"
      },
      {
        label: "黔西南布依族苗族自治州",
        code: "522300",
        children: [
          { label: "兴义市", code: "522301", level: "district" },
          { label: "兴仁市", code: "522302", level: "district" },
          { label: "普安县", code: "522323", level: "district" },
          { label: "晴隆县", code: "522324", level: "district" },
          { label: "贞丰县", code: "522325", level: "district" },
          { label: "望谟县", code: "522326", level: "district" },
          { label: "册亨县", code: "522327", level: "district" },
          { label: "安龙县", code: "522328", level: "district" }
        ],
        level: "city"
      },
      {
        label: "黔东南苗族侗族自治州",
        code: "522600",
        children: [
          { label: "凯里市", code: "522601", level: "district" },
          { label: "黄平县", code: "522622", level: "district" },
          { label: "施秉县", code: "522623", level: "district" },
          { label: "三穗县", code: "522624", level: "district" },
          { label: "镇远县", code: "522625", level: "district" },
          { label: "岑巩县", code: "522626", level: "district" },
          { label: "天柱县", code: "522627", level: "district" },
          { label: "锦屏县", code: "522628", level: "district" },
          { label: "剑河县", code: "522629", level: "district" },
          { label: "台江县", code: "522630", level: "district" },
          { label: "黎平县", code: "522631", level: "district" },
          { label: "榕江县", code: "522632", level: "district" },
          { label: "从江县", code: "522633", level: "district" },
          { label: "雷山县", code: "522634", level: "district" },
          { label: "麻江县", code: "522635", level: "district" },
          { label: "丹寨县", code: "522636", level: "district" }
        ],
        level: "city"
      },
      {
        label: "黔南布依族苗族自治州",
        code: "522700",
        children: [
          { label: "都匀市", code: "522701", level: "district" },
          { label: "福泉市", code: "522702", level: "district" },
          { label: "荔波县", code: "522722", level: "district" },
          { label: "贵定县", code: "522723", level: "district" },
          { label: "瓮安县", code: "522725", level: "district" },
          { label: "独山县", code: "522726", level: "district" },
          { label: "平塘县", code: "522727", level: "district" },
          { label: "罗甸县", code: "522728", level: "district" },
          { label: "长顺县", code: "522729", level: "district" },
          { label: "龙里县", code: "522730", level: "district" },
          { label: "惠水县", code: "522731", level: "district" },
          { label: "三都水族自治县", code: "522732", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "云南省",
    code: "530000",
    children: [
      {
        label: "昆明市",
        code: "530100",
        children: [
          { label: "五华区", code: "530102", level: "district" },
          { label: "盘龙区", code: "530103", level: "district" },
          { label: "官渡区", code: "530111", level: "district" },
          { label: "西山区", code: "530112", level: "district" },
          { label: "东川区", code: "530113", level: "district" },
          { label: "呈贡区", code: "530114", level: "district" },
          { label: "晋宁区", code: "530115", level: "district" },
          { label: "富民县", code: "530124", level: "district" },
          { label: "宜良县", code: "530125", level: "district" },
          { label: "石林彝族自治县", code: "530126", level: "district" },
          { label: "嵩明县", code: "530127", level: "district" },
          { label: "禄劝彝族苗族自治县", code: "530128", level: "district" },
          { label: "寻甸回族彝族自治县", code: "530129", level: "district" },
          { label: "安宁市", code: "530181", level: "district" }
        ],
        level: "city"
      },
      {
        label: "曲靖市",
        code: "530300",
        children: [
          { label: "麒麟区", code: "530302", level: "district" },
          { label: "沾益区", code: "530303", level: "district" },
          { label: "马龙区", code: "530304", level: "district" },
          { label: "陆良县", code: "530322", level: "district" },
          { label: "师宗县", code: "530323", level: "district" },
          { label: "罗平县", code: "530324", level: "district" },
          { label: "富源县", code: "530325", level: "district" },
          { label: "会泽县", code: "530326", level: "district" },
          { label: "宣威市", code: "530381", level: "district" }
        ],
        level: "city"
      },
      {
        label: "玉溪市",
        code: "530400",
        children: [
          { label: "红塔区", code: "530402", level: "district" },
          { label: "江川区", code: "530403", level: "district" },
          { label: "通海县", code: "530423", level: "district" },
          { label: "华宁县", code: "530424", level: "district" },
          { label: "易门县", code: "530425", level: "district" },
          { label: "峨山彝族自治县", code: "530426", level: "district" },
          { label: "新平彝族傣族自治县", code: "530427", level: "district" },
          {
            label: "元江哈尼族彝族傣族自治县",
            code: "530428",
            level: "district"
          },
          { label: "澄江市", code: "530481", level: "district" }
        ],
        level: "city"
      },
      {
        label: "保山市",
        code: "530500",
        children: [
          { label: "隆阳区", code: "530502", level: "district" },
          { label: "施甸县", code: "530521", level: "district" },
          { label: "龙陵县", code: "530523", level: "district" },
          { label: "昌宁县", code: "530524", level: "district" },
          { label: "腾冲市", code: "530581", level: "district" }
        ],
        level: "city"
      },
      {
        label: "昭通市",
        code: "530600",
        children: [
          { label: "昭阳区", code: "530602", level: "district" },
          { label: "鲁甸县", code: "530621", level: "district" },
          { label: "巧家县", code: "530622", level: "district" },
          { label: "盐津县", code: "530623", level: "district" },
          { label: "大关县", code: "530624", level: "district" },
          { label: "永善县", code: "530625", level: "district" },
          { label: "绥江县", code: "530626", level: "district" },
          { label: "镇雄县", code: "530627", level: "district" },
          { label: "彝良县", code: "530628", level: "district" },
          { label: "威信县", code: "530629", level: "district" },
          { label: "水富市", code: "530681", level: "district" }
        ],
        level: "city"
      },
      {
        label: "丽江市",
        code: "530700",
        children: [
          { label: "古城区", code: "530702", level: "district" },
          { label: "玉龙纳西族自治县", code: "530721", level: "district" },
          { label: "永胜县", code: "530722", level: "district" },
          { label: "华坪县", code: "530723", level: "district" },
          { label: "宁蒗彝族自治县", code: "530724", level: "district" }
        ],
        level: "city"
      },
      {
        label: "普洱市",
        code: "530800",
        children: [
          { label: "思茅区", code: "530802", level: "district" },
          { label: "宁洱哈尼族彝族自治县", code: "530821", level: "district" },
          { label: "墨江哈尼族自治县", code: "530822", level: "district" },
          { label: "景东彝族自治县", code: "530823", level: "district" },
          { label: "景谷傣族彝族自治县", code: "530824", level: "district" },
          {
            label: "镇沅彝族哈尼族拉祜族自治县",
            code: "530825",
            level: "district"
          },
          { label: "江城哈尼族彝族自治县", code: "530826", level: "district" },
          {
            label: "孟连傣族拉祜族佤族自治县",
            code: "530827",
            level: "district"
          },
          { label: "澜沧拉祜族自治县", code: "530828", level: "district" },
          { label: "西盟佤族自治县", code: "530829", level: "district" }
        ],
        level: "city"
      },
      {
        label: "临沧市",
        code: "530900",
        children: [
          { label: "临翔区", code: "530902", level: "district" },
          { label: "凤庆县", code: "530921", level: "district" },
          { label: "云县", code: "530922", level: "district" },
          { label: "永德县", code: "530923", level: "district" },
          { label: "镇康县", code: "530924", level: "district" },
          {
            label: "双江拉祜族佤族布朗族傣族自治县",
            code: "530925",
            level: "district"
          },
          { label: "耿马傣族佤族自治县", code: "530926", level: "district" },
          { label: "沧源佤族自治县", code: "530927", level: "district" }
        ],
        level: "city"
      },
      {
        label: "楚雄彝族自治州",
        code: "532300",
        children: [
          { label: "楚雄市", code: "532301", level: "district" },
          { label: "双柏县", code: "532322", level: "district" },
          { label: "牟定县", code: "532323", level: "district" },
          { label: "南华县", code: "532324", level: "district" },
          { label: "姚安县", code: "532325", level: "district" },
          { label: "大姚县", code: "532326", level: "district" },
          { label: "永仁县", code: "532327", level: "district" },
          { label: "元谋县", code: "532328", level: "district" },
          { label: "武定县", code: "532329", level: "district" }
        ],
        level: "city"
      },
      {
        label: "红河哈尼族彝族自治州",
        code: "532500",
        children: [
          { label: "个旧市", code: "532501", level: "district" },
          { label: "开远市", code: "532502", level: "district" },
          { label: "蒙自市", code: "532503", level: "district" },
          { label: "弥勒市", code: "532504", level: "district" },
          { label: "屏边苗族自治县", code: "532523", level: "district" },
          { label: "建水县", code: "532524", level: "district" },
          { label: "石屏县", code: "532525", level: "district" },
          { label: "泸西县", code: "532527", level: "district" },
          { label: "元阳县", code: "532528", level: "district" },
          { label: "红河县", code: "532529", level: "district" },
          {
            label: "金平苗族瑶族傣族自治县",
            code: "532530",
            level: "district"
          },
          { label: "绿春县", code: "532531", level: "district" },
          { label: "河口瑶族自治县", code: "532532", level: "district" }
        ],
        level: "city"
      },
      {
        label: "文山壮族苗族自治州",
        code: "532600",
        children: [
          { label: "文山市", code: "532601", level: "district" },
          { label: "砚山县", code: "532622", level: "district" },
          { label: "西畴县", code: "532623", level: "district" },
          { label: "麻栗坡县", code: "532624", level: "district" },
          { label: "马关县", code: "532625", level: "district" },
          { label: "丘北县", code: "532626", level: "district" },
          { label: "广南县", code: "532627", level: "district" },
          { label: "富宁县", code: "532628", level: "district" }
        ],
        level: "city"
      },
      {
        label: "西双版纳傣族自治州",
        code: "532800",
        children: [
          { label: "景洪市", code: "532801", level: "district" },
          { label: "勐海县", code: "532822", level: "district" },
          { label: "勐腊县", code: "532823", level: "district" }
        ],
        level: "city"
      },
      {
        label: "大理白族自治州",
        code: "532900",
        children: [
          { label: "大理市", code: "532901", level: "district" },
          { label: "漾濞彝族自治县", code: "532922", level: "district" },
          { label: "祥云县", code: "532923", level: "district" },
          { label: "宾川县", code: "532924", level: "district" },
          { label: "弥渡县", code: "532925", level: "district" },
          { label: "南涧彝族自治县", code: "532926", level: "district" },
          { label: "巍山彝族回族自治县", code: "532927", level: "district" },
          { label: "永平县", code: "532928", level: "district" },
          { label: "云龙县", code: "532929", level: "district" },
          { label: "洱源县", code: "532930", level: "district" },
          { label: "剑川县", code: "532931", level: "district" },
          { label: "鹤庆县", code: "532932", level: "district" }
        ],
        level: "city"
      },
      {
        label: "德宏傣族景颇族自治州",
        code: "533100",
        children: [
          { label: "瑞丽市", code: "533102", level: "district" },
          { label: "芒市", code: "533103", level: "district" },
          { label: "梁河县", code: "533122", level: "district" },
          { label: "盈江县", code: "533123", level: "district" },
          { label: "陇川县", code: "533124", level: "district" }
        ],
        level: "city"
      },
      {
        label: "怒江傈僳族自治州",
        code: "533300",
        children: [
          { label: "泸水市", code: "533301", level: "district" },
          { label: "福贡县", code: "533323", level: "district" },
          { label: "贡山独龙族怒族自治县", code: "533324", level: "district" },
          { label: "兰坪白族普米族自治县", code: "533325", level: "district" }
        ],
        level: "city"
      },
      {
        label: "迪庆藏族自治州",
        code: "533400",
        children: [
          { label: "香格里拉市", code: "533401", level: "district" },
          { label: "德钦县", code: "533422", level: "district" },
          { label: "维西傈僳族自治县", code: "533423", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "西藏自治区",
    code: "540000",
    children: [
      {
        label: "拉萨市",
        code: "540100",
        children: [
          { label: "城关区", code: "540102", level: "district" },
          { label: "堆龙德庆区", code: "540103", level: "district" },
          { label: "达孜区", code: "540104", level: "district" },
          { label: "林周县", code: "540121", level: "district" },
          { label: "当雄县", code: "540122", level: "district" },
          { label: "尼木县", code: "540123", level: "district" },
          { label: "曲水县", code: "540124", level: "district" },
          { label: "墨竹工卡县", code: "540127", level: "district" }
        ],
        level: "city"
      },
      {
        label: "日喀则市",
        code: "540200",
        children: [
          { label: "桑珠孜区", code: "540202", level: "district" },
          { label: "南木林县", code: "540221", level: "district" },
          { label: "江孜县", code: "540222", level: "district" },
          { label: "定日县", code: "540223", level: "district" },
          { label: "萨迦县", code: "540224", level: "district" },
          { label: "拉孜县", code: "540225", level: "district" },
          { label: "昂仁县", code: "540226", level: "district" },
          { label: "谢通门县", code: "540227", level: "district" },
          { label: "白朗县", code: "540228", level: "district" },
          { label: "仁布县", code: "540229", level: "district" },
          { label: "康马县", code: "540230", level: "district" },
          { label: "定结县", code: "540231", level: "district" },
          { label: "仲巴县", code: "540232", level: "district" },
          { label: "亚东县", code: "540233", level: "district" },
          { label: "吉隆县", code: "540234", level: "district" },
          { label: "聂拉木县", code: "540235", level: "district" },
          { label: "萨嘎县", code: "540236", level: "district" },
          { label: "岗巴县", code: "540237", level: "district" }
        ],
        level: "city"
      },
      {
        label: "昌都市",
        code: "540300",
        children: [
          { label: "卡若区", code: "540302", level: "district" },
          { label: "江达县", code: "540321", level: "district" },
          { label: "贡觉县", code: "540322", level: "district" },
          { label: "类乌齐县", code: "540323", level: "district" },
          { label: "丁青县", code: "540324", level: "district" },
          { label: "察雅县", code: "540325", level: "district" },
          { label: "八宿县", code: "540326", level: "district" },
          { label: "左贡县", code: "540327", level: "district" },
          { label: "芒康县", code: "540328", level: "district" },
          { label: "洛隆县", code: "540329", level: "district" },
          { label: "边坝县", code: "540330", level: "district" }
        ],
        level: "city"
      },
      {
        label: "林芝市",
        code: "540400",
        children: [
          { label: "巴宜区", code: "540402", level: "district" },
          { label: "工布江达县", code: "540421", level: "district" },
          { label: "米林县", code: "540422", level: "district" },
          { label: "墨脱县", code: "540423", level: "district" },
          { label: "波密县", code: "540424", level: "district" },
          { label: "察隅县", code: "540425", level: "district" },
          { label: "朗县", code: "540426", level: "district" }
        ],
        level: "city"
      },
      {
        label: "山南市",
        code: "540500",
        children: [
          { label: "乃东区", code: "540502", level: "district" },
          { label: "扎囊县", code: "540521", level: "district" },
          { label: "贡嘎县", code: "540522", level: "district" },
          { label: "桑日县", code: "540523", level: "district" },
          { label: "琼结县", code: "540524", level: "district" },
          { label: "曲松县", code: "540525", level: "district" },
          { label: "措美县", code: "540526", level: "district" },
          { label: "洛扎县", code: "540527", level: "district" },
          { label: "加查县", code: "540528", level: "district" },
          { label: "隆子县", code: "540529", level: "district" },
          { label: "错那县", code: "540530", level: "district" },
          { label: "浪卡子县", code: "540531", level: "district" }
        ],
        level: "city"
      },
      {
        label: "那曲市",
        code: "540600",
        children: [
          { label: "色尼区", code: "540602", level: "district" },
          { label: "嘉黎县", code: "540621", level: "district" },
          { label: "比如县", code: "540622", level: "district" },
          { label: "聂荣县", code: "540623", level: "district" },
          { label: "安多县", code: "540624", level: "district" },
          { label: "申扎县", code: "540625", level: "district" },
          { label: "索县", code: "540626", level: "district" },
          { label: "班戈县", code: "540627", level: "district" },
          { label: "巴青县", code: "540628", level: "district" },
          { label: "尼玛县", code: "540629", level: "district" },
          { label: "双湖县", code: "540630", level: "district" }
        ],
        level: "city"
      },
      {
        label: "阿里地区",
        code: "542500",
        children: [
          { label: "普兰县", code: "542521", level: "district" },
          { label: "札达县", code: "542522", level: "district" },
          { label: "噶尔县", code: "542523", level: "district" },
          { label: "日土县", code: "542524", level: "district" },
          { label: "革吉县", code: "542525", level: "district" },
          { label: "改则县", code: "542526", level: "district" },
          { label: "措勤县", code: "542527", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "陕西省",
    code: "610000",
    children: [
      {
        label: "西安市",
        code: "610100",
        children: [
          { label: "新城区", code: "610102", level: "district" },
          { label: "碑林区", code: "610103", level: "district" },
          { label: "莲湖区", code: "610104", level: "district" },
          { label: "灞桥区", code: "610111", level: "district" },
          { label: "未央区", code: "610112", level: "district" },
          { label: "雁塔区", code: "610113", level: "district" },
          { label: "阎良区", code: "610114", level: "district" },
          { label: "临潼区", code: "610115", level: "district" },
          { label: "长安区", code: "610116", level: "district" },
          { label: "高陵区", code: "610117", level: "district" },
          { label: "鄠邑区", code: "610118", level: "district" },
          { label: "蓝田县", code: "610122", level: "district" },
          { label: "周至县", code: "610124", level: "district" }
        ],
        level: "city"
      },
      {
        label: "铜川市",
        code: "610200",
        children: [
          { label: "王益区", code: "610202", level: "district" },
          { label: "印台区", code: "610203", level: "district" },
          { label: "耀州区", code: "610204", level: "district" },
          { label: "宜君县", code: "610222", level: "district" }
        ],
        level: "city"
      },
      {
        label: "宝鸡市",
        code: "610300",
        children: [
          { label: "渭滨区", code: "610302", level: "district" },
          { label: "金台区", code: "610303", level: "district" },
          { label: "陈仓区", code: "610304", level: "district" },
          { label: "岐山县", code: "610323", level: "district" },
          { label: "扶风县", code: "610324", level: "district" },
          { label: "眉县", code: "610326", level: "district" },
          { label: "陇县", code: "610327", level: "district" },
          { label: "千阳县", code: "610328", level: "district" },
          { label: "麟游县", code: "610329", level: "district" },
          { label: "凤县", code: "610330", level: "district" },
          { label: "太白县", code: "610331", level: "district" }
        ],
        level: "city"
      },
      {
        label: "咸阳市",
        code: "610400",
        children: [
          { label: "秦都区", code: "610402", level: "district" },
          { label: "杨陵区", code: "610403", level: "district" },
          { label: "渭城区", code: "610404", level: "district" },
          { label: "三原县", code: "610422", level: "district" },
          { label: "泾阳县", code: "610423", level: "district" },
          { label: "乾县", code: "610424", level: "district" },
          { label: "礼泉县", code: "610425", level: "district" },
          { label: "永寿县", code: "610426", level: "district" },
          { label: "长武县", code: "610428", level: "district" },
          { label: "旬邑县", code: "610429", level: "district" },
          { label: "淳化县", code: "610430", level: "district" },
          { label: "武功县", code: "610431", level: "district" },
          { label: "兴平市", code: "610481", level: "district" },
          { label: "彬州市", code: "610482", level: "district" }
        ],
        level: "city"
      },
      {
        label: "渭南市",
        code: "610500",
        children: [
          { label: "临渭区", code: "610502", level: "district" },
          { label: "华州区", code: "610503", level: "district" },
          { label: "潼关县", code: "610522", level: "district" },
          { label: "大荔县", code: "610523", level: "district" },
          { label: "合阳县", code: "610524", level: "district" },
          { label: "澄城县", code: "610525", level: "district" },
          { label: "蒲城县", code: "610526", level: "district" },
          { label: "白水县", code: "610527", level: "district" },
          { label: "富平县", code: "610528", level: "district" },
          { label: "韩城市", code: "610581", level: "district" },
          { label: "华阴市", code: "610582", level: "district" }
        ],
        level: "city"
      },
      {
        label: "延安市",
        code: "610600",
        children: [
          { label: "宝塔区", code: "610602", level: "district" },
          { label: "安塞区", code: "610603", level: "district" },
          { label: "延长县", code: "610621", level: "district" },
          { label: "延川县", code: "610622", level: "district" },
          { label: "志丹县", code: "610625", level: "district" },
          { label: "吴起县", code: "610626", level: "district" },
          { label: "甘泉县", code: "610627", level: "district" },
          { label: "富县", code: "610628", level: "district" },
          { label: "洛川县", code: "610629", level: "district" },
          { label: "宜川县", code: "610630", level: "district" },
          { label: "黄龙县", code: "610631", level: "district" },
          { label: "黄陵县", code: "610632", level: "district" },
          { label: "子长市", code: "610681", level: "district" }
        ],
        level: "city"
      },
      {
        label: "汉中市",
        code: "610700",
        children: [
          { label: "汉台区", code: "610702", level: "district" },
          { label: "南郑区", code: "610703", level: "district" },
          { label: "城固县", code: "610722", level: "district" },
          { label: "洋县", code: "610723", level: "district" },
          { label: "西乡县", code: "610724", level: "district" },
          { label: "勉县", code: "610725", level: "district" },
          { label: "宁强县", code: "610726", level: "district" },
          { label: "略阳县", code: "610727", level: "district" },
          { label: "镇巴县", code: "610728", level: "district" },
          { label: "留坝县", code: "610729", level: "district" },
          { label: "佛坪县", code: "610730", level: "district" }
        ],
        level: "city"
      },
      {
        label: "榆林市",
        code: "610800",
        children: [
          { label: "榆阳区", code: "610802", level: "district" },
          { label: "横山区", code: "610803", level: "district" },
          { label: "府谷县", code: "610822", level: "district" },
          { label: "靖边县", code: "610824", level: "district" },
          { label: "定边县", code: "610825", level: "district" },
          { label: "绥德县", code: "610826", level: "district" },
          { label: "米脂县", code: "610827", level: "district" },
          { label: "佳县", code: "610828", level: "district" },
          { label: "吴堡县", code: "610829", level: "district" },
          { label: "清涧县", code: "610830", level: "district" },
          { label: "子洲县", code: "610831", level: "district" },
          { label: "神木市", code: "610881", level: "district" }
        ],
        level: "city"
      },
      {
        label: "安康市",
        code: "610900",
        children: [
          { label: "汉滨区", code: "610902", level: "district" },
          { label: "汉阴县", code: "610921", level: "district" },
          { label: "石泉县", code: "610922", level: "district" },
          { label: "宁陕县", code: "610923", level: "district" },
          { label: "紫阳县", code: "610924", level: "district" },
          { label: "岚皋县", code: "610925", level: "district" },
          { label: "平利县", code: "610926", level: "district" },
          { label: "镇坪县", code: "610927", level: "district" },
          { label: "白河县", code: "610929", level: "district" }
        ],
        level: "city"
      },
      {
        label: "商洛市",
        code: "611000",
        children: [
          { label: "商州区", code: "611002", level: "district" },
          { label: "洛南县", code: "611021", level: "district" },
          { label: "丹凤县", code: "611022", level: "district" },
          { label: "商南县", code: "611023", level: "district" },
          { label: "山阳县", code: "611024", level: "district" },
          { label: "镇安县", code: "611025", level: "district" },
          { label: "柞水县", code: "611026", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "甘肃省",
    code: "620000",
    children: [
      {
        label: "兰州市",
        code: "620100",
        children: [
          { label: "城关区", code: "620102", level: "district" },
          { label: "七里河区", code: "620103", level: "district" },
          { label: "西固区", code: "620104", level: "district" },
          { label: "安宁区", code: "620105", level: "district" },
          { label: "红古区", code: "620111", level: "district" },
          { label: "永登县", code: "620121", level: "district" },
          { label: "皋兰县", code: "620122", level: "district" },
          { label: "榆中县", code: "620123", level: "district" }
        ],
        level: "city"
      },
      { label: "嘉峪关市", code: "620200", children: [], level: "city" },
      {
        label: "金昌市",
        code: "620300",
        children: [
          { label: "金川区", code: "620302", level: "district" },
          { label: "永昌县", code: "620321", level: "district" }
        ],
        level: "city"
      },
      {
        label: "白银市",
        code: "620400",
        children: [
          { label: "白银区", code: "620402", level: "district" },
          { label: "平川区", code: "620403", level: "district" },
          { label: "靖远县", code: "620421", level: "district" },
          { label: "会宁县", code: "620422", level: "district" },
          { label: "景泰县", code: "620423", level: "district" }
        ],
        level: "city"
      },
      {
        label: "天水市",
        code: "620500",
        children: [
          { label: "秦州区", code: "620502", level: "district" },
          { label: "麦积区", code: "620503", level: "district" },
          { label: "清水县", code: "620521", level: "district" },
          { label: "秦安县", code: "620522", level: "district" },
          { label: "甘谷县", code: "620523", level: "district" },
          { label: "武山县", code: "620524", level: "district" },
          { label: "张家川回族自治县", code: "620525", level: "district" }
        ],
        level: "city"
      },
      {
        label: "武威市",
        code: "620600",
        children: [
          { label: "凉州区", code: "620602", level: "district" },
          { label: "民勤县", code: "620621", level: "district" },
          { label: "古浪县", code: "620622", level: "district" },
          { label: "天祝藏族自治县", code: "620623", level: "district" }
        ],
        level: "city"
      },
      {
        label: "张掖市",
        code: "620700",
        children: [
          { label: "甘州区", code: "620702", level: "district" },
          { label: "肃南裕固族自治县", code: "620721", level: "district" },
          { label: "民乐县", code: "620722", level: "district" },
          { label: "临泽县", code: "620723", level: "district" },
          { label: "高台县", code: "620724", level: "district" },
          { label: "山丹县", code: "620725", level: "district" }
        ],
        level: "city"
      },
      {
        label: "平凉市",
        code: "620800",
        children: [
          { label: "崆峒区", code: "620802", level: "district" },
          { label: "泾川县", code: "620821", level: "district" },
          { label: "灵台县", code: "620822", level: "district" },
          { label: "崇信县", code: "620823", level: "district" },
          { label: "庄浪县", code: "620825", level: "district" },
          { label: "静宁县", code: "620826", level: "district" },
          { label: "华亭市", code: "620881", level: "district" }
        ],
        level: "city"
      },
      {
        label: "酒泉市",
        code: "620900",
        children: [
          { label: "肃州区", code: "620902", level: "district" },
          { label: "金塔县", code: "620921", level: "district" },
          { label: "瓜州县", code: "620922", level: "district" },
          { label: "肃北蒙古族自治县", code: "620923", level: "district" },
          { label: "阿克塞哈萨克族自治县", code: "620924", level: "district" },
          { label: "玉门市", code: "620981", level: "district" },
          { label: "敦煌市", code: "620982", level: "district" }
        ],
        level: "city"
      },
      {
        label: "庆阳市",
        code: "621000",
        children: [
          { label: "西峰区", code: "621002", level: "district" },
          { label: "庆城县", code: "621021", level: "district" },
          { label: "环县", code: "621022", level: "district" },
          { label: "华池县", code: "621023", level: "district" },
          { label: "合水县", code: "621024", level: "district" },
          { label: "正宁县", code: "621025", level: "district" },
          { label: "宁县", code: "621026", level: "district" },
          { label: "镇原县", code: "621027", level: "district" }
        ],
        level: "city"
      },
      {
        label: "定西市",
        code: "621100",
        children: [
          { label: "安定区", code: "621102", level: "district" },
          { label: "通渭县", code: "621121", level: "district" },
          { label: "陇西县", code: "621122", level: "district" },
          { label: "渭源县", code: "621123", level: "district" },
          { label: "临洮县", code: "621124", level: "district" },
          { label: "漳县", code: "621125", level: "district" },
          { label: "岷县", code: "621126", level: "district" }
        ],
        level: "city"
      },
      {
        label: "陇南市",
        code: "621200",
        children: [
          { label: "武都区", code: "621202", level: "district" },
          { label: "成县", code: "621221", level: "district" },
          { label: "文县", code: "621222", level: "district" },
          { label: "宕昌县", code: "621223", level: "district" },
          { label: "康县", code: "621224", level: "district" },
          { label: "西和县", code: "621225", level: "district" },
          { label: "礼县", code: "621226", level: "district" },
          { label: "徽县", code: "621227", level: "district" },
          { label: "两当县", code: "621228", level: "district" }
        ],
        level: "city"
      },
      {
        label: "临夏回族自治州",
        code: "622900",
        children: [
          { label: "临夏市", code: "622901", level: "district" },
          { label: "临夏县", code: "622921", level: "district" },
          { label: "康乐县", code: "622922", level: "district" },
          { label: "永靖县", code: "622923", level: "district" },
          { label: "广河县", code: "622924", level: "district" },
          { label: "和政县", code: "622925", level: "district" },
          { label: "东乡族自治县", code: "622926", level: "district" },
          {
            label: "积石山保安族东乡族撒拉族自治县",
            code: "622927",
            level: "district"
          }
        ],
        level: "city"
      },
      {
        label: "甘南藏族自治州",
        code: "623000",
        children: [
          { label: "合作市", code: "623001", level: "district" },
          { label: "临潭县", code: "623021", level: "district" },
          { label: "卓尼县", code: "623022", level: "district" },
          { label: "舟曲县", code: "623023", level: "district" },
          { label: "迭部县", code: "623024", level: "district" },
          { label: "玛曲县", code: "623025", level: "district" },
          { label: "碌曲县", code: "623026", level: "district" },
          { label: "夏河县", code: "623027", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "青海省",
    code: "630000",
    children: [
      {
        label: "西宁市",
        code: "630100",
        children: [
          { label: "城东区", code: "630102", level: "district" },
          { label: "城中区", code: "630103", level: "district" },
          { label: "城西区", code: "630104", level: "district" },
          { label: "城北区", code: "630105", level: "district" },
          { label: "湟中区", code: "630106", level: "district" },
          { label: "大通回族土族自治县", code: "630121", level: "district" },
          { label: "湟源县", code: "630123", level: "district" }
        ],
        level: "city"
      },
      {
        label: "海东市",
        code: "630200",
        children: [
          { label: "乐都区", code: "630202", level: "district" },
          { label: "平安区", code: "630203", level: "district" },
          { label: "民和回族土族自治县", code: "630222", level: "district" },
          { label: "互助土族自治县", code: "630223", level: "district" },
          { label: "化隆回族自治县", code: "630224", level: "district" },
          { label: "循化撒拉族自治县", code: "630225", level: "district" }
        ],
        level: "city"
      },
      {
        label: "海北藏族自治州",
        code: "632200",
        children: [
          { label: "门源回族自治县", code: "632221", level: "district" },
          { label: "祁连县", code: "632222", level: "district" },
          { label: "海晏县", code: "632223", level: "district" },
          { label: "刚察县", code: "632224", level: "district" }
        ],
        level: "city"
      },
      {
        label: "黄南藏族自治州",
        code: "632300",
        children: [
          { label: "尖扎县", code: "632322", level: "district" },
          { label: "泽库县", code: "632323", level: "district" },
          { label: "河南蒙古族自治县", code: "632324", level: "district" }
        ],
        level: "city"
      },
      {
        label: "海南藏族自治州",
        code: "632500",
        children: [
          { label: "共和县", code: "632521", level: "district" },
          { label: "同德县", code: "632522", level: "district" },
          { label: "贵德县", code: "632523", level: "district" },
          { label: "兴海县", code: "632524", level: "district" },
          { label: "贵南县", code: "632525", level: "district" }
        ],
        level: "city"
      },
      {
        label: "果洛藏族自治州",
        code: "632600",
        children: [
          { label: "玛沁县", code: "632621", level: "district" },
          { label: "班玛县", code: "632622", level: "district" },
          { label: "甘德县", code: "632623", level: "district" },
          { label: "达日县", code: "632624", level: "district" },
          { label: "久治县", code: "632625", level: "district" },
          { label: "玛多县", code: "632626", level: "district" }
        ],
        level: "city"
      },
      {
        label: "玉树藏族自治州",
        code: "632700",
        children: [
          { label: "玉树市", code: "632701", level: "district" },
          { label: "杂多县", code: "632722", level: "district" },
          { label: "称多县", code: "632723", level: "district" },
          { label: "治多县", code: "632724", level: "district" },
          { label: "囊谦县", code: "632725", level: "district" },
          { label: "曲麻莱县", code: "632726", level: "district" }
        ],
        level: "city"
      },
      {
        label: "海西蒙古族藏族自治州",
        code: "632800",
        children: [
          { label: "格尔木市", code: "632801", level: "district" },
          { label: "德令哈市", code: "632802", level: "district" },
          { label: "茫崖市", code: "632803", level: "district" },
          { label: "乌兰县", code: "632821", level: "district" },
          { label: "都兰县", code: "632822", level: "district" },
          { label: "天峻县", code: "632823", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "宁夏回族自治区",
    code: "640000",
    children: [
      {
        label: "银川市",
        code: "640100",
        children: [
          { label: "兴庆区", code: "640104", level: "district" },
          { label: "西夏区", code: "640105", level: "district" },
          { label: "金凤区", code: "640106", level: "district" },
          { label: "永宁县", code: "640121", level: "district" },
          { label: "贺兰县", code: "640122", level: "district" },
          { label: "灵武市", code: "640181", level: "district" }
        ],
        level: "city"
      },
      {
        label: "石嘴山市",
        code: "640200",
        children: [
          { label: "大武口区", code: "640202", level: "district" },
          { label: "惠农区", code: "640205", level: "district" },
          { label: "平罗县", code: "640221", level: "district" }
        ],
        level: "city"
      },
      {
        label: "吴忠市",
        code: "640300",
        children: [
          { label: "利通区", code: "640302", level: "district" },
          { label: "红寺堡区", code: "640303", level: "district" },
          { label: "盐池县", code: "640323", level: "district" },
          { label: "同心县", code: "640324", level: "district" },
          { label: "青铜峡市", code: "640381", level: "district" }
        ],
        level: "city"
      },
      {
        label: "固原市",
        code: "640400",
        children: [
          { label: "原州区", code: "640402", level: "district" },
          { label: "西吉县", code: "640422", level: "district" },
          { label: "隆德县", code: "640423", level: "district" },
          { label: "泾源县", code: "640424", level: "district" },
          { label: "彭阳县", code: "640425", level: "district" }
        ],
        level: "city"
      },
      {
        label: "中卫市",
        code: "640500",
        children: [
          { label: "沙坡头区", code: "640502", level: "district" },
          { label: "中宁县", code: "640521", level: "district" },
          { label: "海原县", code: "640522", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "新疆维吾尔自治区",
    code: "650000",
    children: [
      {
        label: "乌鲁木齐市",
        code: "650100",
        children: [
          { label: "天山区", code: "650102", level: "district" },
          { label: "沙依巴克区", code: "650103", level: "district" },
          { label: "新市区", code: "650104", level: "district" },
          { label: "水磨沟区", code: "650105", level: "district" },
          { label: "头屯河区", code: "650106", level: "district" },
          { label: "达坂城区", code: "650107", level: "district" },
          { label: "米东区", code: "650109", level: "district" },
          { label: "乌鲁木齐县", code: "650121", level: "district" }
        ],
        level: "city"
      },
      {
        label: "克拉玛依市",
        code: "650200",
        children: [
          { label: "独山子区", code: "650202", level: "district" },
          { label: "克拉玛依区", code: "650203", level: "district" },
          { label: "白碱滩区", code: "650204", level: "district" },
          { label: "乌尔禾区", code: "650205", level: "district" }
        ],
        level: "city"
      },
      {
        label: "吐鲁番市",
        code: "650400",
        children: [
          { label: "高昌区", code: "650402", level: "district" },
          { label: "鄯善县", code: "650421", level: "district" },
          { label: "托克逊县", code: "650422", level: "district" }
        ],
        level: "city"
      },
      {
        label: "哈密市",
        code: "650500",
        children: [
          { label: "伊州区", code: "650502", level: "district" },
          { label: "巴里坤哈萨克自治县", code: "650521", level: "district" },
          { label: "伊吾县", code: "650522", level: "district" }
        ],
        level: "city"
      },
      {
        label: "昌吉回族自治州",
        code: "652300",
        children: [
          { label: "昌吉市", code: "652301", level: "district" },
          { label: "阜康市", code: "652302", level: "district" },
          { label: "呼图壁县", code: "652323", level: "district" },
          { label: "玛纳斯县", code: "652324", level: "district" },
          { label: "奇台县", code: "652325", level: "district" },
          { label: "吉木萨尔县", code: "652327", level: "district" },
          { label: "木垒哈萨克自治县", code: "652328", level: "district" }
        ],
        level: "city"
      },
      {
        label: "博尔塔拉蒙古自治州",
        code: "652700",
        children: [
          { label: "博乐市", code: "652701", level: "district" },
          { label: "阿拉山口市", code: "652702", level: "district" },
          { label: "精河县", code: "652722", level: "district" },
          { label: "温泉县", code: "652723", level: "district" }
        ],
        level: "city"
      },
      {
        label: "巴音郭楞蒙古自治州",
        code: "652800",
        children: [
          { label: "库尔勒市", code: "652801", level: "district" },
          { label: "轮台县", code: "652822", level: "district" },
          { label: "尉犁县", code: "652823", level: "district" },
          { label: "若羌县", code: "652824", level: "district" },
          { label: "且末县", code: "652825", level: "district" },
          { label: "焉耆回族自治县", code: "652826", level: "district" },
          { label: "和静县", code: "652827", level: "district" },
          { label: "和硕县", code: "652828", level: "district" },
          { label: "博湖县", code: "652829", level: "district" }
        ],
        level: "city"
      },
      {
        label: "阿克苏地区",
        code: "652900",
        children: [
          { label: "阿克苏市", code: "652901", level: "district" },
          { label: "库车市", code: "652902", level: "district" },
          { label: "温宿县", code: "652922", level: "district" },
          { label: "沙雅县", code: "652924", level: "district" },
          { label: "新和县", code: "652925", level: "district" },
          { label: "拜城县", code: "652926", level: "district" },
          { label: "乌什县", code: "652927", level: "district" },
          { label: "阿瓦提县", code: "652928", level: "district" },
          { label: "柯坪县", code: "652929", level: "district" }
        ],
        level: "city"
      },
      {
        label: "克孜勒苏柯尔克孜自治州",
        code: "653000",
        children: [
          { label: "阿图什市", code: "653001", level: "district" },
          { label: "阿克陶县", code: "653022", level: "district" },
          { label: "阿合奇县", code: "653023", level: "district" },
          { label: "乌恰县", code: "653024", level: "district" }
        ],
        level: "city"
      },
      {
        label: "喀什地区",
        code: "653100",
        children: [
          { label: "喀什市", code: "653101", level: "district" },
          { label: "疏附县", code: "653121", level: "district" },
          { label: "疏勒县", code: "653122", level: "district" },
          { label: "英吉沙县", code: "653123", level: "district" },
          { label: "泽普县", code: "653124", level: "district" },
          { label: "莎车县", code: "653125", level: "district" },
          { label: "叶城县", code: "653126", level: "district" },
          { label: "麦盖提县", code: "653127", level: "district" },
          { label: "岳普湖县", code: "653128", level: "district" },
          { label: "伽师县", code: "653129", level: "district" },
          { label: "巴楚县", code: "653130", level: "district" },
          { label: "塔什库尔干塔吉克自治县", code: "653131", level: "district" }
        ],
        level: "city"
      },
      {
        label: "和田地区",
        code: "653200",
        children: [
          { label: "和田市", code: "653201", level: "district" },
          { label: "和田县", code: "653221", level: "district" },
          { label: "墨玉县", code: "653222", level: "district" },
          { label: "皮山县", code: "653223", level: "district" },
          { label: "洛浦县", code: "653224", level: "district" },
          { label: "策勒县", code: "653225", level: "district" },
          { label: "于田县", code: "653226", level: "district" },
          { label: "民丰县", code: "653227", level: "district" }
        ],
        level: "city"
      },
      {
        label: "伊犁哈萨克自治州",
        code: "654000",
        children: [
          { label: "伊宁市", code: "654002", level: "district" },
          { label: "奎屯市", code: "654003", level: "district" },
          { label: "霍尔果斯市", code: "654004", level: "district" },
          { label: "伊宁县", code: "654021", level: "district" },
          { label: "察布查尔锡伯自治县", code: "654022", level: "district" },
          { label: "霍城县", code: "654023", level: "district" },
          { label: "巩留县", code: "654024", level: "district" },
          { label: "新源县", code: "654025", level: "district" },
          { label: "昭苏县", code: "654026", level: "district" },
          { label: "特克斯县", code: "654027", level: "district" },
          { label: "尼勒克县", code: "654028", level: "district" }
        ],
        level: "city"
      },
      {
        label: "塔城地区",
        code: "654200",
        children: [
          { label: "塔城市", code: "654201", level: "district" },
          { label: "乌苏市", code: "654202", level: "district" },
          { label: "额敏县", code: "654221", level: "district" },
          { label: "托里县", code: "654224", level: "district" },
          { label: "裕民县", code: "654225", level: "district" },
          { label: "和布克赛尔蒙古自治县", code: "654226", level: "district" }
        ],
        level: "city"
      },
      {
        label: "阿勒泰地区",
        code: "654300",
        children: [
          { label: "阿勒泰市", code: "654301", level: "district" },
          { label: "布尔津县", code: "654321", level: "district" },
          { label: "富蕴县", code: "654322", level: "district" },
          { label: "福海县", code: "654323", level: "district" },
          { label: "哈巴河县", code: "654324", level: "district" },
          { label: "青河县", code: "654325", level: "district" },
          { label: "吉木乃县", code: "654326", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  { label: "台湾省", code: "710000", children: [], level: "province" },
  { label: "香港特别行政区", code: "810000", children: [], level: "province" },
  { label: "澳门特别行政区", code: "820000", children: [], level: "province" }
];
// （ 内蒙古、黑龙江、吉林、辽宁 ）三级区域列表
export const PART_REGEION_LIST = [
  {
    label: "内蒙古自治区",
    code: "150000",
    children: [
      {
        label: "呼和浩特市",
        code: "150100",
        children: [
          { label: "新城区", code: "150102", level: "district" },
          { label: "回民区", code: "150103", level: "district" },
          { label: "玉泉区", code: "150104", level: "district" },
          { label: "赛罕区", code: "150105", level: "district" },
          { label: "土默特左旗", code: "150121", level: "district" },
          { label: "托克托县", code: "150122", level: "district" },
          { label: "和林格尔县", code: "150123", level: "district" },
          { label: "清水河县", code: "150124", level: "district" },
          { label: "武川县", code: "150125", level: "district" },
          {
            label: "呼和浩特经济技术开发区",
            code: "150172",
            level: "district"
          }
        ],
        level: "city"
      },
      {
        label: "包头市",
        code: "150200",
        children: [
          { label: "东河区", code: "150202", level: "district" },
          { label: "昆都仑区", code: "150203", level: "district" },
          { label: "青山区", code: "150204", level: "district" },
          { label: "石拐区", code: "150205", level: "district" },
          { label: "白云鄂博矿区", code: "150206", level: "district" },
          { label: "九原区", code: "150207", level: "district" },
          { label: "土默特右旗", code: "150221", level: "district" },
          { label: "固阳县", code: "150222", level: "district" },
          { label: "达尔罕茂明安联合旗", code: "150223", level: "district" },
          {
            label: "包头稀土高新技术产业开发区",
            code: "150271",
            level: "district"
          }
        ],
        level: "city"
      },
      {
        label: "乌海市",
        code: "150300",
        children: [
          { label: "海勃湾区", code: "150302", level: "district" },
          { label: "海南区", code: "150303", level: "district" },
          { label: "乌达区", code: "150304", level: "district" }
        ],
        level: "city"
      },
      {
        label: "赤峰市",
        code: "150400",
        children: [
          { label: "红山区", code: "150402", level: "district" },
          { label: "元宝山区", code: "150403", level: "district" },
          { label: "松山区", code: "150404", level: "district" },
          { label: "阿鲁科尔沁旗", code: "150421", level: "district" },
          { label: "巴林左旗", code: "150422", level: "district" },
          { label: "巴林右旗", code: "150423", level: "district" },
          { label: "林西县", code: "150424", level: "district" },
          { label: "克什克腾旗", code: "150425", level: "district" },
          { label: "翁牛特旗", code: "150426", level: "district" },
          { label: "喀喇沁旗", code: "150428", level: "district" },
          { label: "宁城县", code: "150429", level: "district" },
          { label: "敖汉旗", code: "150430", level: "district" }
        ],
        level: "city"
      },
      {
        label: "通辽市",
        code: "150500",
        children: [
          { label: "科尔沁区", code: "150502", level: "district" },
          { label: "科尔沁左翼中旗", code: "150521", level: "district" },
          { label: "科尔沁左翼后旗", code: "150522", level: "district" },
          { label: "开鲁县", code: "150523", level: "district" },
          { label: "库伦旗", code: "150524", level: "district" },
          { label: "奈曼旗", code: "150525", level: "district" },
          { label: "扎鲁特旗", code: "150526", level: "district" },
          { label: "通辽经济技术开发区", code: "150571", level: "district" },
          { label: "霍林郭勒市", code: "150581", level: "district" }
        ],
        level: "city"
      },
      {
        label: "鄂尔多斯市",
        code: "150600",
        children: [
          { label: "东胜区", code: "150602", level: "district" },
          { label: "康巴什区", code: "150603", level: "district" },
          { label: "达拉特旗", code: "150621", level: "district" },
          { label: "准格尔旗", code: "150622", level: "district" },
          { label: "鄂托克前旗", code: "150623", level: "district" },
          { label: "鄂托克旗", code: "150624", level: "district" },
          { label: "杭锦旗", code: "150625", level: "district" },
          { label: "乌审旗", code: "150626", level: "district" },
          { label: "伊金霍洛旗", code: "150627", level: "district" }
        ],
        level: "city"
      },
      {
        label: "呼伦贝尔市",
        code: "150700",
        children: [
          { label: "海拉尔区", code: "150702", level: "district" },
          { label: "扎赉诺尔区", code: "150703", level: "district" },
          { label: "阿荣旗", code: "150721", level: "district" },
          {
            label: "莫力达瓦达斡尔族自治旗",
            code: "150722",
            level: "district"
          },
          { label: "鄂伦春自治旗", code: "150723", level: "district" },
          { label: "鄂温克族自治旗", code: "150724", level: "district" },
          { label: "陈巴尔虎旗", code: "150725", level: "district" },
          { label: "新巴尔虎左旗", code: "150726", level: "district" },
          { label: "新巴尔虎右旗", code: "150727", level: "district" },
          { label: "满洲里市", code: "150781", level: "district" },
          { label: "牙克石市", code: "150782", level: "district" },
          { label: "扎兰屯市", code: "150783", level: "district" },
          { label: "额尔古纳市", code: "150784", level: "district" },
          { label: "根河市", code: "150785", level: "district" }
        ],
        level: "city"
      },
      {
        label: "巴彦淖尔市",
        code: "150800",
        children: [
          { label: "临河区", code: "150802", level: "district" },
          { label: "五原县", code: "150821", level: "district" },
          { label: "磴口县", code: "150822", level: "district" },
          { label: "乌拉特前旗", code: "150823", level: "district" },
          { label: "乌拉特中旗", code: "150824", level: "district" },
          { label: "乌拉特后旗", code: "150825", level: "district" },
          { label: "杭锦后旗", code: "150826", level: "district" }
        ],
        level: "city"
      },
      {
        label: "乌兰察布市",
        code: "150900",
        children: [
          { label: "集宁区", code: "150902", level: "district" },
          { label: "卓资县", code: "150921", level: "district" },
          { label: "化德县", code: "150922", level: "district" },
          { label: "商都县", code: "150923", level: "district" },
          { label: "兴和县", code: "150924", level: "district" },
          { label: "凉城县", code: "150925", level: "district" },
          { label: "察哈尔右翼前旗", code: "150926", level: "district" },
          { label: "察哈尔右翼中旗", code: "150927", level: "district" },
          { label: "察哈尔右翼后旗", code: "150928", level: "district" },
          { label: "四子王旗", code: "150929", level: "district" },
          { label: "丰镇市", code: "150981", level: "district" }
        ],
        level: "city"
      },
      {
        label: "兴安盟",
        code: "152200",
        children: [
          { label: "乌兰浩特市", code: "152201", level: "district" },
          { label: "阿尔山市", code: "152202", level: "district" },
          { label: "科尔沁右翼前旗", code: "152221", level: "district" },
          { label: "科尔沁右翼中旗", code: "152222", level: "district" },
          { label: "扎赉特旗", code: "152223", level: "district" },
          { label: "突泉县", code: "152224", level: "district" }
        ],
        level: "city"
      },
      {
        label: "锡林郭勒盟",
        code: "152500",
        children: [
          { label: "二连浩特市", code: "152501", level: "district" },
          { label: "锡林浩特市", code: "152502", level: "district" },
          { label: "阿巴嘎旗", code: "152522", level: "district" },
          { label: "苏尼特左旗", code: "152523", level: "district" },
          { label: "苏尼特右旗", code: "152524", level: "district" },
          { label: "东乌珠穆沁旗", code: "152525", level: "district" },
          { label: "西乌珠穆沁旗", code: "152526", level: "district" },
          { label: "太仆寺旗", code: "152527", level: "district" },
          { label: "镶黄旗", code: "152528", level: "district" },
          { label: "正镶白旗", code: "152529", level: "district" },
          { label: "正蓝旗", code: "152530", level: "district" },
          { label: "多伦县", code: "152531", level: "district" },
          { label: "乌拉盖管委会", code: "152571", level: "district" }
        ],
        level: "city"
      },
      {
        label: "阿拉善盟",
        code: "152900",
        children: [
          { label: "阿拉善左旗", code: "152921", level: "district" },
          { label: "阿拉善右旗", code: "152922", level: "district" },
          { label: "额济纳旗", code: "152923", level: "district" },
          {
            label: "内蒙古阿拉善经济开发区",
            code: "152971",
            level: "district"
          }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "辽宁省",
    code: "210000",
    children: [
      {
        label: "沈阳市",
        code: "210100",
        children: [
          { label: "和平区", code: "210102", level: "district" },
          { label: "沈河区", code: "210103", level: "district" },
          { label: "大东区", code: "210104", level: "district" },
          { label: "皇姑区", code: "210105", level: "district" },
          { label: "铁西区", code: "210106", level: "district" },
          { label: "苏家屯区", code: "210111", level: "district" },
          { label: "浑南区", code: "210112", level: "district" },
          { label: "沈北新区", code: "210113", level: "district" },
          { label: "于洪区", code: "210114", level: "district" },
          { label: "辽中区", code: "210115", level: "district" },
          { label: "康平县", code: "210123", level: "district" },
          { label: "法库县", code: "210124", level: "district" },
          { label: "新民市", code: "210181", level: "district" },
          { label: "经济技术开发区", code: "210190", level: "district" }
        ],
        level: "city"
      },
      {
        label: "大连市",
        code: "210200",
        children: [
          { label: "中山区", code: "210202", level: "district" },
          { label: "西岗区", code: "210203", level: "district" },
          { label: "沙河口区", code: "210204", level: "district" },
          { label: "甘井子区", code: "210211", level: "district" },
          { label: "旅顺口区", code: "210212", level: "district" },
          { label: "金州区", code: "210213", level: "district" },
          { label: "普兰店区", code: "210214", level: "district" },
          { label: "长海县", code: "210224", level: "district" },
          { label: "瓦房店市", code: "210281", level: "district" },
          { label: "庄河市", code: "210283", level: "district" }
        ],
        level: "city"
      },
      {
        label: "鞍山市",
        code: "210300",
        children: [
          { label: "铁东区", code: "210302", level: "district" },
          { label: "铁西区", code: "210303", level: "district" },
          { label: "立山区", code: "210304", level: "district" },
          { label: "千山区", code: "210311", level: "district" },
          { label: "台安县", code: "210321", level: "district" },
          { label: "岫岩满族自治县", code: "210323", level: "district" },
          { label: "海城市", code: "210381", level: "district" },
          { label: "高新区", code: "210390", level: "district" }
        ],
        level: "city"
      },
      {
        label: "抚顺市",
        code: "210400",
        children: [
          { label: "新抚区", code: "210402", level: "district" },
          { label: "东洲区", code: "210403", level: "district" },
          { label: "望花区", code: "210404", level: "district" },
          { label: "顺城区", code: "210411", level: "district" },
          { label: "抚顺县", code: "210421", level: "district" },
          { label: "新宾满族自治县", code: "210422", level: "district" },
          { label: "清原满族自治县", code: "210423", level: "district" }
        ],
        level: "city"
      },
      {
        label: "本溪市",
        code: "210500",
        children: [
          { label: "平山区", code: "210502", level: "district" },
          { label: "溪湖区", code: "210503", level: "district" },
          { label: "明山区", code: "210504", level: "district" },
          { label: "南芬区", code: "210505", level: "district" },
          { label: "本溪满族自治县", code: "210521", level: "district" },
          { label: "桓仁满族自治县", code: "210522", level: "district" }
        ],
        level: "city"
      },
      {
        label: "丹东市",
        code: "210600",
        children: [
          { label: "元宝区", code: "210602", level: "district" },
          { label: "振兴区", code: "210603", level: "district" },
          { label: "振安区", code: "210604", level: "district" },
          { label: "宽甸满族自治县", code: "210624", level: "district" },
          { label: "东港市", code: "210681", level: "district" },
          { label: "凤城市", code: "210682", level: "district" }
        ],
        level: "city"
      },
      {
        label: "锦州市",
        code: "210700",
        children: [
          { label: "古塔区", code: "210702", level: "district" },
          { label: "凌河区", code: "210703", level: "district" },
          { label: "太和区", code: "210711", level: "district" },
          { label: "黑山县", code: "210726", level: "district" },
          { label: "义县", code: "210727", level: "district" },
          { label: "凌海市", code: "210781", level: "district" },
          { label: "北镇市", code: "210782", level: "district" },
          { label: "经济技术开发区", code: "210793", level: "district" }
        ],
        level: "city"
      },
      {
        label: "营口市",
        code: "210800",
        children: [
          { label: "站前区", code: "210802", level: "district" },
          { label: "西市区", code: "210803", level: "district" },
          { label: "鲅鱼圈区", code: "210804", level: "district" },
          { label: "老边区", code: "210811", level: "district" },
          { label: "盖州市", code: "210881", level: "district" },
          { label: "大石桥市", code: "210882", level: "district" }
        ],
        level: "city"
      },
      {
        label: "阜新市",
        code: "210900",
        children: [
          { label: "海州区", code: "210902", level: "district" },
          { label: "新邱区", code: "210903", level: "district" },
          { label: "太平区", code: "210904", level: "district" },
          { label: "清河门区", code: "210905", level: "district" },
          { label: "细河区", code: "210911", level: "district" },
          { label: "阜新蒙古族自治县", code: "210921", level: "district" },
          { label: "彰武县", code: "210922", level: "district" }
        ],
        level: "city"
      },
      {
        label: "辽阳市",
        code: "211000",
        children: [
          { label: "白塔区", code: "211002", level: "district" },
          { label: "文圣区", code: "211003", level: "district" },
          { label: "宏伟区", code: "211004", level: "district" },
          { label: "弓长岭区", code: "211005", level: "district" },
          { label: "太子河区", code: "211011", level: "district" },
          { label: "辽阳县", code: "211021", level: "district" },
          { label: "灯塔市", code: "211081", level: "district" }
        ],
        level: "city"
      },
      {
        label: "盘锦市",
        code: "211100",
        children: [
          { label: "双台子区", code: "211102", level: "district" },
          { label: "兴隆台区", code: "211103", level: "district" },
          { label: "大洼区", code: "211104", level: "district" },
          { label: "盘山县", code: "211122", level: "district" }
        ],
        level: "city"
      },
      {
        label: "铁岭市",
        code: "211200",
        children: [
          { label: "银州区", code: "211202", level: "district" },
          { label: "清河区", code: "211204", level: "district" },
          { label: "铁岭县", code: "211221", level: "district" },
          { label: "西丰县", code: "211223", level: "district" },
          { label: "昌图县", code: "211224", level: "district" },
          { label: "调兵山市", code: "211281", level: "district" },
          { label: "开原市", code: "211282", level: "district" }
        ],
        level: "city"
      },
      {
        label: "朝阳市",
        code: "211300",
        children: [
          { label: "双塔区", code: "211302", level: "district" },
          { label: "龙城区", code: "211303", level: "district" },
          { label: "朝阳县", code: "211321", level: "district" },
          { label: "建平县", code: "211322", level: "district" },
          {
            label: "喀喇沁左翼蒙古族自治县",
            code: "211324",
            level: "district"
          },
          { label: "北票市", code: "211381", level: "district" },
          { label: "凌源市", code: "211382", level: "district" }
        ],
        level: "city"
      },
      {
        label: "葫芦岛市",
        code: "211400",
        children: [
          { label: "连山区", code: "211402", level: "district" },
          { label: "龙港区", code: "211403", level: "district" },
          { label: "南票区", code: "211404", level: "district" },
          { label: "绥中县", code: "211421", level: "district" },
          { label: "建昌县", code: "211422", level: "district" },
          { label: "兴城市", code: "211481", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "吉林省",
    code: "220000",
    children: [
      {
        label: "长春市",
        code: "220100",
        children: [
          { label: "南关区", code: "220102", level: "district" },
          { label: "宽城区", code: "220103", level: "district" },
          { label: "朝阳区", code: "220104", level: "district" },
          { label: "二道区", code: "220105", level: "district" },
          { label: "绿园区", code: "220106", level: "district" },
          { label: "双阳区", code: "220112", level: "district" },
          { label: "九台区", code: "220113", level: "district" },
          { label: "农安县", code: "220122", level: "district" },
          { label: "长春经济技术开发区", code: "220171", level: "district" },
          {
            label: "长春净月高新技术产业开发区",
            code: "220172",
            level: "district"
          },
          {
            label: "长春高新技术产业开发区",
            code: "220173",
            level: "district"
          },
          {
            label: "长春汽车经济技术开发区",
            code: "220174",
            level: "district"
          },
          { label: "榆树市", code: "220182", level: "district" },
          { label: "德惠市", code: "220183", level: "district" },
          { label: "经济技术开发区", code: "220192", level: "district" }
        ],
        level: "city"
      },
      {
        label: "吉林市",
        code: "220200",
        children: [
          { label: "昌邑区", code: "220202", level: "district" },
          { label: "龙潭区", code: "220203", level: "district" },
          { label: "船营区", code: "220204", level: "district" },
          { label: "丰满区", code: "220211", level: "district" },
          { label: "永吉县", code: "220221", level: "district" },
          { label: "吉林经济开发区", code: "220271", level: "district" },
          {
            label: "吉林高新技术产业开发区",
            code: "220272",
            level: "district"
          },
          { label: "蛟河市", code: "220281", level: "district" },
          { label: "桦甸市", code: "220282", level: "district" },
          { label: "舒兰市", code: "220283", level: "district" },
          { label: "磐石市", code: "220284", level: "district" }
        ],
        level: "city"
      },
      {
        label: "四平市",
        code: "220300",
        children: [
          { label: "铁西区", code: "220302", level: "district" },
          { label: "铁东区", code: "220303", level: "district" },
          { label: "梨树县", code: "220322", level: "district" },
          { label: "伊通满族自治县", code: "220323", level: "district" },
          { label: "公主岭市", code: "220381", level: "district" },
          { label: "双辽市", code: "220382", level: "district" }
        ],
        level: "city"
      },
      {
        label: "辽源市",
        code: "220400",
        children: [
          { label: "龙山区", code: "220402", level: "district" },
          { label: "西安区", code: "220403", level: "district" },
          { label: "东丰县", code: "220421", level: "district" },
          { label: "东辽县", code: "220422", level: "district" }
        ],
        level: "city"
      },
      {
        label: "通化市",
        code: "220500",
        children: [
          { label: "东昌区", code: "220502", level: "district" },
          { label: "二道江区", code: "220503", level: "district" },
          { label: "通化县", code: "220521", level: "district" },
          { label: "辉南县", code: "220523", level: "district" },
          { label: "柳河县", code: "220524", level: "district" },
          { label: "梅河口市", code: "220581", level: "district" },
          { label: "集安市", code: "220582", level: "district" }
        ],
        level: "city"
      },
      {
        label: "白山市",
        code: "220600",
        children: [
          { label: "浑江区", code: "220602", level: "district" },
          { label: "江源区", code: "220605", level: "district" },
          { label: "抚松县", code: "220621", level: "district" },
          { label: "靖宇县", code: "220622", level: "district" },
          { label: "长白朝鲜族自治县", code: "220623", level: "district" },
          { label: "临江市", code: "220681", level: "district" }
        ],
        level: "city"
      },
      {
        label: "松原市",
        code: "220700",
        children: [
          { label: "宁江区", code: "220702", level: "district" },
          {
            label: "前郭尔罗斯蒙古族自治县",
            code: "220721",
            level: "district"
          },
          { label: "长岭县", code: "220722", level: "district" },
          { label: "乾安县", code: "220723", level: "district" },
          { label: "吉林松原经济开发区", code: "220771", level: "district" },
          { label: "扶余市", code: "220781", level: "district" }
        ],
        level: "city"
      },
      {
        label: "白城市",
        code: "220800",
        children: [
          { label: "洮北区", code: "220802", level: "district" },
          { label: "镇赉县", code: "220821", level: "district" },
          { label: "通榆县", code: "220822", level: "district" },
          { label: "吉林白城经济开发区", code: "220871", level: "district" },
          { label: "洮南市", code: "220881", level: "district" },
          { label: "大安市", code: "220882", level: "district" }
        ],
        level: "city"
      },
      {
        label: "延边朝鲜族自治州",
        code: "222400",
        children: [
          { label: "延吉市", code: "222401", level: "district" },
          { label: "图们市", code: "222402", level: "district" },
          { label: "敦化市", code: "222403", level: "district" },
          { label: "珲春市", code: "222404", level: "district" },
          { label: "龙井市", code: "222405", level: "district" },
          { label: "和龙市", code: "222406", level: "district" },
          { label: "汪清县", code: "222424", level: "district" },
          { label: "安图县", code: "222426", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  },
  {
    label: "黑龙江省",
    code: "230000",
    children: [
      {
        label: "哈尔滨市",
        code: "230100",
        children: [
          { label: "道里区", code: "230102", level: "district" },
          { label: "南岗区", code: "230103", level: "district" },
          { label: "道外区", code: "230104", level: "district" },
          { label: "平房区", code: "230108", level: "district" },
          { label: "松北区", code: "230109", level: "district" },
          { label: "香坊区", code: "230110", level: "district" },
          { label: "呼兰区", code: "230111", level: "district" },
          { label: "阿城区", code: "230112", level: "district" },
          { label: "双城区", code: "230113", level: "district" },
          { label: "依兰县", code: "230123", level: "district" },
          { label: "方正县", code: "230124", level: "district" },
          { label: "宾县", code: "230125", level: "district" },
          { label: "巴彦县", code: "230126", level: "district" },
          { label: "木兰县", code: "230127", level: "district" },
          { label: "通河县", code: "230128", level: "district" },
          { label: "延寿县", code: "230129", level: "district" },
          { label: "尚志市", code: "230183", level: "district" },
          { label: "五常市", code: "230184", level: "district" }
        ],
        level: "city"
      },
      {
        label: "齐齐哈尔市",
        code: "230200",
        children: [
          { label: "龙沙区", code: "230202", level: "district" },
          { label: "建华区", code: "230203", level: "district" },
          { label: "铁锋区", code: "230204", level: "district" },
          { label: "昂昂溪区", code: "230205", level: "district" },
          { label: "富拉尔基区", code: "230206", level: "district" },
          { label: "碾子山区", code: "230207", level: "district" },
          { label: "梅里斯达斡尔族区", code: "230208", level: "district" },
          { label: "龙江县", code: "230221", level: "district" },
          { label: "依安县", code: "230223", level: "district" },
          { label: "泰来县", code: "230224", level: "district" },
          { label: "甘南县", code: "230225", level: "district" },
          { label: "富裕县", code: "230227", level: "district" },
          { label: "克山县", code: "230229", level: "district" },
          { label: "克东县", code: "230230", level: "district" },
          { label: "拜泉县", code: "230231", level: "district" },
          { label: "讷河市", code: "230281", level: "district" }
        ],
        level: "city"
      },
      {
        label: "鸡西市",
        code: "230300",
        children: [
          { label: "鸡冠区", code: "230302", level: "district" },
          { label: "恒山区", code: "230303", level: "district" },
          { label: "滴道区", code: "230304", level: "district" },
          { label: "梨树区", code: "230305", level: "district" },
          { label: "城子河区", code: "230306", level: "district" },
          { label: "麻山区", code: "230307", level: "district" },
          { label: "鸡东县", code: "230321", level: "district" },
          { label: "虎林市", code: "230381", level: "district" },
          { label: "密山市", code: "230382", level: "district" }
        ],
        level: "city"
      },
      {
        label: "鹤岗市",
        code: "230400",
        children: [
          { label: "向阳区", code: "230402", level: "district" },
          { label: "工农区", code: "230403", level: "district" },
          { label: "南山区", code: "230404", level: "district" },
          { label: "兴安区", code: "230405", level: "district" },
          { label: "东山区", code: "230406", level: "district" },
          { label: "兴山区", code: "230407", level: "district" },
          { label: "萝北县", code: "230421", level: "district" },
          { label: "绥滨县", code: "230422", level: "district" }
        ],
        level: "city"
      },
      {
        label: "双鸭山市",
        code: "230500",
        children: [
          { label: "尖山区", code: "230502", level: "district" },
          { label: "岭东区", code: "230503", level: "district" },
          { label: "四方台区", code: "230505", level: "district" },
          { label: "宝山区", code: "230506", level: "district" },
          { label: "集贤县", code: "230521", level: "district" },
          { label: "友谊县", code: "230522", level: "district" },
          { label: "宝清县", code: "230523", level: "district" },
          { label: "饶河县", code: "230524", level: "district" }
        ],
        level: "city"
      },
      {
        label: "大庆市",
        code: "230600",
        children: [
          { label: "萨尔图区", code: "230602", level: "district" },
          { label: "龙凤区", code: "230603", level: "district" },
          { label: "让胡路区", code: "230604", level: "district" },
          { label: "红岗区", code: "230605", level: "district" },
          { label: "大同区", code: "230606", level: "district" },
          { label: "肇州县", code: "230621", level: "district" },
          { label: "肇源县", code: "230622", level: "district" },
          { label: "林甸县", code: "230623", level: "district" },
          { label: "杜尔伯特蒙古族自治县", code: "230624", level: "district" },
          {
            label: "大庆高新技术产业开发区",
            code: "230671",
            level: "district"
          }
        ],
        level: "city"
      },
      {
        label: "伊春市",
        code: "230700",
        children: [
          { label: "伊美区", code: "230717", level: "district" },
          { label: "乌翠区", code: "230718", level: "district" },
          { label: "友好区", code: "230719", level: "district" },
          { label: "嘉荫县", code: "230722", level: "district" },
          { label: "汤旺县", code: "230723", level: "district" },
          { label: "丰林县", code: "230724", level: "district" },
          { label: "大箐山县", code: "230725", level: "district" },
          { label: "南岔县", code: "230726", level: "district" },
          { label: "金林区", code: "230751", level: "district" },
          { label: "铁力市", code: "230781", level: "district" }
        ],
        level: "city"
      },
      {
        label: "佳木斯市",
        code: "230800",
        children: [
          { label: "向阳区", code: "230803", level: "district" },
          { label: "前进区", code: "230804", level: "district" },
          { label: "东风区", code: "230805", level: "district" },
          { label: "郊区", code: "230811", level: "district" },
          { label: "桦南县", code: "230822", level: "district" },
          { label: "桦川县", code: "230826", level: "district" },
          { label: "汤原县", code: "230828", level: "district" },
          { label: "同江市", code: "230881", level: "district" },
          { label: "富锦市", code: "230882", level: "district" },
          { label: "抚远市", code: "230883", level: "district" }
        ],
        level: "city"
      },
      {
        label: "七台河市",
        code: "230900",
        children: [
          { label: "新兴区", code: "230902", level: "district" },
          { label: "桃山区", code: "230903", level: "district" },
          { label: "茄子河区", code: "230904", level: "district" },
          { label: "勃利县", code: "230921", level: "district" }
        ],
        level: "city"
      },
      {
        label: "牡丹江市",
        code: "231000",
        children: [
          { label: "东安区", code: "231002", level: "district" },
          { label: "阳明区", code: "231003", level: "district" },
          { label: "爱民区", code: "231004", level: "district" },
          { label: "西安区", code: "231005", level: "district" },
          { label: "林口县", code: "231025", level: "district" },
          { label: "绥芬河市", code: "231081", level: "district" },
          { label: "海林市", code: "231083", level: "district" },
          { label: "宁安市", code: "231084", level: "district" },
          { label: "穆棱市", code: "231085", level: "district" },
          { label: "东宁市", code: "231086", level: "district" }
        ],
        level: "city"
      },
      {
        label: "黑河市",
        code: "231100",
        children: [
          { label: "爱辉区", code: "231102", level: "district" },
          { label: "逊克县", code: "231123", level: "district" },
          { label: "孙吴县", code: "231124", level: "district" },
          { label: "北安市", code: "231181", level: "district" },
          { label: "五大连池市", code: "231182", level: "district" },
          { label: "嫩江市", code: "231183", level: "district" }
        ],
        level: "city"
      },
      {
        label: "绥化市",
        code: "231200",
        children: [
          { label: "北林区", code: "231202", level: "district" },
          { label: "望奎县", code: "231221", level: "district" },
          { label: "兰西县", code: "231222", level: "district" },
          { label: "青冈县", code: "231223", level: "district" },
          { label: "庆安县", code: "231224", level: "district" },
          { label: "明水县", code: "231225", level: "district" },
          { label: "绥棱县", code: "231226", level: "district" },
          { label: "安达市", code: "231281", level: "district" },
          { label: "肇东市", code: "231282", level: "district" },
          { label: "海伦市", code: "231283", level: "district" }
        ],
        level: "city"
      },
      {
        label: "大兴安岭地区",
        code: "232700",
        children: [
          { label: "漠河市", code: "232701", level: "district" },
          { label: "呼玛县", code: "232721", level: "district" },
          { label: "塔河县", code: "232722", level: "district" },
          { label: "加格达奇区", code: "232761", level: "district" },
          { label: "松岭区", code: "232762", level: "district" },
          { label: "新林区", code: "232763", level: "district" },
          { label: "呼中区", code: "232764", level: "district" }
        ],
        level: "city"
      }
    ],
    level: "province"
  }
];



// WEBPACK FOOTER //
// ./src/config/region_cofig.js